const TaiZi_3=[
    {
        "Name": "1",
        "Length": 207008127
    },
    {
        "Name": "2",
        "Length": 113468866
    },
    {
        "Name": "3",
        "Length": 104033818
    },
    {
        "Name": "4",
        "Length": 87566864
    },
    {
        "Name": "5",
        "Length": 83274351
    },
    {
        "Name": "6",
        "Length": 67906199
    },
    {
        "Name": "7",
        "Length": 60749257
    },
    {
        "Name": "8",
        "Length": 58756596
    },
    {
        "Name": "KN708708",
        "Length": 33207
    },
    {
        "Name": "KN708743",
        "Length": 274584
    },
    {
        "Name": "KN708744",
        "Length": 5128
    },
    {
        "Name": "KN708746",
        "Length": 20017
    },
    {
        "Name": "KN708754",
        "Length": 6810
    },
    {
        "Name": "KN708829",
        "Length": 768
    },
    {
        "Name": "KN708897",
        "Length": 276688
    },
    {
        "Name": "KN708938",
        "Length": 23420
    },
    {
        "Name": "KN708943",
        "Length": 19819
    },
    {
        "Name": "KN708945",
        "Length": 73705
    },
    {
        "Name": "KN708982",
        "Length": 14032
    },
    {
        "Name": "KN709044",
        "Length": 10683
    },
    {
        "Name": "KN709089",
        "Length": 3592
    },
    {
        "Name": "KN709178",
        "Length": 8020
    },
    {
        "Name": "KN709296",
        "Length": 7524
    },
    {
        "Name": "KN709306",
        "Length": 23668
    },
    {
        "Name": "KN709313",
        "Length": 19545
    },
    {
        "Name": "KN709329",
        "Length": 754
    },
    {
        "Name": "KN709342",
        "Length": 36085
    },
    {
        "Name": "KN709352",
        "Length": 22132
    },
    {
        "Name": "KN709388",
        "Length": 67896
    },
    {
        "Name": "KN709402",
        "Length": 7368
    },
    {
        "Name": "KN709408",
        "Length": 5776
    },
    {
        "Name": "KN709453",
        "Length": 4356
    },
    {
        "Name": "KN709475",
        "Length": 706
    },
    {
        "Name": "KN709494",
        "Length": 23983
    },
    {
        "Name": "KN709505",
        "Length": 219838
    },
    {
        "Name": "KN709525",
        "Length": 10021
    },
    {
        "Name": "KN709564",
        "Length": 1043
    },
    {
        "Name": "KN709568",
        "Length": 524
    },
    {
        "Name": "KN709576",
        "Length": 40798
    },
    {
        "Name": "KN709591",
        "Length": 17299
    },
    {
        "Name": "KN709607",
        "Length": 940
    },
    {
        "Name": "KN709614",
        "Length": 1158
    },
    {
        "Name": "KN709632",
        "Length": 75985
    },
    {
        "Name": "KN709635",
        "Length": 8769
    },
    {
        "Name": "KN709665",
        "Length": 6390
    },
    {
        "Name": "KN709668",
        "Length": 1546
    },
    {
        "Name": "KN709674",
        "Length": 6427
    },
    {
        "Name": "KN709679",
        "Length": 9149
    },
    {
        "Name": "KN709689",
        "Length": 1414
    },
    {
        "Name": "KN709708",
        "Length": 9311
    },
    {
        "Name": "KN709729",
        "Length": 582
    },
    {
        "Name": "KN709730",
        "Length": 3821
    },
    {
        "Name": "KN709733",
        "Length": 45764
    },
    {
        "Name": "KN709738",
        "Length": 62357
    },
    {
        "Name": "KN709743",
        "Length": 894
    },
    {
        "Name": "KN709752",
        "Length": 1735
    },
    {
        "Name": "KN709753",
        "Length": 64080
    },
    {
        "Name": "KN709769",
        "Length": 4593
    },
    {
        "Name": "KN709777",
        "Length": 16737
    },
    {
        "Name": "KN709792",
        "Length": 49728
    },
    {
        "Name": "KN709793",
        "Length": 68717
    },
    {
        "Name": "KN709797",
        "Length": 1312
    },
    {
        "Name": "KN709809",
        "Length": 784
    },
    {
        "Name": "KN709811",
        "Length": 5521
    },
    {
        "Name": "KN709821",
        "Length": 9588
    },
    {
        "Name": "KN709823",
        "Length": 38044
    },
    {
        "Name": "KN709857",
        "Length": 6962
    },
    {
        "Name": "KN709863",
        "Length": 1802
    },
    {
        "Name": "KN709878",
        "Length": 27340
    },
    {
        "Name": "KN709879",
        "Length": 16768
    },
    {
        "Name": "KN709882",
        "Length": 6405
    },
    {
        "Name": "KN709884",
        "Length": 3707
    },
    {
        "Name": "KN709885",
        "Length": 5329
    },
    {
        "Name": "KN709887",
        "Length": 24815
    },
    {
        "Name": "KN709891",
        "Length": 64559
    },
    {
        "Name": "KN709910",
        "Length": 698
    },
    {
        "Name": "KN709911",
        "Length": 756
    },
    {
        "Name": "KN709917",
        "Length": 9246
    },
    {
        "Name": "KN709949",
        "Length": 2101
    },
    {
        "Name": "KN709950",
        "Length": 9599
    },
    {
        "Name": "KN709953",
        "Length": 85433
    },
    {
        "Name": "KN709964",
        "Length": 2387
    },
    {
        "Name": "KN709968",
        "Length": 12138
    },
    {
        "Name": "KN709992",
        "Length": 32382
    },
    {
        "Name": "KN709994",
        "Length": 1497
    },
    {
        "Name": "KN709998",
        "Length": 9597
    },
    {
        "Name": "KN710013",
        "Length": 6603
    },
    {
        "Name": "KN710025",
        "Length": 5848
    },
    {
        "Name": "KN710032",
        "Length": 5885
    },
    {
        "Name": "KN710040",
        "Length": 6861
    },
    {
        "Name": "KN710050",
        "Length": 864
    },
    {
        "Name": "KN710054",
        "Length": 14188
    },
    {
        "Name": "KN710056",
        "Length": 1185
    },
    {
        "Name": "KN710059",
        "Length": 67714
    },
    {
        "Name": "KN710062",
        "Length": 20069
    },
    {
        "Name": "KN710068",
        "Length": 5086
    },
    {
        "Name": "KN710070",
        "Length": 701
    },
    {
        "Name": "KN710074",
        "Length": 15538
    },
    {
        "Name": "KN710082",
        "Length": 19384
    },
    {
        "Name": "KN710083",
        "Length": 658
    },
    {
        "Name": "KN710089",
        "Length": 36455
    },
    {
        "Name": "KN710099",
        "Length": 10423
    },
    {
        "Name": "KN710103",
        "Length": 5133
    },
    {
        "Name": "KN710104",
        "Length": 76893
    },
    {
        "Name": "KN710110",
        "Length": 31813
    },
    {
        "Name": "KN710115",
        "Length": 870
    },
    {
        "Name": "KN710120",
        "Length": 16779
    },
    {
        "Name": "KN710128",
        "Length": 19167
    },
    {
        "Name": "KN710131",
        "Length": 10556
    },
    {
        "Name": "KN710139",
        "Length": 25407
    },
    {
        "Name": "KN710140",
        "Length": 194417
    },
    {
        "Name": "KN710144",
        "Length": 1232
    },
    {
        "Name": "KN710149",
        "Length": 47407
    },
    {
        "Name": "KN710156",
        "Length": 14766
    },
    {
        "Name": "KN710158",
        "Length": 34015
    },
    {
        "Name": "KN710159",
        "Length": 1889
    },
    {
        "Name": "KN710163",
        "Length": 13941
    },
    {
        "Name": "KN710176",
        "Length": 605
    },
    {
        "Name": "KN710182",
        "Length": 10851
    },
    {
        "Name": "KN710183",
        "Length": 94069
    },
    {
        "Name": "KN710205",
        "Length": 5403
    },
    {
        "Name": "KN710208",
        "Length": 31903
    },
    {
        "Name": "KN710211",
        "Length": 7612
    },
    {
        "Name": "KN710219",
        "Length": 1424
    },
    {
        "Name": "KN710220",
        "Length": 19428
    },
    {
        "Name": "KN710222",
        "Length": 2932
    },
    {
        "Name": "KN710223",
        "Length": 730
    },
    {
        "Name": "KN710227",
        "Length": 23775
    },
    {
        "Name": "KN710228",
        "Length": 3097
    },
    {
        "Name": "KN710236",
        "Length": 9536
    },
    {
        "Name": "KN710237",
        "Length": 5638
    },
    {
        "Name": "KN710238",
        "Length": 2874
    },
    {
        "Name": "KN710239",
        "Length": 754
    },
    {
        "Name": "KN710241",
        "Length": 2214
    },
    {
        "Name": "KN710249",
        "Length": 1165
    },
    {
        "Name": "KN710251",
        "Length": 5759
    },
    {
        "Name": "KN710252",
        "Length": 16843
    },
    {
        "Name": "KN710253",
        "Length": 3607
    },
    {
        "Name": "KN710259",
        "Length": 24624
    },
    {
        "Name": "KN710260",
        "Length": 19399
    },
    {
        "Name": "KN710263",
        "Length": 776
    },
    {
        "Name": "KN710264",
        "Length": 59211
    },
    {
        "Name": "KN710265",
        "Length": 16967
    },
    {
        "Name": "KN710266",
        "Length": 4500
    },
    {
        "Name": "KN710270",
        "Length": 951
    },
    {
        "Name": "KN710274",
        "Length": 16515
    },
    {
        "Name": "KN710276",
        "Length": 15182
    },
    {
        "Name": "KN710277",
        "Length": 16894
    },
    {
        "Name": "KN710279",
        "Length": 26359
    },
    {
        "Name": "KN710282",
        "Length": 34246
    },
    {
        "Name": "KN710283",
        "Length": 22984
    },
    {
        "Name": "KN710284",
        "Length": 2345
    },
    {
        "Name": "KN710285",
        "Length": 12257
    },
    {
        "Name": "KN710286",
        "Length": 1103
    },
    {
        "Name": "KN710288",
        "Length": 1783
    },
    {
        "Name": "KN710291",
        "Length": 755
    },
    {
        "Name": "KN710294",
        "Length": 11309
    },
    {
        "Name": "KN710295",
        "Length": 855
    },
    {
        "Name": "KN710296",
        "Length": 7805
    },
    {
        "Name": "KN710297",
        "Length": 7417
    },
    {
        "Name": "KN710298",
        "Length": 17408
    },
    {
        "Name": "KN710299",
        "Length": 1426
    },
    {
        "Name": "KN710301",
        "Length": 26292
    },
    {
        "Name": "KN710304",
        "Length": 528
    },
    {
        "Name": "KN710307",
        "Length": 833
    },
    {
        "Name": "KN710317",
        "Length": 9912
    },
    {
        "Name": "KN710320",
        "Length": 2494
    },
    {
        "Name": "KN710322",
        "Length": 2645
    },
    {
        "Name": "KN710324",
        "Length": 16167
    },
    {
        "Name": "KN710326",
        "Length": 6683
    },
    {
        "Name": "KN710327",
        "Length": 2448
    },
    {
        "Name": "KN710331",
        "Length": 6376
    },
    {
        "Name": "KN710342",
        "Length": 2211
    },
    {
        "Name": "KN710344",
        "Length": 699
    },
    {
        "Name": "KN710345",
        "Length": 532
    },
    {
        "Name": "KN710347",
        "Length": 12043
    },
    {
        "Name": "KN710349",
        "Length": 3438
    },
    {
        "Name": "KN710355",
        "Length": 3437
    },
    {
        "Name": "KN710356",
        "Length": 2598
    },
    {
        "Name": "KN710359",
        "Length": 31396
    },
    {
        "Name": "KN710361",
        "Length": 10405
    },
    {
        "Name": "KN710365",
        "Length": 3606
    },
    {
        "Name": "KN710366",
        "Length": 778
    },
    {
        "Name": "KN710367",
        "Length": 3393
    },
    {
        "Name": "KN710370",
        "Length": 1437
    },
    {
        "Name": "KN710375",
        "Length": 9372
    },
    {
        "Name": "KN710378",
        "Length": 73853
    },
    {
        "Name": "KN710381",
        "Length": 39602
    },
    {
        "Name": "KN710387",
        "Length": 17451
    },
    {
        "Name": "KN710388",
        "Length": 541
    },
    {
        "Name": "KN710390",
        "Length": 2521
    },
    {
        "Name": "KN710391",
        "Length": 1348
    },
    {
        "Name": "KN710392",
        "Length": 705
    },
    {
        "Name": "KN710393",
        "Length": 793
    },
    {
        "Name": "KN710394",
        "Length": 32884
    },
    {
        "Name": "KN710395",
        "Length": 557
    },
    {
        "Name": "KN710400",
        "Length": 522
    },
    {
        "Name": "KN710402",
        "Length": 2503
    },
    {
        "Name": "KN710404",
        "Length": 2418
    },
    {
        "Name": "KN710407",
        "Length": 4830
    },
    {
        "Name": "KN710408",
        "Length": 4878
    },
    {
        "Name": "KN710417",
        "Length": 42834
    },
    {
        "Name": "KN710418",
        "Length": 7337
    },
    {
        "Name": "KN710425",
        "Length": 790
    },
    {
        "Name": "KN710427",
        "Length": 39607
    },
    {
        "Name": "KN710428",
        "Length": 8595
    },
    {
        "Name": "KN710429",
        "Length": 7251
    },
    {
        "Name": "KN710432",
        "Length": 725
    },
    {
        "Name": "KN710433",
        "Length": 3275
    },
    {
        "Name": "KN710434",
        "Length": 843
    },
    {
        "Name": "KN710437",
        "Length": 5414
    },
    {
        "Name": "KN710438",
        "Length": 7727
    },
    {
        "Name": "KN710440",
        "Length": 8547
    },
    {
        "Name": "KN710441",
        "Length": 2809
    },
    {
        "Name": "KN710442",
        "Length": 2105
    },
    {
        "Name": "KN710443",
        "Length": 499
    },
    {
        "Name": "KN710444",
        "Length": 1332
    },
    {
        "Name": "KN710448",
        "Length": 2390
    },
    {
        "Name": "KN710449",
        "Length": 100284
    },
    {
        "Name": "KN710451",
        "Length": 9039
    },
    {
        "Name": "KN710452",
        "Length": 6356
    },
    {
        "Name": "KN710453",
        "Length": 1066
    },
    {
        "Name": "KN710455",
        "Length": 3314
    },
    {
        "Name": "KN710456",
        "Length": 4617
    },
    {
        "Name": "KN710457",
        "Length": 1150
    },
    {
        "Name": "KN710458",
        "Length": 10177
    },
    {
        "Name": "KN710459",
        "Length": 6211
    },
    {
        "Name": "KN710460",
        "Length": 497
    },
    {
        "Name": "KN710461",
        "Length": 37858
    },
    {
        "Name": "KN710467",
        "Length": 713
    },
    {
        "Name": "KN710469",
        "Length": 501
    },
    {
        "Name": "KN710472",
        "Length": 3113
    },
    {
        "Name": "KN710473",
        "Length": 2798
    },
    {
        "Name": "KN710476",
        "Length": 490
    },
    {
        "Name": "KN710480",
        "Length": 9843
    },
    {
        "Name": "KN710481",
        "Length": 6955
    },
    {
        "Name": "KN710482",
        "Length": 9994
    },
    {
        "Name": "KN710483",
        "Length": 7095
    },
    {
        "Name": "KN710484",
        "Length": 11884
    },
    {
        "Name": "KN710485",
        "Length": 8030
    },
    {
        "Name": "KN710486",
        "Length": 19097
    },
    {
        "Name": "KN710487",
        "Length": 2292
    },
    {
        "Name": "KN710488",
        "Length": 935
    },
    {
        "Name": "KN710489",
        "Length": 3305
    },
    {
        "Name": "KN710491",
        "Length": 795
    },
    {
        "Name": "KN710493",
        "Length": 6415
    },
    {
        "Name": "KN710494",
        "Length": 2034
    },
    {
        "Name": "KN710495",
        "Length": 1149
    },
    {
        "Name": "KN710496",
        "Length": 2075
    },
    {
        "Name": "KN710498",
        "Length": 6528
    },
    {
        "Name": "KN710499",
        "Length": 3481
    },
    {
        "Name": "KN710503",
        "Length": 1924
    },
    {
        "Name": "KN710504",
        "Length": 20908
    },
    {
        "Name": "KN710506",
        "Length": 15402
    },
    {
        "Name": "KN710507",
        "Length": 1557
    },
    {
        "Name": "KN710513",
        "Length": 4586
    },
    {
        "Name": "KN710514",
        "Length": 673
    },
    {
        "Name": "KN710515",
        "Length": 27772
    },
    {
        "Name": "KN710517",
        "Length": 2709
    },
    {
        "Name": "KN710521",
        "Length": 752
    },
    {
        "Name": "KN710522",
        "Length": 883
    },
    {
        "Name": "KN710523",
        "Length": 3119
    },
    {
        "Name": "KN710524",
        "Length": 3118
    },
    {
        "Name": "KN710526",
        "Length": 2610
    },
    {
        "Name": "KN710529",
        "Length": 760
    },
    {
        "Name": "KN710531",
        "Length": 4068
    },
    {
        "Name": "KN710533",
        "Length": 932
    },
    {
        "Name": "KN710534",
        "Length": 18367
    },
    {
        "Name": "KN710536",
        "Length": 6400
    },
    {
        "Name": "KN710537",
        "Length": 3806
    },
    {
        "Name": "KN710538",
        "Length": 15582
    },
    {
        "Name": "KN710539",
        "Length": 761
    },
    {
        "Name": "KN710541",
        "Length": 3373
    },
    {
        "Name": "KN710542",
        "Length": 14277
    },
    {
        "Name": "KN710543",
        "Length": 891
    },
    {
        "Name": "KN710546",
        "Length": 1217
    },
    {
        "Name": "KN710549",
        "Length": 55123
    },
    {
        "Name": "KN710552",
        "Length": 806
    },
    {
        "Name": "KN710553",
        "Length": 695
    },
    {
        "Name": "KN710556",
        "Length": 579
    },
    {
        "Name": "KN710558",
        "Length": 26738
    },
    {
        "Name": "KN710561",
        "Length": 8166
    },
    {
        "Name": "KN710563",
        "Length": 1760
    },
    {
        "Name": "KN710571",
        "Length": 1478
    },
    {
        "Name": "KN710573",
        "Length": 13982
    },
    {
        "Name": "KN710574",
        "Length": 824
    },
    {
        "Name": "KN710576",
        "Length": 18958
    },
    {
        "Name": "KN710581",
        "Length": 10692
    },
    {
        "Name": "KN710582",
        "Length": 1302
    },
    {
        "Name": "KN710584",
        "Length": 1204
    },
    {
        "Name": "KN710585",
        "Length": 835
    },
    {
        "Name": "KN710587",
        "Length": 2298
    },
    {
        "Name": "KN710590",
        "Length": 196289
    },
    {
        "Name": "KN710591",
        "Length": 21737
    },
    {
        "Name": "KN710592",
        "Length": 29832
    },
    {
        "Name": "KN710593",
        "Length": 777
    },
    {
        "Name": "KN710594",
        "Length": 10151
    },
    {
        "Name": "KN710595",
        "Length": 2197
    },
    {
        "Name": "KN710596",
        "Length": 706
    },
    {
        "Name": "KN710597",
        "Length": 757
    },
    {
        "Name": "KN710600",
        "Length": 1172
    },
    {
        "Name": "KN710601",
        "Length": 8552
    },
    {
        "Name": "KN710602",
        "Length": 846
    },
    {
        "Name": "KN710603",
        "Length": 13935
    },
    {
        "Name": "KN710604",
        "Length": 766
    },
    {
        "Name": "KN710606",
        "Length": 2530
    },
    {
        "Name": "KN710607",
        "Length": 10449
    },
    {
        "Name": "KN710609",
        "Length": 1363
    },
    {
        "Name": "KN710610",
        "Length": 716
    },
    {
        "Name": "KN710611",
        "Length": 2174
    },
    {
        "Name": "KN710612",
        "Length": 4312
    },
    {
        "Name": "KN710614",
        "Length": 13529
    },
    {
        "Name": "KN710615",
        "Length": 10753
    },
    {
        "Name": "KN710616",
        "Length": 6076
    },
    {
        "Name": "KN710618",
        "Length": 1843
    },
    {
        "Name": "KN710619",
        "Length": 2427
    },
    {
        "Name": "KN710620",
        "Length": 720
    },
    {
        "Name": "KN710623",
        "Length": 748
    },
    {
        "Name": "KN710624",
        "Length": 944
    },
    {
        "Name": "KN710625",
        "Length": 29488
    },
    {
        "Name": "KN710627",
        "Length": 710
    },
    {
        "Name": "KN710630",
        "Length": 803
    },
    {
        "Name": "KN710631",
        "Length": 772
    },
    {
        "Name": "KN710634",
        "Length": 4795
    },
    {
        "Name": "KN710635",
        "Length": 1140
    },
    {
        "Name": "KN710636",
        "Length": 1342
    },
    {
        "Name": "KN710638",
        "Length": 763
    },
    {
        "Name": "KN710639",
        "Length": 739
    },
    {
        "Name": "KN710641",
        "Length": 10529
    },
    {
        "Name": "KN710642",
        "Length": 19533
    },
    {
        "Name": "KN710643",
        "Length": 754
    },
    {
        "Name": "KN710644",
        "Length": 607
    },
    {
        "Name": "KN710645",
        "Length": 1515
    },
    {
        "Name": "KN710646",
        "Length": 5204
    },
    {
        "Name": "KN710647",
        "Length": 10162
    },
    {
        "Name": "KN710648",
        "Length": 918
    },
    {
        "Name": "KN710649",
        "Length": 7288
    },
    {
        "Name": "KN710650",
        "Length": 1405
    },
    {
        "Name": "KN710652",
        "Length": 601
    },
    {
        "Name": "KN710654",
        "Length": 499
    },
    {
        "Name": "KN710659",
        "Length": 5754
    },
    {
        "Name": "KN710660",
        "Length": 1724
    },
    {
        "Name": "KN710661",
        "Length": 7198
    },
    {
        "Name": "KN710662",
        "Length": 2405
    },
    {
        "Name": "KN710663",
        "Length": 831
    },
    {
        "Name": "KN710664",
        "Length": 12135
    },
    {
        "Name": "KN710665",
        "Length": 522
    },
    {
        "Name": "KN710666",
        "Length": 6221
    },
    {
        "Name": "KN710669",
        "Length": 8922
    },
    {
        "Name": "KN710670",
        "Length": 2745
    },
    {
        "Name": "KN710671",
        "Length": 3314
    },
    {
        "Name": "KN710672",
        "Length": 840
    },
    {
        "Name": "KN710673",
        "Length": 3225
    },
    {
        "Name": "KN710674",
        "Length": 27632
    },
    {
        "Name": "KN710676",
        "Length": 1445
    },
    {
        "Name": "KN710678",
        "Length": 745
    },
    {
        "Name": "KN710680",
        "Length": 1362
    },
    {
        "Name": "KN710681",
        "Length": 971
    },
    {
        "Name": "KN710682",
        "Length": 2820
    },
    {
        "Name": "KN710685",
        "Length": 767
    },
    {
        "Name": "KN710686",
        "Length": 522
    },
    {
        "Name": "KN710689",
        "Length": 10407
    },
    {
        "Name": "KN710690",
        "Length": 452
    },
    {
        "Name": "KN710691",
        "Length": 2392
    },
    {
        "Name": "KN710692",
        "Length": 984
    },
    {
        "Name": "KN710694",
        "Length": 11725
    },
    {
        "Name": "KN710695",
        "Length": 961
    },
    {
        "Name": "KN710696",
        "Length": 14976
    },
    {
        "Name": "KN710697",
        "Length": 781
    },
    {
        "Name": "KN710698",
        "Length": 533
    },
    {
        "Name": "KN710700",
        "Length": 5613
    },
    {
        "Name": "KN710701",
        "Length": 740
    },
    {
        "Name": "KN710702",
        "Length": 5150
    },
    {
        "Name": "KN710703",
        "Length": 2230
    },
    {
        "Name": "KN710704",
        "Length": 760
    },
    {
        "Name": "KN710708",
        "Length": 826
    },
    {
        "Name": "KN710710",
        "Length": 2327
    },
    {
        "Name": "KN710711",
        "Length": 8994
    },
    {
        "Name": "KN710712",
        "Length": 2586
    },
    {
        "Name": "KN710713",
        "Length": 719
    },
    {
        "Name": "KN710717",
        "Length": 1004
    },
    {
        "Name": "KN710719",
        "Length": 3291
    },
    {
        "Name": "KN710720",
        "Length": 2518
    },
    {
        "Name": "KN710721",
        "Length": 1845
    },
    {
        "Name": "KN710722",
        "Length": 733
    },
    {
        "Name": "KN710723",
        "Length": 8892
    },
    {
        "Name": "KN710725",
        "Length": 2725
    },
    {
        "Name": "KN710727",
        "Length": 1759
    },
    {
        "Name": "KN710728",
        "Length": 11785
    },
    {
        "Name": "KN710729",
        "Length": 725
    },
    {
        "Name": "KN710730",
        "Length": 712
    },
    {
        "Name": "KN710731",
        "Length": 534
    },
    {
        "Name": "KN710733",
        "Length": 735
    },
    {
        "Name": "KN710734",
        "Length": 806
    },
    {
        "Name": "KN710735",
        "Length": 805
    },
    {
        "Name": "KN710736",
        "Length": 702
    },
    {
        "Name": "KN710737",
        "Length": 764
    },
    {
        "Name": "KN710739",
        "Length": 421
    },
    {
        "Name": "KN710742",
        "Length": 619
    },
    {
        "Name": "KN710744",
        "Length": 1361
    },
    {
        "Name": "KN710745",
        "Length": 693
    },
    {
        "Name": "KN710746",
        "Length": 20073
    },
    {
        "Name": "KN710747",
        "Length": 2138
    },
    {
        "Name": "KN710748",
        "Length": 1158
    },
    {
        "Name": "KN710750",
        "Length": 2720
    },
    {
        "Name": "KN710751",
        "Length": 2195
    },
    {
        "Name": "KN710753",
        "Length": 12603
    },
    {
        "Name": "KN710754",
        "Length": 692
    },
    {
        "Name": "KN710755",
        "Length": 1370
    },
    {
        "Name": "KN710756",
        "Length": 696
    },
    {
        "Name": "KN710757",
        "Length": 3512
    },
    {
        "Name": "KN710759",
        "Length": 700
    },
    {
        "Name": "KN710761",
        "Length": 470
    },
    {
        "Name": "KN710762",
        "Length": 5311
    },
    {
        "Name": "KN710763",
        "Length": 480
    },
    {
        "Name": "KN710765",
        "Length": 865
    },
    {
        "Name": "KN710766",
        "Length": 2383
    },
    {
        "Name": "KN710767",
        "Length": 1193
    },
    {
        "Name": "KN710768",
        "Length": 2750
    },
    {
        "Name": "KN710769",
        "Length": 742
    },
    {
        "Name": "KN710770",
        "Length": 563
    },
    {
        "Name": "KN710771",
        "Length": 797
    },
    {
        "Name": "KN710772",
        "Length": 3237
    },
    {
        "Name": "KN710774",
        "Length": 9916
    },
    {
        "Name": "KN710777",
        "Length": 8252
    },
    {
        "Name": "KN710778",
        "Length": 558
    },
    {
        "Name": "KN710779",
        "Length": 1232
    },
    {
        "Name": "KN710780",
        "Length": 14179
    },
    {
        "Name": "KN710781",
        "Length": 2538
    },
    {
        "Name": "KN710782",
        "Length": 1737
    },
    {
        "Name": "KN710783",
        "Length": 501
    },
    {
        "Name": "KN710784",
        "Length": 2550
    },
    {
        "Name": "KN710786",
        "Length": 740
    },
    {
        "Name": "KN710787",
        "Length": 567
    },
    {
        "Name": "KN710789",
        "Length": 2656
    },
    {
        "Name": "KN710790",
        "Length": 738
    },
    {
        "Name": "KN710791",
        "Length": 1211
    },
    {
        "Name": "KN710792",
        "Length": 855
    },
    {
        "Name": "KN710793",
        "Length": 1464
    },
    {
        "Name": "KN710795",
        "Length": 3034
    },
    {
        "Name": "KN710796",
        "Length": 505
    },
    {
        "Name": "KN710797",
        "Length": 981
    },
    {
        "Name": "KN710801",
        "Length": 1356
    },
    {
        "Name": "KN710802",
        "Length": 13437
    },
    {
        "Name": "KN710804",
        "Length": 1456
    },
    {
        "Name": "KN710805",
        "Length": 2249
    },
    {
        "Name": "KN710806",
        "Length": 610
    },
    {
        "Name": "KN710807",
        "Length": 6642
    },
    {
        "Name": "KN710808",
        "Length": 3115
    },
    {
        "Name": "KN710810",
        "Length": 1009
    },
    {
        "Name": "KN710811",
        "Length": 5485
    },
    {
        "Name": "KN710812",
        "Length": 969
    },
    {
        "Name": "KN710813",
        "Length": 939
    },
    {
        "Name": "KN710814",
        "Length": 765
    },
    {
        "Name": "KN710815",
        "Length": 691
    },
    {
        "Name": "KN710816",
        "Length": 970
    },
    {
        "Name": "KN710817",
        "Length": 612
    },
    {
        "Name": "KN710818",
        "Length": 2298
    },
    {
        "Name": "KN710821",
        "Length": 741
    },
    {
        "Name": "KN710822",
        "Length": 760
    },
    {
        "Name": "KN710823",
        "Length": 1277
    },
    {
        "Name": "KN710824",
        "Length": 2270
    },
    {
        "Name": "KN710827",
        "Length": 1608
    },
    {
        "Name": "KN710828",
        "Length": 567
    },
    {
        "Name": "KN710829",
        "Length": 1369
    },
    {
        "Name": "KN710830",
        "Length": 727
    },
    {
        "Name": "KN710831",
        "Length": 814
    },
    {
        "Name": "KN710832",
        "Length": 872
    },
    {
        "Name": "KN710834",
        "Length": 774
    },
    {
        "Name": "KN710836",
        "Length": 2407
    },
    {
        "Name": "KN710838",
        "Length": 27248
    },
    {
        "Name": "KN710839",
        "Length": 751
    },
    {
        "Name": "KN710840",
        "Length": 722
    },
    {
        "Name": "KN710841",
        "Length": 18335
    },
    {
        "Name": "KN710843",
        "Length": 1370
    },
    {
        "Name": "KN710844",
        "Length": 1371
    },
    {
        "Name": "KN710845",
        "Length": 2791
    },
    {
        "Name": "KN710846",
        "Length": 493
    },
    {
        "Name": "KN710847",
        "Length": 4797
    },
    {
        "Name": "KN710848",
        "Length": 2199
    },
    {
        "Name": "KN710849",
        "Length": 853
    },
    {
        "Name": "KN710850",
        "Length": 754
    },
    {
        "Name": "KN710851",
        "Length": 732
    },
    {
        "Name": "KN710852",
        "Length": 2411
    },
    {
        "Name": "KN710853",
        "Length": 470
    },
    {
        "Name": "KN710854",
        "Length": 749
    },
    {
        "Name": "KN710856",
        "Length": 897
    },
    {
        "Name": "KN710857",
        "Length": 1446
    },
    {
        "Name": "KN710858",
        "Length": 696
    },
    {
        "Name": "KN710860",
        "Length": 15507
    },
    {
        "Name": "KN710861",
        "Length": 763
    },
    {
        "Name": "KN710862",
        "Length": 525
    },
    {
        "Name": "KN710863",
        "Length": 5117
    },
    {
        "Name": "KN710864",
        "Length": 740
    },
    {
        "Name": "KN710865",
        "Length": 553
    },
    {
        "Name": "KN710866",
        "Length": 1881
    },
    {
        "Name": "KN710867",
        "Length": 1169
    },
    {
        "Name": "KN710868",
        "Length": 2722
    },
    {
        "Name": "KN710869",
        "Length": 1581
    },
    {
        "Name": "KN710870",
        "Length": 793
    },
    {
        "Name": "KN710871",
        "Length": 883
    },
    {
        "Name": "KN710872",
        "Length": 6210
    },
    {
        "Name": "KN710873",
        "Length": 6692
    },
    {
        "Name": "KN710874",
        "Length": 1014
    },
    {
        "Name": "KN710875",
        "Length": 601
    },
    {
        "Name": "KN710877",
        "Length": 1398
    },
    {
        "Name": "KN710879",
        "Length": 1408
    },
    {
        "Name": "KN710880",
        "Length": 786
    },
    {
        "Name": "KN710881",
        "Length": 1502
    },
    {
        "Name": "KN710883",
        "Length": 6271
    },
    {
        "Name": "KN710885",
        "Length": 1125
    },
    {
        "Name": "KN710887",
        "Length": 783
    },
    {
        "Name": "KN710888",
        "Length": 1423
    },
    {
        "Name": "KN710890",
        "Length": 803
    },
    {
        "Name": "KN710891",
        "Length": 15780
    },
    {
        "Name": "KN710892",
        "Length": 742
    },
    {
        "Name": "KN710893",
        "Length": 756
    },
    {
        "Name": "KN710895",
        "Length": 552
    },
    {
        "Name": "KN710897",
        "Length": 720
    },
    {
        "Name": "KN710898",
        "Length": 752
    },
    {
        "Name": "KN710899",
        "Length": 721
    },
    {
        "Name": "KN710900",
        "Length": 848
    },
    {
        "Name": "KN710901",
        "Length": 822
    },
    {
        "Name": "KN710902",
        "Length": 2151
    },
    {
        "Name": "KN710904",
        "Length": 3169
    },
    {
        "Name": "KN710905",
        "Length": 1195
    },
    {
        "Name": "KN710906",
        "Length": 1595
    },
    {
        "Name": "KN710907",
        "Length": 5773
    },
    {
        "Name": "KN710908",
        "Length": 789
    },
    {
        "Name": "KN710909",
        "Length": 2330
    },
    {
        "Name": "KN710910",
        "Length": 3626
    },
    {
        "Name": "KN710911",
        "Length": 868
    },
    {
        "Name": "KN710912",
        "Length": 2397
    },
    {
        "Name": "KN710915",
        "Length": 720
    },
    {
        "Name": "KN710916",
        "Length": 3290
    },
    {
        "Name": "KN710917",
        "Length": 539
    },
    {
        "Name": "KN710918",
        "Length": 3957
    },
    {
        "Name": "KN710920",
        "Length": 554
    },
    {
        "Name": "KN710921",
        "Length": 3187
    },
    {
        "Name": "KN710923",
        "Length": 748
    },
    {
        "Name": "KN710926",
        "Length": 565
    },
    {
        "Name": "KN710928",
        "Length": 5662
    },
    {
        "Name": "KN710929",
        "Length": 1095
    },
    {
        "Name": "KN710930",
        "Length": 2134
    },
    {
        "Name": "KN710931",
        "Length": 2026
    },
    {
        "Name": "KN710933",
        "Length": 893
    },
    {
        "Name": "KN710934",
        "Length": 771
    },
    {
        "Name": "KN710935",
        "Length": 3191
    },
    {
        "Name": "KN710937",
        "Length": 829
    },
    {
        "Name": "KN710939",
        "Length": 905
    },
    {
        "Name": "KN710940",
        "Length": 2654
    },
    {
        "Name": "KN710941",
        "Length": 1258
    },
    {
        "Name": "KN710944",
        "Length": 889
    },
    {
        "Name": "KN710945",
        "Length": 5936
    },
    {
        "Name": "KN710946",
        "Length": 909
    },
    {
        "Name": "KN710947",
        "Length": 1158
    },
    {
        "Name": "KN710948",
        "Length": 2392
    },
    {
        "Name": "KN710949",
        "Length": 468
    },
    {
        "Name": "KN710950",
        "Length": 720
    },
    {
        "Name": "KN710951",
        "Length": 1021
    },
    {
        "Name": "KN710952",
        "Length": 1882
    },
    {
        "Name": "KN710953",
        "Length": 904
    },
    {
        "Name": "KN710954",
        "Length": 1104
    },
    {
        "Name": "KN710955",
        "Length": 737
    },
    {
        "Name": "KN710956",
        "Length": 516
    },
    {
        "Name": "KN710957",
        "Length": 2438
    },
    {
        "Name": "KN710958",
        "Length": 13295
    },
    {
        "Name": "KN710959",
        "Length": 796
    },
    {
        "Name": "KN710960",
        "Length": 5985
    },
    {
        "Name": "KN710961",
        "Length": 733
    },
    {
        "Name": "KN710962",
        "Length": 807
    },
    {
        "Name": "KN710963",
        "Length": 2059
    },
    {
        "Name": "KN710964",
        "Length": 2711
    },
    {
        "Name": "KN710965",
        "Length": 745
    },
    {
        "Name": "KN710966",
        "Length": 1094
    },
    {
        "Name": "KN710967",
        "Length": 13755
    },
    {
        "Name": "KN710968",
        "Length": 784
    },
    {
        "Name": "KN710969",
        "Length": 318
    },
    {
        "Name": "KN710970",
        "Length": 774
    },
    {
        "Name": "KN710971",
        "Length": 755
    },
    {
        "Name": "KN710973",
        "Length": 722
    },
    {
        "Name": "KN710974",
        "Length": 838
    },
    {
        "Name": "KN710975",
        "Length": 1100
    },
    {
        "Name": "KN710976",
        "Length": 2520
    },
    {
        "Name": "KN710977",
        "Length": 2262
    },
    {
        "Name": "KN710978",
        "Length": 16329
    },
    {
        "Name": "KN710979",
        "Length": 474
    },
    {
        "Name": "KN710980",
        "Length": 723
    },
    {
        "Name": "KN710981",
        "Length": 1534
    },
    {
        "Name": "KN710982",
        "Length": 1300
    },
    {
        "Name": "KN710983",
        "Length": 862
    },
    {
        "Name": "KN710985",
        "Length": 872
    },
    {
        "Name": "KN710987",
        "Length": 689
    },
    {
        "Name": "KN710988",
        "Length": 4614
    },
    {
        "Name": "KN710989",
        "Length": 4491
    },
    {
        "Name": "KN710990",
        "Length": 804
    },
    {
        "Name": "KN710991",
        "Length": 1652
    },
    {
        "Name": "KN710992",
        "Length": 2097
    },
    {
        "Name": "KN710993",
        "Length": 1499
    },
    {
        "Name": "KN710994",
        "Length": 845
    },
    {
        "Name": "KN710995",
        "Length": 392
    },
    {
        "Name": "KN710997",
        "Length": 708
    },
    {
        "Name": "KN710998",
        "Length": 597
    },
    {
        "Name": "KN710999",
        "Length": 735
    },
    {
        "Name": "KN711000",
        "Length": 2782
    },
    {
        "Name": "KN711001",
        "Length": 3022
    },
    {
        "Name": "KN711002",
        "Length": 725
    },
    {
        "Name": "KN711003",
        "Length": 1227
    },
    {
        "Name": "KN711004",
        "Length": 2337
    },
    {
        "Name": "KN711005",
        "Length": 1127
    },
    {
        "Name": "KN711006",
        "Length": 524
    },
    {
        "Name": "KN711007",
        "Length": 2693
    },
    {
        "Name": "KN711008",
        "Length": 527
    },
    {
        "Name": "KN711009",
        "Length": 939
    },
    {
        "Name": "KN711010",
        "Length": 986
    },
    {
        "Name": "KN711011",
        "Length": 47540
    },
    {
        "Name": "KN711012",
        "Length": 801
    },
    {
        "Name": "KN711013",
        "Length": 727
    },
    {
        "Name": "KN711014",
        "Length": 5875
    },
    {
        "Name": "KN711015",
        "Length": 490
    },
    {
        "Name": "KN711016",
        "Length": 760
    },
    {
        "Name": "KN711017",
        "Length": 4438
    },
    {
        "Name": "KN711018",
        "Length": 742
    },
    {
        "Name": "KN711019",
        "Length": 786
    },
    {
        "Name": "KN711020",
        "Length": 687
    },
    {
        "Name": "KN711021",
        "Length": 2610
    },
    {
        "Name": "KN711022",
        "Length": 756
    },
    {
        "Name": "KN711023",
        "Length": 3451
    },
    {
        "Name": "KN711024",
        "Length": 3195
    },
    {
        "Name": "KN711025",
        "Length": 457
    },
    {
        "Name": "KN711026",
        "Length": 6658
    },
    {
        "Name": "KN711027",
        "Length": 496
    },
    {
        "Name": "KN711028",
        "Length": 801
    },
    {
        "Name": "KN711029",
        "Length": 703
    },
    {
        "Name": "KN711030",
        "Length": 723
    },
    {
        "Name": "KN711031",
        "Length": 493
    },
    {
        "Name": "KN711032",
        "Length": 745
    },
    {
        "Name": "KN711033",
        "Length": 1373
    },
    {
        "Name": "KN711034",
        "Length": 688
    },
    {
        "Name": "KN711037",
        "Length": 951
    },
    {
        "Name": "KN711039",
        "Length": 5046
    },
    {
        "Name": "KN711040",
        "Length": 872
    },
    {
        "Name": "KN711041",
        "Length": 5418
    },
    {
        "Name": "KN711042",
        "Length": 1077
    },
    {
        "Name": "KN711043",
        "Length": 811
    },
    {
        "Name": "KN711044",
        "Length": 2460
    },
    {
        "Name": "KN711045",
        "Length": 1154
    },
    {
        "Name": "KN711046",
        "Length": 784
    },
    {
        "Name": "KN711047",
        "Length": 783
    },
    {
        "Name": "KN711049",
        "Length": 2168
    },
    {
        "Name": "KN711050",
        "Length": 809
    },
    {
        "Name": "KN711051",
        "Length": 733
    },
    {
        "Name": "KN711052",
        "Length": 3067
    },
    {
        "Name": "KN711054",
        "Length": 975
    },
    {
        "Name": "KN711055",
        "Length": 5892
    },
    {
        "Name": "KN711057",
        "Length": 1941
    },
    {
        "Name": "KN711058",
        "Length": 2361
    },
    {
        "Name": "KN711059",
        "Length": 1260
    },
    {
        "Name": "KN711060",
        "Length": 566
    },
    {
        "Name": "KN711061",
        "Length": 1164
    },
    {
        "Name": "KN711062",
        "Length": 750
    },
    {
        "Name": "KN711063",
        "Length": 716
    },
    {
        "Name": "KN711064",
        "Length": 504
    },
    {
        "Name": "KN711065",
        "Length": 690
    },
    {
        "Name": "KN711066",
        "Length": 5177
    },
    {
        "Name": "KN711067",
        "Length": 7692
    },
    {
        "Name": "KN711068",
        "Length": 686
    },
    {
        "Name": "KN711070",
        "Length": 732
    },
    {
        "Name": "KN711071",
        "Length": 3465
    },
    {
        "Name": "KN711073",
        "Length": 1126
    },
    {
        "Name": "KN711074",
        "Length": 2136
    },
    {
        "Name": "KN711076",
        "Length": 559
    },
    {
        "Name": "KN711077",
        "Length": 2500
    },
    {
        "Name": "KN711078",
        "Length": 2248
    },
    {
        "Name": "KN711079",
        "Length": 768
    },
    {
        "Name": "KN711080",
        "Length": 1645
    },
    {
        "Name": "KN711081",
        "Length": 2665
    },
    {
        "Name": "KN711083",
        "Length": 801
    },
    {
        "Name": "KN711084",
        "Length": 7125
    },
    {
        "Name": "KN711085",
        "Length": 811
    },
    {
        "Name": "KN711086",
        "Length": 747
    },
    {
        "Name": "KN711087",
        "Length": 802
    },
    {
        "Name": "KN711088",
        "Length": 988
    },
    {
        "Name": "KN711089",
        "Length": 2548
    },
    {
        "Name": "KN711090",
        "Length": 759
    },
    {
        "Name": "KN711091",
        "Length": 2655
    },
    {
        "Name": "KN711092",
        "Length": 17407
    },
    {
        "Name": "KN711093",
        "Length": 725
    },
    {
        "Name": "KN711094",
        "Length": 551
    },
    {
        "Name": "KN711095",
        "Length": 934
    },
    {
        "Name": "KN711096",
        "Length": 523
    },
    {
        "Name": "KN711097",
        "Length": 506
    },
    {
        "Name": "KN711098",
        "Length": 746
    },
    {
        "Name": "KN711099",
        "Length": 524
    },
    {
        "Name": "KN711100",
        "Length": 2405
    },
    {
        "Name": "KN711101",
        "Length": 767
    },
    {
        "Name": "KN711102",
        "Length": 1078
    },
    {
        "Name": "KN711103",
        "Length": 825
    },
    {
        "Name": "KN711104",
        "Length": 2174
    },
    {
        "Name": "KN711106",
        "Length": 822
    },
    {
        "Name": "KN711108",
        "Length": 854
    },
    {
        "Name": "KN711109",
        "Length": 758
    },
    {
        "Name": "KN711110",
        "Length": 891
    },
    {
        "Name": "KN711111",
        "Length": 706
    },
    {
        "Name": "KN711112",
        "Length": 1175
    },
    {
        "Name": "KN711113",
        "Length": 785
    },
    {
        "Name": "KN711114",
        "Length": 1133
    },
    {
        "Name": "KN711115",
        "Length": 3707
    },
    {
        "Name": "KN711116",
        "Length": 735
    },
    {
        "Name": "KN711117",
        "Length": 763
    },
    {
        "Name": "KN711118",
        "Length": 1598
    },
    {
        "Name": "KN711119",
        "Length": 803
    },
    {
        "Name": "KN711121",
        "Length": 2946
    },
    {
        "Name": "KN711122",
        "Length": 800
    },
    {
        "Name": "KN711123",
        "Length": 915
    },
    {
        "Name": "KN711124",
        "Length": 702
    },
    {
        "Name": "KN711125",
        "Length": 1162
    },
    {
        "Name": "KN711126",
        "Length": 599
    },
    {
        "Name": "KN711127",
        "Length": 685
    },
    {
        "Name": "KN711128",
        "Length": 802
    },
    {
        "Name": "KN711129",
        "Length": 1370
    },
    {
        "Name": "KN711131",
        "Length": 9805
    },
    {
        "Name": "KN711132",
        "Length": 876
    },
    {
        "Name": "KN711133",
        "Length": 767
    },
    {
        "Name": "KN711134",
        "Length": 710
    },
    {
        "Name": "KN711135",
        "Length": 756
    },
    {
        "Name": "KN711136",
        "Length": 1004
    },
    {
        "Name": "KN711137",
        "Length": 4319
    },
    {
        "Name": "KN711138",
        "Length": 1006
    },
    {
        "Name": "KN711139",
        "Length": 10112
    },
    {
        "Name": "KN711140",
        "Length": 510
    },
    {
        "Name": "KN711141",
        "Length": 9833
    },
    {
        "Name": "KN711142",
        "Length": 624
    },
    {
        "Name": "KN711143",
        "Length": 524
    },
    {
        "Name": "KN711144",
        "Length": 732
    },
    {
        "Name": "KN711145",
        "Length": 2839
    },
    {
        "Name": "KN711146",
        "Length": 795
    },
    {
        "Name": "KN711147",
        "Length": 758
    },
    {
        "Name": "KN711148",
        "Length": 1359
    },
    {
        "Name": "KN711149",
        "Length": 830
    },
    {
        "Name": "KN711150",
        "Length": 2799
    },
    {
        "Name": "KN711151",
        "Length": 5865
    },
    {
        "Name": "KN711152",
        "Length": 510
    },
    {
        "Name": "KN711153",
        "Length": 15849
    },
    {
        "Name": "KN711154",
        "Length": 5147
    },
    {
        "Name": "KN711156",
        "Length": 768
    },
    {
        "Name": "KN711157",
        "Length": 1039
    },
    {
        "Name": "KN711158",
        "Length": 5877
    },
    {
        "Name": "KN711159",
        "Length": 2485
    },
    {
        "Name": "KN711160",
        "Length": 2724
    },
    {
        "Name": "KN711161",
        "Length": 2074
    },
    {
        "Name": "KN711162",
        "Length": 2083
    },
    {
        "Name": "KN711163",
        "Length": 730
    },
    {
        "Name": "KN711164",
        "Length": 713
    },
    {
        "Name": "KN711165",
        "Length": 826
    },
    {
        "Name": "KN711166",
        "Length": 554
    },
    {
        "Name": "KN711167",
        "Length": 799
    },
    {
        "Name": "KN711168",
        "Length": 2755
    },
    {
        "Name": "KN711169",
        "Length": 5882
    },
    {
        "Name": "KN711170",
        "Length": 810
    },
    {
        "Name": "KN711171",
        "Length": 472
    },
    {
        "Name": "KN711172",
        "Length": 738
    },
    {
        "Name": "KN711173",
        "Length": 2584
    },
    {
        "Name": "KN711174",
        "Length": 2457
    },
    {
        "Name": "KN711175",
        "Length": 518
    },
    {
        "Name": "KN711176",
        "Length": 2385
    },
    {
        "Name": "KN711177",
        "Length": 9632
    },
    {
        "Name": "KN711178",
        "Length": 538
    },
    {
        "Name": "KN711179",
        "Length": 726
    },
    {
        "Name": "KN711180",
        "Length": 506
    },
    {
        "Name": "KN711181",
        "Length": 795
    },
    {
        "Name": "KN711182",
        "Length": 533
    },
    {
        "Name": "KN711185",
        "Length": 763
    },
    {
        "Name": "KN711186",
        "Length": 853
    },
    {
        "Name": "KN711187",
        "Length": 5070
    },
    {
        "Name": "KN711188",
        "Length": 779
    },
    {
        "Name": "KN711189",
        "Length": 806
    },
    {
        "Name": "KN711190",
        "Length": 708
    },
    {
        "Name": "KN711191",
        "Length": 693
    },
    {
        "Name": "KN711192",
        "Length": 785
    },
    {
        "Name": "KN711193",
        "Length": 260
    },
    {
        "Name": "KN711194",
        "Length": 2385
    },
    {
        "Name": "KN711195",
        "Length": 764
    },
    {
        "Name": "KN711196",
        "Length": 1200
    },
    {
        "Name": "KN711197",
        "Length": 2093
    },
    {
        "Name": "KN711198",
        "Length": 2383
    },
    {
        "Name": "KN711199",
        "Length": 721
    },
    {
        "Name": "KN711200",
        "Length": 569
    },
    {
        "Name": "KN711201",
        "Length": 1220
    },
    {
        "Name": "KN711202",
        "Length": 2448
    },
    {
        "Name": "KN711203",
        "Length": 924
    },
    {
        "Name": "KN711204",
        "Length": 843
    },
    {
        "Name": "KN711205",
        "Length": 818
    },
    {
        "Name": "KN711206",
        "Length": 1967
    },
    {
        "Name": "KN711207",
        "Length": 2087
    },
    {
        "Name": "KN711208",
        "Length": 4295
    },
    {
        "Name": "KN711209",
        "Length": 592
    },
    {
        "Name": "KN711210",
        "Length": 692
    },
    {
        "Name": "KN711211",
        "Length": 804
    },
    {
        "Name": "KN711212",
        "Length": 2434
    },
    {
        "Name": "KN711213",
        "Length": 874
    },
    {
        "Name": "KN711214",
        "Length": 9889
    },
    {
        "Name": "KN711215",
        "Length": 567
    },
    {
        "Name": "KN711216",
        "Length": 1329
    },
    {
        "Name": "KN711217",
        "Length": 950
    },
    {
        "Name": "KN711218",
        "Length": 1322
    },
    {
        "Name": "KN711220",
        "Length": 762
    },
    {
        "Name": "KN711221",
        "Length": 740
    },
    {
        "Name": "KN711223",
        "Length": 4108
    },
    {
        "Name": "KN711224",
        "Length": 2903
    },
    {
        "Name": "KN711225",
        "Length": 5742
    },
    {
        "Name": "KN711226",
        "Length": 3482
    },
    {
        "Name": "KN711228",
        "Length": 20124
    },
    {
        "Name": "KN711230",
        "Length": 7032
    },
    {
        "Name": "KN711232",
        "Length": 2718
    },
    {
        "Name": "Super-Scaffold_12",
        "Length": 798855
    },
    {
        "Name": "Super-Scaffold_167",
        "Length": 113192
    },
    {
        "Name": "Super-Scaffold_655",
        "Length": 494977
    },
    {
        "Name": "Super-Scaffold_933",
        "Length": 665659
    },
    {
        "Name": "ctgAPLB01000001",
        "Length": 14169
    },
    {
        "Name": "ctgAPLB01000002",
        "Length": 10219
    },
    {
        "Name": "ctgAPLB01000747",
        "Length": 3939
    },
    {
        "Name": "ctgAPLB01003822",
        "Length": 1091
    },
    {
        "Name": "ctgAPLB01005326",
        "Length": 28304
    },
    {
        "Name": "ctgAPLB01008294",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01008295",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01008337",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01009831",
        "Length": 7519
    },
    {
        "Name": "ctgAPLB01011484",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01011639",
        "Length": 15969
    },
    {
        "Name": "ctgAPLB01011827",
        "Length": 1952
    },
    {
        "Name": "ctgAPLB01012817",
        "Length": 895
    },
    {
        "Name": "ctgAPLB01013229",
        "Length": 19883
    },
    {
        "Name": "ctgAPLB01014436",
        "Length": 3263
    },
    {
        "Name": "ctgAPLB01014762",
        "Length": 901
    },
    {
        "Name": "ctgAPLB01015707",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01016328",
        "Length": 1160
    },
    {
        "Name": "ctgAPLB01016526",
        "Length": 18779
    },
    {
        "Name": "ctgAPLB01017882",
        "Length": 31186
    },
    {
        "Name": "ctgAPLB01018307",
        "Length": 2984
    },
    {
        "Name": "ctgAPLB01019221",
        "Length": 28732
    },
    {
        "Name": "ctgAPLB01022107",
        "Length": 17136
    },
    {
        "Name": "ctgAPLB01022876",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01023404",
        "Length": 6435
    },
    {
        "Name": "ctgAPLB01023560",
        "Length": 725
    },
    {
        "Name": "ctgAPLB01024357",
        "Length": 3891
    },
    {
        "Name": "ctgAPLB01024507",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01024508",
        "Length": 825
    },
    {
        "Name": "ctgAPLB01024686",
        "Length": 4861
    },
    {
        "Name": "ctgAPLB01024728",
        "Length": 6497
    },
    {
        "Name": "ctgAPLB01025504",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01026427",
        "Length": 752
    },
    {
        "Name": "ctgAPLB01026482",
        "Length": 1181
    },
    {
        "Name": "ctgAPLB01026856",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01027737",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01027808",
        "Length": 17710
    },
    {
        "Name": "ctgAPLB01027949",
        "Length": 843
    },
    {
        "Name": "ctgAPLB01028398",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01028592",
        "Length": 3540
    },
    {
        "Name": "ctgAPLB01028666",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01028981",
        "Length": 4653
    },
    {
        "Name": "ctgAPLB01029053",
        "Length": 1229
    },
    {
        "Name": "ctgAPLB01029163",
        "Length": 846
    },
    {
        "Name": "ctgAPLB01029303",
        "Length": 1200
    },
    {
        "Name": "ctgAPLB01029407",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01029426",
        "Length": 1411
    },
    {
        "Name": "ctgAPLB01029962",
        "Length": 26141
    },
    {
        "Name": "ctgAPLB01030065",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01030070",
        "Length": 1438
    },
    {
        "Name": "ctgAPLB01030152",
        "Length": 1129
    },
    {
        "Name": "ctgAPLB01030437",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01030661",
        "Length": 813
    },
    {
        "Name": "ctgAPLB01030673",
        "Length": 2777
    },
    {
        "Name": "ctgAPLB01030927",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01031003",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01031004",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01031030",
        "Length": 2240
    },
    {
        "Name": "ctgAPLB01031091",
        "Length": 1121
    },
    {
        "Name": "ctgAPLB01031248",
        "Length": 16582
    },
    {
        "Name": "ctgAPLB01031285",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01031421",
        "Length": 997
    },
    {
        "Name": "ctgAPLB01031422",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01031441",
        "Length": 1262
    },
    {
        "Name": "ctgAPLB01031555",
        "Length": 2617
    },
    {
        "Name": "ctgAPLB01031581",
        "Length": 689
    },
    {
        "Name": "ctgAPLB01031585",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01031720",
        "Length": 4429
    },
    {
        "Name": "ctgAPLB01031721",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01031804",
        "Length": 817
    },
    {
        "Name": "ctgAPLB01031916",
        "Length": 2008
    },
    {
        "Name": "ctgAPLB01031955",
        "Length": 883
    },
    {
        "Name": "ctgAPLB01031956",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01031957",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01032150",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01032151",
        "Length": 5907
    },
    {
        "Name": "ctgAPLB01032163",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01032501",
        "Length": 3454
    },
    {
        "Name": "ctgAPLB01032521",
        "Length": 1625
    },
    {
        "Name": "ctgAPLB01032780",
        "Length": 775
    },
    {
        "Name": "ctgAPLB01032818",
        "Length": 790
    },
    {
        "Name": "ctgAPLB01032881",
        "Length": 1632
    },
    {
        "Name": "ctgAPLB01032882",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01032979",
        "Length": 8799
    },
    {
        "Name": "ctgAPLB01033236",
        "Length": 1135
    },
    {
        "Name": "ctgAPLB01033263",
        "Length": 5315
    },
    {
        "Name": "ctgAPLB01033281",
        "Length": 1408
    },
    {
        "Name": "ctgAPLB01033287",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01033288",
        "Length": 6110
    },
    {
        "Name": "ctgAPLB01033564",
        "Length": 29573
    },
    {
        "Name": "ctgAPLB01033565",
        "Length": 5653
    },
    {
        "Name": "ctgAPLB01033566",
        "Length": 3712
    },
    {
        "Name": "ctgAPLB01033614",
        "Length": 783
    },
    {
        "Name": "ctgAPLB01033632",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01033700",
        "Length": 1170
    },
    {
        "Name": "ctgAPLB01033833",
        "Length": 15713
    },
    {
        "Name": "ctgAPLB01033834",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01033881",
        "Length": 27881
    },
    {
        "Name": "ctgAPLB01033914",
        "Length": 1374
    },
    {
        "Name": "ctgAPLB01034011",
        "Length": 737
    },
    {
        "Name": "ctgAPLB01034020",
        "Length": 11153
    },
    {
        "Name": "ctgAPLB01034104",
        "Length": 1922
    },
    {
        "Name": "ctgAPLB01034113",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01034114",
        "Length": 1482
    },
    {
        "Name": "ctgAPLB01034272",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01034295",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01034457",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01034521",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01034565",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01034566",
        "Length": 33355
    },
    {
        "Name": "ctgAPLB01034574",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01034584",
        "Length": 7875
    },
    {
        "Name": "ctgAPLB01034622",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01034656",
        "Length": 12966
    },
    {
        "Name": "ctgAPLB01034691",
        "Length": 1153
    },
    {
        "Name": "ctgAPLB01034761",
        "Length": 5651
    },
    {
        "Name": "ctgAPLB01034762",
        "Length": 885
    },
    {
        "Name": "ctgAPLB01034790",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01034818",
        "Length": 1281
    },
    {
        "Name": "ctgAPLB01034840",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01034903",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01034920",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01034921",
        "Length": 21248
    },
    {
        "Name": "ctgAPLB01034922",
        "Length": 4357
    },
    {
        "Name": "ctgAPLB01034987",
        "Length": 1914
    },
    {
        "Name": "ctgAPLB01034988",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01034989",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01034990",
        "Length": 893
    },
    {
        "Name": "ctgAPLB01034991",
        "Length": 1288
    },
    {
        "Name": "ctgAPLB01034992",
        "Length": 456
    },
    {
        "Name": "ctgAPLB01034993",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01034998",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01034999",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01035033",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01035035",
        "Length": 1171
    },
    {
        "Name": "ctgAPLB01035127",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01035216",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01035226",
        "Length": 4387
    },
    {
        "Name": "ctgAPLB01035241",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01035340",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01035386",
        "Length": 5519
    },
    {
        "Name": "ctgAPLB01035446",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01035468",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01035501",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01035507",
        "Length": 885
    },
    {
        "Name": "ctgAPLB01035508",
        "Length": 416
    },
    {
        "Name": "ctgAPLB01035511",
        "Length": 1726
    },
    {
        "Name": "ctgAPLB01035517",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01035529",
        "Length": 1620
    },
    {
        "Name": "ctgAPLB01035543",
        "Length": 2992
    },
    {
        "Name": "ctgAPLB01035544",
        "Length": 6211
    },
    {
        "Name": "ctgAPLB01035545",
        "Length": 4835
    },
    {
        "Name": "ctgAPLB01035585",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01035714",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01035754",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01035760",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01035761",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01035764",
        "Length": 636
    },
    {
        "Name": "ctgAPLB01035771",
        "Length": 3142
    },
    {
        "Name": "ctgAPLB01035806",
        "Length": 1830
    },
    {
        "Name": "ctgAPLB01035818",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01035869",
        "Length": 1058
    },
    {
        "Name": "ctgAPLB01035924",
        "Length": 1265
    },
    {
        "Name": "ctgAPLB01035940",
        "Length": 2439
    },
    {
        "Name": "ctgAPLB01035944",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01035945",
        "Length": 1007
    },
    {
        "Name": "ctgAPLB01035946",
        "Length": 891
    },
    {
        "Name": "ctgAPLB01035947",
        "Length": 1790
    },
    {
        "Name": "ctgAPLB01035960",
        "Length": 1244
    },
    {
        "Name": "ctgAPLB01035984",
        "Length": 1235
    },
    {
        "Name": "ctgAPLB01036062",
        "Length": 815
    },
    {
        "Name": "ctgAPLB01036063",
        "Length": 3260
    },
    {
        "Name": "ctgAPLB01036064",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01036065",
        "Length": 707
    },
    {
        "Name": "ctgAPLB01036066",
        "Length": 3883
    },
    {
        "Name": "ctgAPLB01036114",
        "Length": 16676
    },
    {
        "Name": "ctgAPLB01036180",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01036187",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01036204",
        "Length": 6626
    },
    {
        "Name": "ctgAPLB01036205",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01036212",
        "Length": 1097
    },
    {
        "Name": "ctgAPLB01036216",
        "Length": 656
    },
    {
        "Name": "ctgAPLB01036225",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01036226",
        "Length": 3599
    },
    {
        "Name": "ctgAPLB01036234",
        "Length": 5904
    },
    {
        "Name": "ctgAPLB01036248",
        "Length": 1176
    },
    {
        "Name": "ctgAPLB01036261",
        "Length": 1130
    },
    {
        "Name": "ctgAPLB01036266",
        "Length": 4369
    },
    {
        "Name": "ctgAPLB01036273",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01036326",
        "Length": 11087
    },
    {
        "Name": "ctgAPLB01036364",
        "Length": 829
    },
    {
        "Name": "ctgAPLB01036365",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01036432",
        "Length": 2912
    },
    {
        "Name": "ctgAPLB01036436",
        "Length": 1512
    },
    {
        "Name": "ctgAPLB01036456",
        "Length": 587
    },
    {
        "Name": "ctgAPLB01036459",
        "Length": 1047
    },
    {
        "Name": "ctgAPLB01036460",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01036464",
        "Length": 7494
    },
    {
        "Name": "ctgAPLB01036465",
        "Length": 2750
    },
    {
        "Name": "ctgAPLB01036509",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01036557",
        "Length": 657
    },
    {
        "Name": "ctgAPLB01036558",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01036582",
        "Length": 6023
    },
    {
        "Name": "ctgAPLB01036604",
        "Length": 1244
    },
    {
        "Name": "ctgAPLB01036642",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01036643",
        "Length": 14892
    },
    {
        "Name": "ctgAPLB01036644",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01036645",
        "Length": 647
    },
    {
        "Name": "ctgAPLB01036646",
        "Length": 20979
    },
    {
        "Name": "ctgAPLB01036650",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01036654",
        "Length": 873
    },
    {
        "Name": "ctgAPLB01036657",
        "Length": 8257
    },
    {
        "Name": "ctgAPLB01036668",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01036677",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01036678",
        "Length": 899
    },
    {
        "Name": "ctgAPLB01036689",
        "Length": 8090
    },
    {
        "Name": "ctgAPLB01036705",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01036758",
        "Length": 2479
    },
    {
        "Name": "ctgAPLB01036769",
        "Length": 5710
    },
    {
        "Name": "ctgAPLB01036796",
        "Length": 1824
    },
    {
        "Name": "ctgAPLB01036803",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01036822",
        "Length": 3030
    },
    {
        "Name": "ctgAPLB01036835",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01036841",
        "Length": 6572
    },
    {
        "Name": "ctgAPLB01036844",
        "Length": 1601
    },
    {
        "Name": "ctgAPLB01036849",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01036905",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01036911",
        "Length": 1257
    },
    {
        "Name": "ctgAPLB01036940",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01036963",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01036964",
        "Length": 13159
    },
    {
        "Name": "ctgAPLB01036965",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01036974",
        "Length": 867
    },
    {
        "Name": "ctgAPLB01036981",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01037005",
        "Length": 2800
    },
    {
        "Name": "ctgAPLB01037013",
        "Length": 2181
    },
    {
        "Name": "ctgAPLB01037055",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01037056",
        "Length": 8647
    },
    {
        "Name": "ctgAPLB01037057",
        "Length": 980
    },
    {
        "Name": "ctgAPLB01037058",
        "Length": 779
    },
    {
        "Name": "ctgAPLB01037059",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01037069",
        "Length": 4620
    },
    {
        "Name": "ctgAPLB01037071",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01037072",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01037073",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01037091",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01037117",
        "Length": 10141
    },
    {
        "Name": "ctgAPLB01037121",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01037150",
        "Length": 3358
    },
    {
        "Name": "ctgAPLB01037151",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01037152",
        "Length": 2304
    },
    {
        "Name": "ctgAPLB01037197",
        "Length": 3824
    },
    {
        "Name": "ctgAPLB01037231",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01037232",
        "Length": 2451
    },
    {
        "Name": "ctgAPLB01037233",
        "Length": 783
    },
    {
        "Name": "ctgAPLB01037248",
        "Length": 5228
    },
    {
        "Name": "ctgAPLB01037249",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01037270",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01037274",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01037314",
        "Length": 5905
    },
    {
        "Name": "ctgAPLB01037333",
        "Length": 9467
    },
    {
        "Name": "ctgAPLB01037337",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01037351",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01037352",
        "Length": 648
    },
    {
        "Name": "ctgAPLB01037360",
        "Length": 4991
    },
    {
        "Name": "ctgAPLB01037376",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01037377",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01037378",
        "Length": 1201
    },
    {
        "Name": "ctgAPLB01037383",
        "Length": 1376
    },
    {
        "Name": "ctgAPLB01037408",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01037419",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01037420",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01037424",
        "Length": 725
    },
    {
        "Name": "ctgAPLB01037425",
        "Length": 1328
    },
    {
        "Name": "ctgAPLB01037433",
        "Length": 945
    },
    {
        "Name": "ctgAPLB01037434",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01037436",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01037439",
        "Length": 1000
    },
    {
        "Name": "ctgAPLB01037441",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01037442",
        "Length": 1007
    },
    {
        "Name": "ctgAPLB01037443",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01037459",
        "Length": 5405
    },
    {
        "Name": "ctgAPLB01037482",
        "Length": 3975
    },
    {
        "Name": "ctgAPLB01037483",
        "Length": 15781
    },
    {
        "Name": "ctgAPLB01037508",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01037509",
        "Length": 1014
    },
    {
        "Name": "ctgAPLB01037538",
        "Length": 1487
    },
    {
        "Name": "ctgAPLB01037542",
        "Length": 2438
    },
    {
        "Name": "ctgAPLB01037543",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01037544",
        "Length": 1104
    },
    {
        "Name": "ctgAPLB01037545",
        "Length": 1114
    },
    {
        "Name": "ctgAPLB01037546",
        "Length": 1074
    },
    {
        "Name": "ctgAPLB01037550",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01037568",
        "Length": 576
    },
    {
        "Name": "ctgAPLB01037578",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01037593",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01037594",
        "Length": 8843
    },
    {
        "Name": "ctgAPLB01037599",
        "Length": 5035
    },
    {
        "Name": "ctgAPLB01037600",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01037601",
        "Length": 456
    },
    {
        "Name": "ctgAPLB01037612",
        "Length": 11347
    },
    {
        "Name": "ctgAPLB01037613",
        "Length": 697
    },
    {
        "Name": "ctgAPLB01037614",
        "Length": 615
    },
    {
        "Name": "ctgAPLB01037618",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01037642",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01037643",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01037646",
        "Length": 5591
    },
    {
        "Name": "ctgAPLB01037668",
        "Length": 4226
    },
    {
        "Name": "ctgAPLB01037675",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01037684",
        "Length": 1171
    },
    {
        "Name": "ctgAPLB01037694",
        "Length": 1049
    },
    {
        "Name": "ctgAPLB01037697",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01037708",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01037709",
        "Length": 1756
    },
    {
        "Name": "ctgAPLB01037710",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01037713",
        "Length": 9415
    },
    {
        "Name": "ctgAPLB01037714",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01037718",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01037730",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01037745",
        "Length": 790
    },
    {
        "Name": "ctgAPLB01037790",
        "Length": 1235
    },
    {
        "Name": "ctgAPLB01037843",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01037844",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01037845",
        "Length": 836
    },
    {
        "Name": "ctgAPLB01037872",
        "Length": 1305
    },
    {
        "Name": "ctgAPLB01037885",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01037900",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01037901",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01037902",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01037903",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01037904",
        "Length": 832
    },
    {
        "Name": "ctgAPLB01037907",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01037932",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01037933",
        "Length": 9473
    },
    {
        "Name": "ctgAPLB01037934",
        "Length": 2384
    },
    {
        "Name": "ctgAPLB01037944",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01037945",
        "Length": 14944
    },
    {
        "Name": "ctgAPLB01037952",
        "Length": 418
    },
    {
        "Name": "ctgAPLB01037953",
        "Length": 1076
    },
    {
        "Name": "ctgAPLB01037954",
        "Length": 2437
    },
    {
        "Name": "ctgAPLB01037957",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01037958",
        "Length": 2214
    },
    {
        "Name": "ctgAPLB01037959",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01037976",
        "Length": 1087
    },
    {
        "Name": "ctgAPLB01037977",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01037978",
        "Length": 771
    },
    {
        "Name": "ctgAPLB01037979",
        "Length": 848
    },
    {
        "Name": "ctgAPLB01037988",
        "Length": 942
    },
    {
        "Name": "ctgAPLB01037991",
        "Length": 948
    },
    {
        "Name": "ctgAPLB01037992",
        "Length": 750
    },
    {
        "Name": "ctgAPLB01037993",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01038003",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01038006",
        "Length": 2922
    },
    {
        "Name": "ctgAPLB01038007",
        "Length": 5025
    },
    {
        "Name": "ctgAPLB01038008",
        "Length": 3794
    },
    {
        "Name": "ctgAPLB01038018",
        "Length": 964
    },
    {
        "Name": "ctgAPLB01038022",
        "Length": 737
    },
    {
        "Name": "ctgAPLB01038024",
        "Length": 2539
    },
    {
        "Name": "ctgAPLB01038025",
        "Length": 4417
    },
    {
        "Name": "ctgAPLB01038026",
        "Length": 7799
    },
    {
        "Name": "ctgAPLB01038029",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01038030",
        "Length": 674
    },
    {
        "Name": "ctgAPLB01038039",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01038040",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01038041",
        "Length": 1119
    },
    {
        "Name": "ctgAPLB01038044",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01038048",
        "Length": 1067
    },
    {
        "Name": "ctgAPLB01038049",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01038050",
        "Length": 2580
    },
    {
        "Name": "ctgAPLB01038051",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01038052",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01038055",
        "Length": 1417
    },
    {
        "Name": "ctgAPLB01038056",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01038057",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01038075",
        "Length": 2943
    },
    {
        "Name": "ctgAPLB01038079",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01038083",
        "Length": 421
    },
    {
        "Name": "ctgAPLB01038084",
        "Length": 4862
    },
    {
        "Name": "ctgAPLB01038092",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01038093",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01038094",
        "Length": 1051
    },
    {
        "Name": "ctgAPLB01038100",
        "Length": 1165
    },
    {
        "Name": "ctgAPLB01038101",
        "Length": 902
    },
    {
        "Name": "ctgAPLB01038102",
        "Length": 35629
    },
    {
        "Name": "ctgAPLB01038104",
        "Length": 1459
    },
    {
        "Name": "ctgAPLB01038114",
        "Length": 1335
    },
    {
        "Name": "ctgAPLB01038115",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01038127",
        "Length": 1156
    },
    {
        "Name": "ctgAPLB01038128",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01038129",
        "Length": 715
    },
    {
        "Name": "ctgAPLB01038134",
        "Length": 805
    },
    {
        "Name": "ctgAPLB01038144",
        "Length": 3422
    },
    {
        "Name": "ctgAPLB01038147",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01038148",
        "Length": 7360
    },
    {
        "Name": "ctgAPLB01038151",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01038152",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01038153",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01038156",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01038157",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01038158",
        "Length": 930
    },
    {
        "Name": "ctgAPLB01038160",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01038161",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01038162",
        "Length": 1291
    },
    {
        "Name": "ctgAPLB01038164",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01038165",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01038169",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01038206",
        "Length": 887
    },
    {
        "Name": "ctgAPLB01038207",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01038209",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01038219",
        "Length": 16576
    },
    {
        "Name": "ctgAPLB01038222",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01038225",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01038226",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01038230",
        "Length": 1305
    },
    {
        "Name": "ctgAPLB01038231",
        "Length": 2297
    },
    {
        "Name": "ctgAPLB01038233",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01038234",
        "Length": 1036
    },
    {
        "Name": "ctgAPLB01038237",
        "Length": 1074
    },
    {
        "Name": "ctgAPLB01038238",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01038239",
        "Length": 9037
    },
    {
        "Name": "ctgAPLB01038240",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01038241",
        "Length": 994
    },
    {
        "Name": "ctgAPLB01038242",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01038243",
        "Length": 1980
    },
    {
        "Name": "ctgAPLB01038244",
        "Length": 972
    },
    {
        "Name": "ctgAPLB01038245",
        "Length": 5706
    },
    {
        "Name": "ctgAPLB01038251",
        "Length": 4830
    },
    {
        "Name": "ctgAPLB01038252",
        "Length": 816
    },
    {
        "Name": "ctgAPLB01038257",
        "Length": 1761
    },
    {
        "Name": "ctgAPLB01038265",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01038269",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01038270",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01038274",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01038275",
        "Length": 6064
    },
    {
        "Name": "ctgAPLB01038276",
        "Length": 4711
    },
    {
        "Name": "ctgAPLB01038277",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01038280",
        "Length": 4523
    },
    {
        "Name": "ctgAPLB01038281",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01038283",
        "Length": 12795
    },
    {
        "Name": "ctgAPLB01038284",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01038289",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01038296",
        "Length": 1560
    },
    {
        "Name": "ctgAPLB01038297",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01038298",
        "Length": 905
    },
    {
        "Name": "ctgAPLB01038299",
        "Length": 7338
    },
    {
        "Name": "ctgAPLB01038303",
        "Length": 11034
    },
    {
        "Name": "ctgAPLB01038308",
        "Length": 1451
    },
    {
        "Name": "ctgAPLB01038309",
        "Length": 817
    },
    {
        "Name": "ctgAPLB01038310",
        "Length": 1540
    },
    {
        "Name": "ctgAPLB01038311",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01038319",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01038332",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01038335",
        "Length": 1362
    },
    {
        "Name": "ctgAPLB01038337",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01038338",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01038339",
        "Length": 3239
    },
    {
        "Name": "ctgAPLB01038340",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01038350",
        "Length": 5322
    },
    {
        "Name": "ctgAPLB01038355",
        "Length": 856
    },
    {
        "Name": "ctgAPLB01038356",
        "Length": 3485
    },
    {
        "Name": "ctgAPLB01038361",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01038364",
        "Length": 1518
    },
    {
        "Name": "ctgAPLB01038365",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01038370",
        "Length": 1125
    },
    {
        "Name": "ctgAPLB01038371",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01038376",
        "Length": 3888
    },
    {
        "Name": "ctgAPLB01038378",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01038382",
        "Length": 3737
    },
    {
        "Name": "ctgAPLB01038385",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01038386",
        "Length": 29375
    },
    {
        "Name": "ctgAPLB01038391",
        "Length": 1626
    },
    {
        "Name": "ctgAPLB01038395",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01038410",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01038411",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01038412",
        "Length": 978
    },
    {
        "Name": "ctgAPLB01038413",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01038414",
        "Length": 1515
    },
    {
        "Name": "ctgAPLB01038421",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01038422",
        "Length": 1533
    },
    {
        "Name": "ctgAPLB01038425",
        "Length": 3669
    },
    {
        "Name": "ctgAPLB01038426",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01038441",
        "Length": 767
    },
    {
        "Name": "ctgAPLB01038442",
        "Length": 966
    },
    {
        "Name": "ctgAPLB01038443",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01038457",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01038460",
        "Length": 4642
    },
    {
        "Name": "ctgAPLB01038464",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01038465",
        "Length": 952
    },
    {
        "Name": "ctgAPLB01038466",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01038469",
        "Length": 910
    },
    {
        "Name": "ctgAPLB01038473",
        "Length": 1013
    },
    {
        "Name": "ctgAPLB01038483",
        "Length": 863
    },
    {
        "Name": "ctgAPLB01038487",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01038488",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01038524",
        "Length": 941
    },
    {
        "Name": "ctgAPLB01038525",
        "Length": 7214
    },
    {
        "Name": "ctgAPLB01038526",
        "Length": 2969
    },
    {
        "Name": "ctgAPLB01038529",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01038530",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01038531",
        "Length": 860
    },
    {
        "Name": "ctgAPLB01038532",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01038533",
        "Length": 1473
    },
    {
        "Name": "ctgAPLB01038540",
        "Length": 6621
    },
    {
        "Name": "ctgAPLB01038545",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01038567",
        "Length": 828
    },
    {
        "Name": "ctgAPLB01038570",
        "Length": 2546
    },
    {
        "Name": "ctgAPLB01038571",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01038575",
        "Length": 3829
    },
    {
        "Name": "ctgAPLB01038581",
        "Length": 1025
    },
    {
        "Name": "ctgAPLB01038582",
        "Length": 1099
    },
    {
        "Name": "ctgAPLB01038583",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01038584",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01038589",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01038590",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01038594",
        "Length": 586
    },
    {
        "Name": "ctgAPLB01038596",
        "Length": 1782
    },
    {
        "Name": "ctgAPLB01038597",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01038607",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01038610",
        "Length": 1640
    },
    {
        "Name": "ctgAPLB01038611",
        "Length": 697
    },
    {
        "Name": "ctgAPLB01038614",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01038615",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01038616",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01038617",
        "Length": 1296
    },
    {
        "Name": "ctgAPLB01038618",
        "Length": 1064
    },
    {
        "Name": "ctgAPLB01038621",
        "Length": 6773
    },
    {
        "Name": "ctgAPLB01038624",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01038629",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01038640",
        "Length": 1197
    },
    {
        "Name": "ctgAPLB01038647",
        "Length": 582
    },
    {
        "Name": "ctgAPLB01038650",
        "Length": 15618
    },
    {
        "Name": "ctgAPLB01038653",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01038654",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01038655",
        "Length": 590
    },
    {
        "Name": "ctgAPLB01038656",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01038657",
        "Length": 2130
    },
    {
        "Name": "ctgAPLB01038658",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01038659",
        "Length": 1154
    },
    {
        "Name": "ctgAPLB01038660",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01038661",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01038665",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01038666",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01038677",
        "Length": 1658
    },
    {
        "Name": "ctgAPLB01038678",
        "Length": 875
    },
    {
        "Name": "ctgAPLB01038679",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01038685",
        "Length": 6825
    },
    {
        "Name": "ctgAPLB01038687",
        "Length": 8760
    },
    {
        "Name": "ctgAPLB01038688",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01038692",
        "Length": 699
    },
    {
        "Name": "ctgAPLB01038693",
        "Length": 1649
    },
    {
        "Name": "ctgAPLB01038694",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01038701",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01038702",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01038703",
        "Length": 1511
    },
    {
        "Name": "ctgAPLB01038716",
        "Length": 1337
    },
    {
        "Name": "ctgAPLB01038722",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01038723",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01038727",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01038738",
        "Length": 1124
    },
    {
        "Name": "ctgAPLB01038739",
        "Length": 1480
    },
    {
        "Name": "ctgAPLB01038740",
        "Length": 3596
    },
    {
        "Name": "ctgAPLB01038741",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01038742",
        "Length": 691
    },
    {
        "Name": "ctgAPLB01038743",
        "Length": 590
    },
    {
        "Name": "ctgAPLB01038744",
        "Length": 11184
    },
    {
        "Name": "ctgAPLB01038752",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01038753",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01038756",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01038758",
        "Length": 1005
    },
    {
        "Name": "ctgAPLB01038759",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01038760",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01038761",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01038762",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01038763",
        "Length": 1446
    },
    {
        "Name": "ctgAPLB01038764",
        "Length": 1019
    },
    {
        "Name": "ctgAPLB01038765",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01038768",
        "Length": 1630
    },
    {
        "Name": "ctgAPLB01038777",
        "Length": 689
    },
    {
        "Name": "ctgAPLB01038778",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01038784",
        "Length": 9770
    },
    {
        "Name": "ctgAPLB01038785",
        "Length": 552
    },
    {
        "Name": "ctgAPLB01038786",
        "Length": 3207
    },
    {
        "Name": "ctgAPLB01038789",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01038791",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01038796",
        "Length": 1224
    },
    {
        "Name": "ctgAPLB01038797",
        "Length": 688
    },
    {
        "Name": "ctgAPLB01038798",
        "Length": 8221
    },
    {
        "Name": "ctgAPLB01038801",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01038808",
        "Length": 1436
    },
    {
        "Name": "ctgAPLB01038831",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01038832",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01038833",
        "Length": 6324
    },
    {
        "Name": "ctgAPLB01038834",
        "Length": 2380
    },
    {
        "Name": "ctgAPLB01038835",
        "Length": 3654
    },
    {
        "Name": "ctgAPLB01038836",
        "Length": 2076
    },
    {
        "Name": "ctgAPLB01038837",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01038839",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01038842",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01038853",
        "Length": 635
    },
    {
        "Name": "ctgAPLB01038857",
        "Length": 635
    },
    {
        "Name": "ctgAPLB01038870",
        "Length": 2561
    },
    {
        "Name": "ctgAPLB01038871",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01038872",
        "Length": 22703
    },
    {
        "Name": "ctgAPLB01038873",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01038878",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01038882",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01038893",
        "Length": 12182
    },
    {
        "Name": "ctgAPLB01038897",
        "Length": 7215
    },
    {
        "Name": "ctgAPLB01038898",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01038899",
        "Length": 8677
    },
    {
        "Name": "ctgAPLB01038900",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01038901",
        "Length": 875
    },
    {
        "Name": "ctgAPLB01038902",
        "Length": 2487
    },
    {
        "Name": "ctgAPLB01038903",
        "Length": 1089
    },
    {
        "Name": "ctgAPLB01038905",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01038906",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01038907",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01038908",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01038909",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01038910",
        "Length": 2335
    },
    {
        "Name": "ctgAPLB01038920",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01038929",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01038932",
        "Length": 3244
    },
    {
        "Name": "ctgAPLB01038933",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01038941",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01038942",
        "Length": 8037
    },
    {
        "Name": "ctgAPLB01038943",
        "Length": 24385
    },
    {
        "Name": "ctgAPLB01038944",
        "Length": 1043
    },
    {
        "Name": "ctgAPLB01038947",
        "Length": 3139
    },
    {
        "Name": "ctgAPLB01038948",
        "Length": 3785
    },
    {
        "Name": "ctgAPLB01038949",
        "Length": 2333
    },
    {
        "Name": "ctgAPLB01038950",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01038951",
        "Length": 982
    },
    {
        "Name": "ctgAPLB01038952",
        "Length": 1049
    },
    {
        "Name": "ctgAPLB01038955",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01038957",
        "Length": 1312
    },
    {
        "Name": "ctgAPLB01038960",
        "Length": 1893
    },
    {
        "Name": "ctgAPLB01038961",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01038962",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01038963",
        "Length": 1419
    },
    {
        "Name": "ctgAPLB01038964",
        "Length": 885
    },
    {
        "Name": "ctgAPLB01038966",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01038967",
        "Length": 386
    },
    {
        "Name": "ctgAPLB01038968",
        "Length": 1203
    },
    {
        "Name": "ctgAPLB01038972",
        "Length": 614
    },
    {
        "Name": "ctgAPLB01038973",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01038974",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01038976",
        "Length": 927
    },
    {
        "Name": "ctgAPLB01038977",
        "Length": 1107
    },
    {
        "Name": "ctgAPLB01038978",
        "Length": 3331
    },
    {
        "Name": "ctgAPLB01038979",
        "Length": 3681
    },
    {
        "Name": "ctgAPLB01038982",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01038983",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01038987",
        "Length": 930
    },
    {
        "Name": "ctgAPLB01038988",
        "Length": 699
    },
    {
        "Name": "ctgAPLB01038989",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01038990",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01038992",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01038994",
        "Length": 652
    },
    {
        "Name": "ctgAPLB01038995",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01038996",
        "Length": 3031
    },
    {
        "Name": "ctgAPLB01039008",
        "Length": 1039
    },
    {
        "Name": "ctgAPLB01039012",
        "Length": 953
    },
    {
        "Name": "ctgAPLB01039013",
        "Length": 3129
    },
    {
        "Name": "ctgAPLB01039014",
        "Length": 765
    },
    {
        "Name": "ctgAPLB01039017",
        "Length": 1080
    },
    {
        "Name": "ctgAPLB01039018",
        "Length": 1339
    },
    {
        "Name": "ctgAPLB01039019",
        "Length": 1346
    },
    {
        "Name": "ctgAPLB01039020",
        "Length": 1479
    },
    {
        "Name": "ctgAPLB01039025",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01039027",
        "Length": 956
    },
    {
        "Name": "ctgAPLB01039028",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01039031",
        "Length": 1091
    },
    {
        "Name": "ctgAPLB01039032",
        "Length": 1871
    },
    {
        "Name": "ctgAPLB01039039",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01039040",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01039041",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01039046",
        "Length": 1325
    },
    {
        "Name": "ctgAPLB01039054",
        "Length": 11749
    },
    {
        "Name": "ctgAPLB01039057",
        "Length": 2003
    },
    {
        "Name": "ctgAPLB01039059",
        "Length": 945
    },
    {
        "Name": "ctgAPLB01039069",
        "Length": 4585
    },
    {
        "Name": "ctgAPLB01039070",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01039072",
        "Length": 6572
    },
    {
        "Name": "ctgAPLB01039073",
        "Length": 767
    },
    {
        "Name": "ctgAPLB01039074",
        "Length": 828
    },
    {
        "Name": "ctgAPLB01039075",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01039076",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01039081",
        "Length": 1226
    },
    {
        "Name": "ctgAPLB01039082",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01039085",
        "Length": 1906
    },
    {
        "Name": "ctgAPLB01039086",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01039089",
        "Length": 957
    },
    {
        "Name": "ctgAPLB01039094",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01039097",
        "Length": 1011
    },
    {
        "Name": "ctgAPLB01039102",
        "Length": 1404
    },
    {
        "Name": "ctgAPLB01039103",
        "Length": 12858
    },
    {
        "Name": "ctgAPLB01039111",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01039120",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01039121",
        "Length": 903
    },
    {
        "Name": "ctgAPLB01039123",
        "Length": 1620
    },
    {
        "Name": "ctgAPLB01039127",
        "Length": 1681
    },
    {
        "Name": "ctgAPLB01039133",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01039134",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01039135",
        "Length": 998
    },
    {
        "Name": "ctgAPLB01039138",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01039139",
        "Length": 1213
    },
    {
        "Name": "ctgAPLB01039144",
        "Length": 2048
    },
    {
        "Name": "ctgAPLB01039145",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01039146",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01039147",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01039148",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01039149",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01039154",
        "Length": 3896
    },
    {
        "Name": "ctgAPLB01039155",
        "Length": 2681
    },
    {
        "Name": "ctgAPLB01039156",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01039157",
        "Length": 1377
    },
    {
        "Name": "ctgAPLB01039158",
        "Length": 4043
    },
    {
        "Name": "ctgAPLB01039159",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01039163",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01039164",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01039165",
        "Length": 2422
    },
    {
        "Name": "ctgAPLB01039166",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01039167",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01039169",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01039170",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01039173",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01039174",
        "Length": 12681
    },
    {
        "Name": "ctgAPLB01039176",
        "Length": 5426
    },
    {
        "Name": "ctgAPLB01039177",
        "Length": 913
    },
    {
        "Name": "ctgAPLB01039179",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01039180",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01039181",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01039182",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01039183",
        "Length": 7435
    },
    {
        "Name": "ctgAPLB01039184",
        "Length": 1440
    },
    {
        "Name": "ctgAPLB01039185",
        "Length": 3460
    },
    {
        "Name": "ctgAPLB01039186",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01039187",
        "Length": 3608
    },
    {
        "Name": "ctgAPLB01039190",
        "Length": 1311
    },
    {
        "Name": "ctgAPLB01039191",
        "Length": 832
    },
    {
        "Name": "ctgAPLB01039192",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01039195",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01039198",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01039204",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01039205",
        "Length": 5497
    },
    {
        "Name": "ctgAPLB01039206",
        "Length": 5793
    },
    {
        "Name": "ctgAPLB01039207",
        "Length": 652
    },
    {
        "Name": "ctgAPLB01039208",
        "Length": 1241
    },
    {
        "Name": "ctgAPLB01039209",
        "Length": 1107
    },
    {
        "Name": "ctgAPLB01039215",
        "Length": 7854
    },
    {
        "Name": "ctgAPLB01039218",
        "Length": 1940
    },
    {
        "Name": "ctgAPLB01039219",
        "Length": 1324
    },
    {
        "Name": "ctgAPLB01039223",
        "Length": 820
    },
    {
        "Name": "ctgAPLB01039227",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01039228",
        "Length": 2521
    },
    {
        "Name": "ctgAPLB01039229",
        "Length": 1344
    },
    {
        "Name": "ctgAPLB01039230",
        "Length": 8512
    },
    {
        "Name": "ctgAPLB01039231",
        "Length": 3234
    },
    {
        "Name": "ctgAPLB01039232",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01039233",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01039237",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01039243",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01039245",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01039251",
        "Length": 1409
    },
    {
        "Name": "ctgAPLB01039254",
        "Length": 3343
    },
    {
        "Name": "ctgAPLB01039255",
        "Length": 589
    },
    {
        "Name": "ctgAPLB01039256",
        "Length": 29844
    },
    {
        "Name": "ctgAPLB01039261",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01039267",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01039268",
        "Length": 1198
    },
    {
        "Name": "ctgAPLB01039269",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01039282",
        "Length": 696
    },
    {
        "Name": "ctgAPLB01039283",
        "Length": 667
    },
    {
        "Name": "ctgAPLB01039284",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01039285",
        "Length": 1555
    },
    {
        "Name": "ctgAPLB01039286",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01039287",
        "Length": 3071
    },
    {
        "Name": "ctgAPLB01039288",
        "Length": 1750
    },
    {
        "Name": "ctgAPLB01039289",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01039290",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01039291",
        "Length": 889
    },
    {
        "Name": "ctgAPLB01039295",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01039299",
        "Length": 739
    },
    {
        "Name": "ctgAPLB01039300",
        "Length": 1252
    },
    {
        "Name": "ctgAPLB01039301",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01039302",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01039303",
        "Length": 1523
    },
    {
        "Name": "ctgAPLB01039304",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01039305",
        "Length": 5437
    },
    {
        "Name": "ctgAPLB01039320",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01039321",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01039337",
        "Length": 1128
    },
    {
        "Name": "ctgAPLB01039345",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01039346",
        "Length": 1421
    },
    {
        "Name": "ctgAPLB01039347",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01039348",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01039352",
        "Length": 8754
    },
    {
        "Name": "ctgAPLB01039353",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01039354",
        "Length": 1617
    },
    {
        "Name": "ctgAPLB01039355",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01039360",
        "Length": 11234
    },
    {
        "Name": "ctgAPLB01039363",
        "Length": 4855
    },
    {
        "Name": "ctgAPLB01039364",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01039365",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01039366",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01039367",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01039368",
        "Length": 17075
    },
    {
        "Name": "ctgAPLB01039371",
        "Length": 943
    },
    {
        "Name": "ctgAPLB01039372",
        "Length": 832
    },
    {
        "Name": "ctgAPLB01039373",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01039381",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01039382",
        "Length": 1163
    },
    {
        "Name": "ctgAPLB01039383",
        "Length": 9096
    },
    {
        "Name": "ctgAPLB01039384",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01039385",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01039386",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01039387",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01039388",
        "Length": 882
    },
    {
        "Name": "ctgAPLB01039389",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01039392",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01039393",
        "Length": 799
    },
    {
        "Name": "ctgAPLB01039394",
        "Length": 621
    },
    {
        "Name": "ctgAPLB01039397",
        "Length": 667
    },
    {
        "Name": "ctgAPLB01039400",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01039403",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01039404",
        "Length": 1503
    },
    {
        "Name": "ctgAPLB01039412",
        "Length": 714
    },
    {
        "Name": "ctgAPLB01039413",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01039414",
        "Length": 461
    },
    {
        "Name": "ctgAPLB01039415",
        "Length": 593
    },
    {
        "Name": "ctgAPLB01039424",
        "Length": 2056
    },
    {
        "Name": "ctgAPLB01039425",
        "Length": 1185
    },
    {
        "Name": "ctgAPLB01039426",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01039427",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01039428",
        "Length": 695
    },
    {
        "Name": "ctgAPLB01039429",
        "Length": 821
    },
    {
        "Name": "ctgAPLB01039430",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01039431",
        "Length": 2898
    },
    {
        "Name": "ctgAPLB01039444",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01039446",
        "Length": 1352
    },
    {
        "Name": "ctgAPLB01039447",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01039452",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01039458",
        "Length": 1080
    },
    {
        "Name": "ctgAPLB01039459",
        "Length": 6369
    },
    {
        "Name": "ctgAPLB01039468",
        "Length": 4468
    },
    {
        "Name": "ctgAPLB01039469",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01039470",
        "Length": 2333
    },
    {
        "Name": "ctgAPLB01039471",
        "Length": 1313
    },
    {
        "Name": "ctgAPLB01039472",
        "Length": 2290
    },
    {
        "Name": "ctgAPLB01039473",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01039474",
        "Length": 8262
    },
    {
        "Name": "ctgAPLB01039477",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01039480",
        "Length": 3882
    },
    {
        "Name": "ctgAPLB01039485",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01039486",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01039487",
        "Length": 956
    },
    {
        "Name": "ctgAPLB01039488",
        "Length": 3924
    },
    {
        "Name": "ctgAPLB01039489",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01039493",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01039494",
        "Length": 1684
    },
    {
        "Name": "ctgAPLB01039495",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01039499",
        "Length": 1124
    },
    {
        "Name": "ctgAPLB01039501",
        "Length": 733
    },
    {
        "Name": "ctgAPLB01039502",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01039504",
        "Length": 1764
    },
    {
        "Name": "ctgAPLB01039507",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01039508",
        "Length": 2565
    },
    {
        "Name": "ctgAPLB01039509",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01039510",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01039513",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01039516",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01039521",
        "Length": 1090
    },
    {
        "Name": "ctgAPLB01039526",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01039527",
        "Length": 1220
    },
    {
        "Name": "ctgAPLB01039528",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01039529",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01039530",
        "Length": 1379
    },
    {
        "Name": "ctgAPLB01039531",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01039532",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01039533",
        "Length": 1052
    },
    {
        "Name": "ctgAPLB01039534",
        "Length": 1245
    },
    {
        "Name": "ctgAPLB01039535",
        "Length": 819
    },
    {
        "Name": "ctgAPLB01039536",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01039537",
        "Length": 1489
    },
    {
        "Name": "ctgAPLB01039538",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01039539",
        "Length": 1358
    },
    {
        "Name": "ctgAPLB01039540",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01039541",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01039542",
        "Length": 1208
    },
    {
        "Name": "ctgAPLB01039543",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01039544",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01039545",
        "Length": 933
    },
    {
        "Name": "ctgAPLB01039546",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01039547",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01039548",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01039551",
        "Length": 614
    },
    {
        "Name": "ctgAPLB01039554",
        "Length": 1000
    },
    {
        "Name": "ctgAPLB01039555",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01039556",
        "Length": 1638
    },
    {
        "Name": "ctgAPLB01039572",
        "Length": 752
    },
    {
        "Name": "ctgAPLB01039577",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01039578",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01039579",
        "Length": 987
    },
    {
        "Name": "ctgAPLB01039587",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01039588",
        "Length": 1107
    },
    {
        "Name": "ctgAPLB01039589",
        "Length": 801
    },
    {
        "Name": "ctgAPLB01039590",
        "Length": 537
    },
    {
        "Name": "ctgAPLB01039596",
        "Length": 581
    },
    {
        "Name": "ctgAPLB01039599",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01039600",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01039601",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01039607",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01039611",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01039612",
        "Length": 737
    },
    {
        "Name": "ctgAPLB01039617",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01039618",
        "Length": 1185
    },
    {
        "Name": "ctgAPLB01039624",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01039625",
        "Length": 1449
    },
    {
        "Name": "ctgAPLB01039629",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01039630",
        "Length": 2480
    },
    {
        "Name": "ctgAPLB01039631",
        "Length": 3775
    },
    {
        "Name": "ctgAPLB01039634",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01039635",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01039636",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01039637",
        "Length": 1181
    },
    {
        "Name": "ctgAPLB01039638",
        "Length": 790
    },
    {
        "Name": "ctgAPLB01039641",
        "Length": 1022
    },
    {
        "Name": "ctgAPLB01039642",
        "Length": 842
    },
    {
        "Name": "ctgAPLB01039643",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01039646",
        "Length": 2486
    },
    {
        "Name": "ctgAPLB01039648",
        "Length": 1152
    },
    {
        "Name": "ctgAPLB01039649",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01039650",
        "Length": 788
    },
    {
        "Name": "ctgAPLB01039651",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01039652",
        "Length": 744
    },
    {
        "Name": "ctgAPLB01039653",
        "Length": 1087
    },
    {
        "Name": "ctgAPLB01039654",
        "Length": 847
    },
    {
        "Name": "ctgAPLB01039655",
        "Length": 1723
    },
    {
        "Name": "ctgAPLB01039656",
        "Length": 7105
    },
    {
        "Name": "ctgAPLB01039658",
        "Length": 2506
    },
    {
        "Name": "ctgAPLB01039659",
        "Length": 3014
    },
    {
        "Name": "ctgAPLB01039662",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01039663",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01039664",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01039670",
        "Length": 1767
    },
    {
        "Name": "ctgAPLB01039671",
        "Length": 844
    },
    {
        "Name": "ctgAPLB01039675",
        "Length": 3704
    },
    {
        "Name": "ctgAPLB01039689",
        "Length": 799
    },
    {
        "Name": "ctgAPLB01039690",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01039699",
        "Length": 594
    },
    {
        "Name": "ctgAPLB01039700",
        "Length": 807
    },
    {
        "Name": "ctgAPLB01039703",
        "Length": 1191
    },
    {
        "Name": "ctgAPLB01039708",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01039709",
        "Length": 1088
    },
    {
        "Name": "ctgAPLB01039712",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01039713",
        "Length": 7404
    },
    {
        "Name": "ctgAPLB01039714",
        "Length": 1456
    },
    {
        "Name": "ctgAPLB01039715",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01039716",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01039717",
        "Length": 1148
    },
    {
        "Name": "ctgAPLB01039718",
        "Length": 694
    },
    {
        "Name": "ctgAPLB01039719",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01039724",
        "Length": 767
    },
    {
        "Name": "ctgAPLB01039725",
        "Length": 804
    },
    {
        "Name": "ctgAPLB01039732",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01039733",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01039734",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01039735",
        "Length": 1293
    },
    {
        "Name": "ctgAPLB01039739",
        "Length": 1805
    },
    {
        "Name": "ctgAPLB01039740",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01039741",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01039745",
        "Length": 1380
    },
    {
        "Name": "ctgAPLB01039746",
        "Length": 697
    },
    {
        "Name": "ctgAPLB01039747",
        "Length": 3143
    },
    {
        "Name": "ctgAPLB01039748",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01039749",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01039750",
        "Length": 825
    },
    {
        "Name": "ctgAPLB01039751",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01039753",
        "Length": 844
    },
    {
        "Name": "ctgAPLB01039754",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01039760",
        "Length": 891
    },
    {
        "Name": "ctgAPLB01039764",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01039765",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01039766",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01039767",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01039769",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01039770",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01039775",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01039776",
        "Length": 3011
    },
    {
        "Name": "ctgAPLB01039781",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01039782",
        "Length": 999
    },
    {
        "Name": "ctgAPLB01039786",
        "Length": 1412
    },
    {
        "Name": "ctgAPLB01039787",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01039794",
        "Length": 880
    },
    {
        "Name": "ctgAPLB01039795",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01039798",
        "Length": 24967
    },
    {
        "Name": "ctgAPLB01039799",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01039800",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01039801",
        "Length": 959
    },
    {
        "Name": "ctgAPLB01039802",
        "Length": 1469
    },
    {
        "Name": "ctgAPLB01039803",
        "Length": 1166
    },
    {
        "Name": "ctgAPLB01039804",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01039809",
        "Length": 2901
    },
    {
        "Name": "ctgAPLB01039810",
        "Length": 696
    },
    {
        "Name": "ctgAPLB01039811",
        "Length": 1816
    },
    {
        "Name": "ctgAPLB01039817",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01039820",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01039821",
        "Length": 836
    },
    {
        "Name": "ctgAPLB01039822",
        "Length": 3967
    },
    {
        "Name": "ctgAPLB01039823",
        "Length": 821
    },
    {
        "Name": "ctgAPLB01039824",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01039825",
        "Length": 874
    },
    {
        "Name": "ctgAPLB01039826",
        "Length": 4789
    },
    {
        "Name": "ctgAPLB01039829",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01039830",
        "Length": 6038
    },
    {
        "Name": "ctgAPLB01039831",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01039832",
        "Length": 1035
    },
    {
        "Name": "ctgAPLB01039833",
        "Length": 5424
    },
    {
        "Name": "ctgAPLB01039834",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01039837",
        "Length": 1291
    },
    {
        "Name": "ctgAPLB01039838",
        "Length": 1194
    },
    {
        "Name": "ctgAPLB01039839",
        "Length": 915
    },
    {
        "Name": "ctgAPLB01039840",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01039845",
        "Length": 961
    },
    {
        "Name": "ctgAPLB01039846",
        "Length": 1363
    },
    {
        "Name": "ctgAPLB01039847",
        "Length": 1309
    },
    {
        "Name": "ctgAPLB01039850",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01039851",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01039852",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01039854",
        "Length": 1171
    },
    {
        "Name": "ctgAPLB01039857",
        "Length": 7208
    },
    {
        "Name": "ctgAPLB01039858",
        "Length": 916
    },
    {
        "Name": "ctgAPLB01039859",
        "Length": 2093
    },
    {
        "Name": "ctgAPLB01039860",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01039861",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01039862",
        "Length": 905
    },
    {
        "Name": "ctgAPLB01039863",
        "Length": 1297
    },
    {
        "Name": "ctgAPLB01039866",
        "Length": 5807
    },
    {
        "Name": "ctgAPLB01039869",
        "Length": 858
    },
    {
        "Name": "ctgAPLB01039870",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01039871",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01039879",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01039880",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01039881",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01039882",
        "Length": 1319
    },
    {
        "Name": "ctgAPLB01039883",
        "Length": 1077
    },
    {
        "Name": "ctgAPLB01039884",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01039885",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01039886",
        "Length": 862
    },
    {
        "Name": "ctgAPLB01039887",
        "Length": 1125
    },
    {
        "Name": "ctgAPLB01039888",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01039889",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01039890",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01039891",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01039894",
        "Length": 858
    },
    {
        "Name": "ctgAPLB01039899",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01039900",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01039901",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01039902",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01039905",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01039906",
        "Length": 1461
    },
    {
        "Name": "ctgAPLB01039907",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01039909",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01039910",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01039911",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01039912",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01039915",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01039916",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01039917",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01039919",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01039929",
        "Length": 840
    },
    {
        "Name": "ctgAPLB01039930",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01039933",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01039936",
        "Length": 461
    },
    {
        "Name": "ctgAPLB01039937",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01039938",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01039939",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01039940",
        "Length": 3855
    },
    {
        "Name": "ctgAPLB01039941",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01039946",
        "Length": 1540
    },
    {
        "Name": "ctgAPLB01039947",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01039961",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01039964",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01039965",
        "Length": 601
    },
    {
        "Name": "ctgAPLB01039970",
        "Length": 799
    },
    {
        "Name": "ctgAPLB01039971",
        "Length": 2285
    },
    {
        "Name": "ctgAPLB01039972",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01039973",
        "Length": 836
    },
    {
        "Name": "ctgAPLB01039974",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01039977",
        "Length": 1088
    },
    {
        "Name": "ctgAPLB01039978",
        "Length": 1026
    },
    {
        "Name": "ctgAPLB01039979",
        "Length": 18816
    },
    {
        "Name": "ctgAPLB01039983",
        "Length": 1409
    },
    {
        "Name": "ctgAPLB01039984",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01039985",
        "Length": 820
    },
    {
        "Name": "ctgAPLB01039986",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01039987",
        "Length": 1030
    },
    {
        "Name": "ctgAPLB01039988",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01039989",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01039990",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01039991",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01039992",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01039994",
        "Length": 801
    },
    {
        "Name": "ctgAPLB01040002",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01040004",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01040008",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01040009",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01040010",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01040014",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01040015",
        "Length": 1575
    },
    {
        "Name": "ctgAPLB01040016",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01040018",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01040019",
        "Length": 979
    },
    {
        "Name": "ctgAPLB01040020",
        "Length": 1607
    },
    {
        "Name": "ctgAPLB01040021",
        "Length": 1262
    },
    {
        "Name": "ctgAPLB01040022",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01040023",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01040024",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01040032",
        "Length": 962
    },
    {
        "Name": "ctgAPLB01040033",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01040034",
        "Length": 1878
    },
    {
        "Name": "ctgAPLB01040035",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01040036",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01040037",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01040040",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01040041",
        "Length": 820
    },
    {
        "Name": "ctgAPLB01040045",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01040048",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01040049",
        "Length": 1607
    },
    {
        "Name": "ctgAPLB01040050",
        "Length": 1505
    },
    {
        "Name": "ctgAPLB01040054",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01040055",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01040056",
        "Length": 3107
    },
    {
        "Name": "ctgAPLB01040057",
        "Length": 4164
    },
    {
        "Name": "ctgAPLB01040058",
        "Length": 1648
    },
    {
        "Name": "ctgAPLB01040061",
        "Length": 878
    },
    {
        "Name": "ctgAPLB01040063",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01040064",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01040065",
        "Length": 689
    },
    {
        "Name": "ctgAPLB01040066",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01040067",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01040068",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01040070",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01040076",
        "Length": 2044
    },
    {
        "Name": "ctgAPLB01040077",
        "Length": 715
    },
    {
        "Name": "ctgAPLB01040080",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01040081",
        "Length": 3884
    },
    {
        "Name": "ctgAPLB01040082",
        "Length": 1123
    },
    {
        "Name": "ctgAPLB01040088",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01040089",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01040092",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01040093",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01040094",
        "Length": 3089
    },
    {
        "Name": "ctgAPLB01040097",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01040102",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01040103",
        "Length": 1462
    },
    {
        "Name": "ctgAPLB01040106",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01040109",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01040110",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01040113",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01040115",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01040116",
        "Length": 2215
    },
    {
        "Name": "ctgAPLB01040117",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01040119",
        "Length": 1630
    },
    {
        "Name": "ctgAPLB01040124",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01040125",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01040126",
        "Length": 2794
    },
    {
        "Name": "ctgAPLB01040127",
        "Length": 7276
    },
    {
        "Name": "ctgAPLB01040128",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01040129",
        "Length": 3073
    },
    {
        "Name": "ctgAPLB01040132",
        "Length": 828
    },
    {
        "Name": "ctgAPLB01040133",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01040134",
        "Length": 726
    },
    {
        "Name": "ctgAPLB01040140",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01040141",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01040142",
        "Length": 2767
    },
    {
        "Name": "ctgAPLB01040143",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01040148",
        "Length": 832
    },
    {
        "Name": "ctgAPLB01040155",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01040156",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01040159",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01040171",
        "Length": 943
    },
    {
        "Name": "ctgAPLB01040174",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01040175",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01040178",
        "Length": 4993
    },
    {
        "Name": "ctgAPLB01040179",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01040180",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01040181",
        "Length": 1447
    },
    {
        "Name": "ctgAPLB01040184",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01040185",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01040186",
        "Length": 1051
    },
    {
        "Name": "ctgAPLB01040187",
        "Length": 651
    },
    {
        "Name": "ctgAPLB01040188",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01040189",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01040190",
        "Length": 1379
    },
    {
        "Name": "ctgAPLB01040193",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01040195",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01040202",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01040203",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01040204",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01040205",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01040206",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01040210",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01040211",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01040219",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01040220",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01040221",
        "Length": 1047
    },
    {
        "Name": "ctgAPLB01040228",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01040231",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01040232",
        "Length": 4388
    },
    {
        "Name": "ctgAPLB01040235",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01040240",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01040241",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01040242",
        "Length": 1565
    },
    {
        "Name": "ctgAPLB01040243",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01040246",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01040247",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01040248",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01040249",
        "Length": 2653
    },
    {
        "Name": "ctgAPLB01040252",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01040254",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01040256",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01040258",
        "Length": 900
    },
    {
        "Name": "ctgAPLB01040259",
        "Length": 913
    },
    {
        "Name": "ctgAPLB01040263",
        "Length": 10729
    },
    {
        "Name": "ctgAPLB01040266",
        "Length": 1180
    },
    {
        "Name": "ctgAPLB01040270",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01040271",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01040272",
        "Length": 1142
    },
    {
        "Name": "ctgAPLB01040273",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01040277",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01040278",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01040280",
        "Length": 3388
    },
    {
        "Name": "ctgAPLB01040286",
        "Length": 1628
    },
    {
        "Name": "ctgAPLB01040287",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01040288",
        "Length": 754
    },
    {
        "Name": "ctgAPLB01040289",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01040290",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01040297",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01040298",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01040299",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01040301",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01040311",
        "Length": 806
    },
    {
        "Name": "ctgAPLB01040312",
        "Length": 4956
    },
    {
        "Name": "ctgAPLB01040313",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01040314",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01040315",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01040318",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01040319",
        "Length": 1203
    },
    {
        "Name": "ctgAPLB01040320",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01040321",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01040322",
        "Length": 1423
    },
    {
        "Name": "ctgAPLB01040323",
        "Length": 1094
    },
    {
        "Name": "ctgAPLB01040326",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01040330",
        "Length": 936
    },
    {
        "Name": "ctgAPLB01040331",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01040336",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01040337",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01040342",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01040343",
        "Length": 887
    },
    {
        "Name": "ctgAPLB01040346",
        "Length": 1367
    },
    {
        "Name": "ctgAPLB01040351",
        "Length": 1166
    },
    {
        "Name": "ctgAPLB01040352",
        "Length": 876
    },
    {
        "Name": "ctgAPLB01040353",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01040354",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01040358",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01040359",
        "Length": 1073
    },
    {
        "Name": "ctgAPLB01040360",
        "Length": 1088
    },
    {
        "Name": "ctgAPLB01040369",
        "Length": 857
    },
    {
        "Name": "ctgAPLB01040370",
        "Length": 694
    },
    {
        "Name": "ctgAPLB01040371",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01040372",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01040373",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01040374",
        "Length": 968
    },
    {
        "Name": "ctgAPLB01040375",
        "Length": 1631
    },
    {
        "Name": "ctgAPLB01040376",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01040379",
        "Length": 871
    },
    {
        "Name": "ctgAPLB01040380",
        "Length": 706
    },
    {
        "Name": "ctgAPLB01040381",
        "Length": 2963
    },
    {
        "Name": "ctgAPLB01040382",
        "Length": 3208
    },
    {
        "Name": "ctgAPLB01040383",
        "Length": 856
    },
    {
        "Name": "ctgAPLB01040384",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01040385",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01040386",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01040387",
        "Length": 3419
    },
    {
        "Name": "ctgAPLB01040388",
        "Length": 890
    },
    {
        "Name": "ctgAPLB01040391",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01040394",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01040395",
        "Length": 1166
    },
    {
        "Name": "ctgAPLB01040396",
        "Length": 1769
    },
    {
        "Name": "ctgAPLB01040397",
        "Length": 2022
    },
    {
        "Name": "ctgAPLB01040398",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01040399",
        "Length": 1248
    },
    {
        "Name": "ctgAPLB01040400",
        "Length": 1334
    },
    {
        "Name": "ctgAPLB01040403",
        "Length": 439
    },
    {
        "Name": "ctgAPLB01040404",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01040405",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01040410",
        "Length": 2488
    },
    {
        "Name": "ctgAPLB01040411",
        "Length": 1136
    },
    {
        "Name": "ctgAPLB01040412",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01040416",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01040419",
        "Length": 700
    },
    {
        "Name": "ctgAPLB01040424",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01040425",
        "Length": 1524
    },
    {
        "Name": "ctgAPLB01040426",
        "Length": 5032
    },
    {
        "Name": "ctgAPLB01040428",
        "Length": 13189
    },
    {
        "Name": "ctgAPLB01040435",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01040439",
        "Length": 3803
    },
    {
        "Name": "ctgAPLB01040440",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01040441",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01040442",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01040443",
        "Length": 6306
    },
    {
        "Name": "ctgAPLB01040444",
        "Length": 1876
    },
    {
        "Name": "ctgAPLB01040445",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01040448",
        "Length": 1278
    },
    {
        "Name": "ctgAPLB01040449",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01040450",
        "Length": 1600
    },
    {
        "Name": "ctgAPLB01040451",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01040452",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01040453",
        "Length": 1799
    },
    {
        "Name": "ctgAPLB01040456",
        "Length": 1327
    },
    {
        "Name": "ctgAPLB01040459",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01040460",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01040461",
        "Length": 2171
    },
    {
        "Name": "ctgAPLB01040462",
        "Length": 2746
    },
    {
        "Name": "ctgAPLB01040463",
        "Length": 1180
    },
    {
        "Name": "ctgAPLB01040464",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01040465",
        "Length": 1178
    },
    {
        "Name": "ctgAPLB01040466",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01040467",
        "Length": 5304
    },
    {
        "Name": "ctgAPLB01040468",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01040469",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01040470",
        "Length": 1313
    },
    {
        "Name": "ctgAPLB01040471",
        "Length": 1091
    },
    {
        "Name": "ctgAPLB01040476",
        "Length": 4019
    },
    {
        "Name": "ctgAPLB01040477",
        "Length": 1498
    },
    {
        "Name": "ctgAPLB01040478",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01040479",
        "Length": 1310
    },
    {
        "Name": "ctgAPLB01040480",
        "Length": 994
    },
    {
        "Name": "ctgAPLB01040481",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01040482",
        "Length": 7283
    },
    {
        "Name": "ctgAPLB01040483",
        "Length": 1191
    },
    {
        "Name": "ctgAPLB01040484",
        "Length": 1129
    },
    {
        "Name": "ctgAPLB01040485",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01040486",
        "Length": 1807
    },
    {
        "Name": "ctgAPLB01040487",
        "Length": 926
    },
    {
        "Name": "ctgAPLB01040490",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01040491",
        "Length": 24558
    },
    {
        "Name": "ctgAPLB01040494",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01040495",
        "Length": 2911
    },
    {
        "Name": "ctgAPLB01040496",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01040497",
        "Length": 1015
    },
    {
        "Name": "ctgAPLB01040498",
        "Length": 1202
    },
    {
        "Name": "ctgAPLB01040499",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01040500",
        "Length": 873
    },
    {
        "Name": "ctgAPLB01040501",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01040502",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01040505",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01040506",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01040507",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01040508",
        "Length": 3254
    },
    {
        "Name": "ctgAPLB01040509",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01040512",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01040513",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01040514",
        "Length": 3549
    },
    {
        "Name": "ctgAPLB01040515",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01040516",
        "Length": 934
    },
    {
        "Name": "ctgAPLB01040518",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01040519",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01040520",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01040521",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01040522",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01040526",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01040527",
        "Length": 842
    },
    {
        "Name": "ctgAPLB01040528",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01040529",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01040530",
        "Length": 3798
    },
    {
        "Name": "ctgAPLB01040532",
        "Length": 1019
    },
    {
        "Name": "ctgAPLB01040533",
        "Length": 2103
    },
    {
        "Name": "ctgAPLB01040534",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01040535",
        "Length": 656
    },
    {
        "Name": "ctgAPLB01040536",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01040537",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01040538",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01040539",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01040544",
        "Length": 702
    },
    {
        "Name": "ctgAPLB01040549",
        "Length": 14108
    },
    {
        "Name": "ctgAPLB01040550",
        "Length": 684
    },
    {
        "Name": "ctgAPLB01040551",
        "Length": 1981
    },
    {
        "Name": "ctgAPLB01040552",
        "Length": 3687
    },
    {
        "Name": "ctgAPLB01040555",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01040556",
        "Length": 11988
    },
    {
        "Name": "ctgAPLB01040557",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01040558",
        "Length": 3571
    },
    {
        "Name": "ctgAPLB01040559",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01040560",
        "Length": 1079
    },
    {
        "Name": "ctgAPLB01040561",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01040563",
        "Length": 2663
    },
    {
        "Name": "ctgAPLB01040564",
        "Length": 879
    },
    {
        "Name": "ctgAPLB01040565",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01040566",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01040574",
        "Length": 945
    },
    {
        "Name": "ctgAPLB01040579",
        "Length": 1218
    },
    {
        "Name": "ctgAPLB01040580",
        "Length": 966
    },
    {
        "Name": "ctgAPLB01040581",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01040582",
        "Length": 3757
    },
    {
        "Name": "ctgAPLB01040584",
        "Length": 2546
    },
    {
        "Name": "ctgAPLB01040585",
        "Length": 1364
    },
    {
        "Name": "ctgAPLB01040590",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01040591",
        "Length": 1345
    },
    {
        "Name": "ctgAPLB01040592",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01040593",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01040594",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01040595",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01040597",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01040598",
        "Length": 1391
    },
    {
        "Name": "ctgAPLB01040605",
        "Length": 1728
    },
    {
        "Name": "ctgAPLB01040606",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01040609",
        "Length": 1333
    },
    {
        "Name": "ctgAPLB01040610",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01040611",
        "Length": 970
    },
    {
        "Name": "ctgAPLB01040613",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01040614",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01040615",
        "Length": 601
    },
    {
        "Name": "ctgAPLB01040616",
        "Length": 3680
    },
    {
        "Name": "ctgAPLB01040617",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01040618",
        "Length": 862
    },
    {
        "Name": "ctgAPLB01040620",
        "Length": 2651
    },
    {
        "Name": "ctgAPLB01040623",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01040624",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01040627",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01040630",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01040631",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01040632",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01040636",
        "Length": 1604
    },
    {
        "Name": "ctgAPLB01040637",
        "Length": 848
    },
    {
        "Name": "ctgAPLB01040638",
        "Length": 2903
    },
    {
        "Name": "ctgAPLB01040639",
        "Length": 1411
    },
    {
        "Name": "ctgAPLB01040640",
        "Length": 576
    },
    {
        "Name": "ctgAPLB01040641",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01040642",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01040643",
        "Length": 689
    },
    {
        "Name": "ctgAPLB01040644",
        "Length": 1154
    },
    {
        "Name": "ctgAPLB01040647",
        "Length": 1270
    },
    {
        "Name": "ctgAPLB01040648",
        "Length": 1490
    },
    {
        "Name": "ctgAPLB01040649",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01040650",
        "Length": 10604
    },
    {
        "Name": "ctgAPLB01040651",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01040652",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01040653",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01040654",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01040656",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01040657",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01040658",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01040659",
        "Length": 2297
    },
    {
        "Name": "ctgAPLB01040660",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01040661",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01040662",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01040663",
        "Length": 1038
    },
    {
        "Name": "ctgAPLB01040664",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01040673",
        "Length": 1305
    },
    {
        "Name": "ctgAPLB01040674",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01040675",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01040676",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01040677",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01040680",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01040681",
        "Length": 1506
    },
    {
        "Name": "ctgAPLB01040682",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01040683",
        "Length": 1311
    },
    {
        "Name": "ctgAPLB01040684",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01040686",
        "Length": 1183
    },
    {
        "Name": "ctgAPLB01040687",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01040688",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01040689",
        "Length": 1461
    },
    {
        "Name": "ctgAPLB01040692",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01040693",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01040695",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01040696",
        "Length": 873
    },
    {
        "Name": "ctgAPLB01040702",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01040703",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01040704",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01040707",
        "Length": 2469
    },
    {
        "Name": "ctgAPLB01040708",
        "Length": 1741
    },
    {
        "Name": "ctgAPLB01040711",
        "Length": 1323
    },
    {
        "Name": "ctgAPLB01040715",
        "Length": 3216
    },
    {
        "Name": "ctgAPLB01040716",
        "Length": 3209
    },
    {
        "Name": "ctgAPLB01040717",
        "Length": 1221
    },
    {
        "Name": "ctgAPLB01040718",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01040721",
        "Length": 2257
    },
    {
        "Name": "ctgAPLB01040722",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01040723",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01040724",
        "Length": 4573
    },
    {
        "Name": "ctgAPLB01040725",
        "Length": 1769
    },
    {
        "Name": "ctgAPLB01040727",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01040730",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01040732",
        "Length": 697
    },
    {
        "Name": "ctgAPLB01040733",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01040734",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01040741",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01040746",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01040747",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01040750",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01040751",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01040754",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01040755",
        "Length": 991
    },
    {
        "Name": "ctgAPLB01040758",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01040761",
        "Length": 1848
    },
    {
        "Name": "ctgAPLB01040762",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01040763",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01040764",
        "Length": 929
    },
    {
        "Name": "ctgAPLB01040765",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01040766",
        "Length": 1777
    },
    {
        "Name": "ctgAPLB01040767",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01040768",
        "Length": 654
    },
    {
        "Name": "ctgAPLB01040769",
        "Length": 904
    },
    {
        "Name": "ctgAPLB01040770",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01040773",
        "Length": 1321
    },
    {
        "Name": "ctgAPLB01040774",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01040775",
        "Length": 13945
    },
    {
        "Name": "ctgAPLB01040778",
        "Length": 2189
    },
    {
        "Name": "ctgAPLB01040779",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01040780",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01040785",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01040788",
        "Length": 1165
    },
    {
        "Name": "ctgAPLB01040791",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01040792",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01040795",
        "Length": 552
    },
    {
        "Name": "ctgAPLB01040802",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01040803",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01040804",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01040805",
        "Length": 1560
    },
    {
        "Name": "ctgAPLB01040806",
        "Length": 941
    },
    {
        "Name": "ctgAPLB01040807",
        "Length": 1241
    },
    {
        "Name": "ctgAPLB01040808",
        "Length": 1165
    },
    {
        "Name": "ctgAPLB01040811",
        "Length": 782
    },
    {
        "Name": "ctgAPLB01040812",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01040813",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01040814",
        "Length": 1525
    },
    {
        "Name": "ctgAPLB01040815",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01040816",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01040817",
        "Length": 1283
    },
    {
        "Name": "ctgAPLB01040818",
        "Length": 4512
    },
    {
        "Name": "ctgAPLB01040819",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01040824",
        "Length": 2535
    },
    {
        "Name": "ctgAPLB01040825",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01040826",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01040829",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01040830",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01040836",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01040837",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01040841",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01040842",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01040843",
        "Length": 1201
    },
    {
        "Name": "ctgAPLB01040844",
        "Length": 920
    },
    {
        "Name": "ctgAPLB01040845",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01040848",
        "Length": 863
    },
    {
        "Name": "ctgAPLB01040849",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01040850",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01040851",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01040852",
        "Length": 3057
    },
    {
        "Name": "ctgAPLB01040853",
        "Length": 1847
    },
    {
        "Name": "ctgAPLB01040854",
        "Length": 876
    },
    {
        "Name": "ctgAPLB01040857",
        "Length": 825
    },
    {
        "Name": "ctgAPLB01040858",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01040859",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01040860",
        "Length": 1019
    },
    {
        "Name": "ctgAPLB01040861",
        "Length": 856
    },
    {
        "Name": "ctgAPLB01040862",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01040863",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01040864",
        "Length": 2481
    },
    {
        "Name": "ctgAPLB01040867",
        "Length": 801
    },
    {
        "Name": "ctgAPLB01040868",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01040869",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01040873",
        "Length": 1062
    },
    {
        "Name": "ctgAPLB01040874",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01040875",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01040877",
        "Length": 1632
    },
    {
        "Name": "ctgAPLB01040878",
        "Length": 1267
    },
    {
        "Name": "ctgAPLB01040879",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01040880",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01040881",
        "Length": 1931
    },
    {
        "Name": "ctgAPLB01040882",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01040885",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01040886",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01040890",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01040894",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01040897",
        "Length": 669
    },
    {
        "Name": "ctgAPLB01040898",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01040900",
        "Length": 669
    },
    {
        "Name": "ctgAPLB01040901",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01040902",
        "Length": 726
    },
    {
        "Name": "ctgAPLB01040903",
        "Length": 456
    },
    {
        "Name": "ctgAPLB01040906",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01040907",
        "Length": 590
    },
    {
        "Name": "ctgAPLB01040908",
        "Length": 1171
    },
    {
        "Name": "ctgAPLB01040909",
        "Length": 619
    },
    {
        "Name": "ctgAPLB01040910",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01040911",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01040912",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01040915",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01040916",
        "Length": 989
    },
    {
        "Name": "ctgAPLB01040917",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01040921",
        "Length": 1522
    },
    {
        "Name": "ctgAPLB01040926",
        "Length": 665
    },
    {
        "Name": "ctgAPLB01040927",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01040928",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01040932",
        "Length": 790
    },
    {
        "Name": "ctgAPLB01040933",
        "Length": 1218
    },
    {
        "Name": "ctgAPLB01040938",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01040941",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01040944",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01040945",
        "Length": 929
    },
    {
        "Name": "ctgAPLB01040949",
        "Length": 2542
    },
    {
        "Name": "ctgAPLB01040953",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01040954",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01040955",
        "Length": 697
    },
    {
        "Name": "ctgAPLB01040956",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01040960",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01040961",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01040962",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01040963",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01040964",
        "Length": 4550
    },
    {
        "Name": "ctgAPLB01040965",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01040966",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01040967",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01040968",
        "Length": 1100
    },
    {
        "Name": "ctgAPLB01040969",
        "Length": 2295
    },
    {
        "Name": "ctgAPLB01040970",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01040971",
        "Length": 1406
    },
    {
        "Name": "ctgAPLB01040972",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01040973",
        "Length": 2272
    },
    {
        "Name": "ctgAPLB01040974",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01040976",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01040977",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01040978",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01040979",
        "Length": 955
    },
    {
        "Name": "ctgAPLB01040980",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01040981",
        "Length": 1150
    },
    {
        "Name": "ctgAPLB01040984",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01040987",
        "Length": 1414
    },
    {
        "Name": "ctgAPLB01040988",
        "Length": 1076
    },
    {
        "Name": "ctgAPLB01040991",
        "Length": 2490
    },
    {
        "Name": "ctgAPLB01040992",
        "Length": 936
    },
    {
        "Name": "ctgAPLB01040993",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01040994",
        "Length": 850
    },
    {
        "Name": "ctgAPLB01041004",
        "Length": 4601
    },
    {
        "Name": "ctgAPLB01041005",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01041006",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01041009",
        "Length": 1103
    },
    {
        "Name": "ctgAPLB01041010",
        "Length": 1945
    },
    {
        "Name": "ctgAPLB01041011",
        "Length": 1295
    },
    {
        "Name": "ctgAPLB01041012",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01041013",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01041014",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01041015",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01041016",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01041017",
        "Length": 2494
    },
    {
        "Name": "ctgAPLB01041018",
        "Length": 1224
    },
    {
        "Name": "ctgAPLB01041019",
        "Length": 636
    },
    {
        "Name": "ctgAPLB01041020",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01041021",
        "Length": 801
    },
    {
        "Name": "ctgAPLB01041022",
        "Length": 2705
    },
    {
        "Name": "ctgAPLB01041023",
        "Length": 715
    },
    {
        "Name": "ctgAPLB01041024",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01041025",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01041026",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01041027",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01041028",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01041029",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01041030",
        "Length": 3399
    },
    {
        "Name": "ctgAPLB01041034",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01041037",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01041038",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01041039",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01041043",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01041044",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01041045",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01041046",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01041049",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01041050",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01041051",
        "Length": 686
    },
    {
        "Name": "ctgAPLB01041052",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01041053",
        "Length": 925
    },
    {
        "Name": "ctgAPLB01041054",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01041055",
        "Length": 1301
    },
    {
        "Name": "ctgAPLB01041056",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01041057",
        "Length": 1065
    },
    {
        "Name": "ctgAPLB01041058",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01041059",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01041062",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01041064",
        "Length": 1160
    },
    {
        "Name": "ctgAPLB01041065",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01041066",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01041067",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01041068",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01041069",
        "Length": 5167
    },
    {
        "Name": "ctgAPLB01041070",
        "Length": 1676
    },
    {
        "Name": "ctgAPLB01041073",
        "Length": 2175
    },
    {
        "Name": "ctgAPLB01041074",
        "Length": 1118
    },
    {
        "Name": "ctgAPLB01041078",
        "Length": 1196
    },
    {
        "Name": "ctgAPLB01041079",
        "Length": 402
    },
    {
        "Name": "ctgAPLB01041081",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01041082",
        "Length": 1151
    },
    {
        "Name": "ctgAPLB01041083",
        "Length": 745
    },
    {
        "Name": "ctgAPLB01041084",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01041088",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01041092",
        "Length": 562
    },
    {
        "Name": "ctgAPLB01041093",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01041094",
        "Length": 916
    },
    {
        "Name": "ctgAPLB01041099",
        "Length": 939
    },
    {
        "Name": "ctgAPLB01041100",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01041101",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01041102",
        "Length": 887
    },
    {
        "Name": "ctgAPLB01041103",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01041104",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01041105",
        "Length": 3186
    },
    {
        "Name": "ctgAPLB01041106",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01041107",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01041108",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01041111",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01041112",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01041115",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01041116",
        "Length": 913
    },
    {
        "Name": "ctgAPLB01041117",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01041120",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01041121",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01041122",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01041125",
        "Length": 1074
    },
    {
        "Name": "ctgAPLB01041126",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01041127",
        "Length": 1276
    },
    {
        "Name": "ctgAPLB01041134",
        "Length": 1095
    },
    {
        "Name": "ctgAPLB01041135",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01041136",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01041137",
        "Length": 1639
    },
    {
        "Name": "ctgAPLB01041141",
        "Length": 927
    },
    {
        "Name": "ctgAPLB01041143",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01041144",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01041145",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01041146",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01041147",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01041148",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01041149",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01041151",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01041152",
        "Length": 726
    },
    {
        "Name": "ctgAPLB01041153",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01041154",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01041156",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01041157",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01041161",
        "Length": 4594
    },
    {
        "Name": "ctgAPLB01041164",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01041165",
        "Length": 1942
    },
    {
        "Name": "ctgAPLB01041174",
        "Length": 409
    },
    {
        "Name": "ctgAPLB01041176",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01041177",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01041178",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01041179",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01041180",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01041181",
        "Length": 866
    },
    {
        "Name": "ctgAPLB01041184",
        "Length": 1033
    },
    {
        "Name": "ctgAPLB01041185",
        "Length": 1454
    },
    {
        "Name": "ctgAPLB01041186",
        "Length": 1152
    },
    {
        "Name": "ctgAPLB01041187",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01041188",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01041191",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01041195",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01041196",
        "Length": 943
    },
    {
        "Name": "ctgAPLB01041197",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01041198",
        "Length": 1496
    },
    {
        "Name": "ctgAPLB01041199",
        "Length": 694
    },
    {
        "Name": "ctgAPLB01041202",
        "Length": 959
    },
    {
        "Name": "ctgAPLB01041203",
        "Length": 986
    },
    {
        "Name": "ctgAPLB01041204",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01041205",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01041206",
        "Length": 5508
    },
    {
        "Name": "ctgAPLB01041207",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01041208",
        "Length": 3540
    },
    {
        "Name": "ctgAPLB01041212",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01041213",
        "Length": 1220
    },
    {
        "Name": "ctgAPLB01041214",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01041215",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01041216",
        "Length": 2533
    },
    {
        "Name": "ctgAPLB01041217",
        "Length": 1492
    },
    {
        "Name": "ctgAPLB01041220",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01041221",
        "Length": 1489
    },
    {
        "Name": "ctgAPLB01041222",
        "Length": 1280
    },
    {
        "Name": "ctgAPLB01041223",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01041224",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01041225",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01041226",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01041231",
        "Length": 776
    },
    {
        "Name": "ctgAPLB01041232",
        "Length": 1229
    },
    {
        "Name": "ctgAPLB01041237",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01041238",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01041239",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01041240",
        "Length": 1308
    },
    {
        "Name": "ctgAPLB01041244",
        "Length": 3119
    },
    {
        "Name": "ctgAPLB01041245",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01041246",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01041247",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01041248",
        "Length": 1574
    },
    {
        "Name": "ctgAPLB01041249",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01041250",
        "Length": 4255
    },
    {
        "Name": "ctgAPLB01041251",
        "Length": 2235
    },
    {
        "Name": "ctgAPLB01041252",
        "Length": 1958
    },
    {
        "Name": "ctgAPLB01041253",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01041256",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01041257",
        "Length": 1689
    },
    {
        "Name": "ctgAPLB01041258",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01041259",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01041260",
        "Length": 4704
    },
    {
        "Name": "ctgAPLB01041262",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01041263",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01041264",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01041266",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01041268",
        "Length": 1144
    },
    {
        "Name": "ctgAPLB01041269",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01041270",
        "Length": 1162
    },
    {
        "Name": "ctgAPLB01041273",
        "Length": 2584
    },
    {
        "Name": "ctgAPLB01041274",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01041275",
        "Length": 715
    },
    {
        "Name": "ctgAPLB01041276",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01041277",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01041283",
        "Length": 2329
    },
    {
        "Name": "ctgAPLB01041284",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01041285",
        "Length": 1102
    },
    {
        "Name": "ctgAPLB01041286",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01041294",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01041295",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01041296",
        "Length": 1217
    },
    {
        "Name": "ctgAPLB01041297",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01041298",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01041301",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01041302",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01041303",
        "Length": 726
    },
    {
        "Name": "ctgAPLB01041304",
        "Length": 1286
    },
    {
        "Name": "ctgAPLB01041310",
        "Length": 1496
    },
    {
        "Name": "ctgAPLB01041311",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01041312",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01041316",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01041317",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01041320",
        "Length": 661
    },
    {
        "Name": "ctgAPLB01041323",
        "Length": 1382
    },
    {
        "Name": "ctgAPLB01041324",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01041325",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01041328",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01041331",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01041332",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01041333",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01041334",
        "Length": 4419
    },
    {
        "Name": "ctgAPLB01041335",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01041336",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01041337",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01041338",
        "Length": 642
    },
    {
        "Name": "ctgAPLB01041341",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01041342",
        "Length": 796
    },
    {
        "Name": "ctgAPLB01041343",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01041344",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01041349",
        "Length": 1067
    },
    {
        "Name": "ctgAPLB01041350",
        "Length": 1652
    },
    {
        "Name": "ctgAPLB01041351",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01041352",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01041353",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01041354",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01041355",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01041356",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01041357",
        "Length": 847
    },
    {
        "Name": "ctgAPLB01041358",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01041359",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01041360",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01041361",
        "Length": 597
    },
    {
        "Name": "ctgAPLB01041362",
        "Length": 1948
    },
    {
        "Name": "ctgAPLB01041363",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01041364",
        "Length": 597
    },
    {
        "Name": "ctgAPLB01041367",
        "Length": 6467
    },
    {
        "Name": "ctgAPLB01041368",
        "Length": 633
    },
    {
        "Name": "ctgAPLB01041370",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01041371",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01041372",
        "Length": 1216
    },
    {
        "Name": "ctgAPLB01041373",
        "Length": 1303
    },
    {
        "Name": "ctgAPLB01041376",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01041378",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01041379",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01041380",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01041381",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01041382",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01041384",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01041385",
        "Length": 1385
    },
    {
        "Name": "ctgAPLB01041386",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01041387",
        "Length": 914
    },
    {
        "Name": "ctgAPLB01041388",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01041389",
        "Length": 1529
    },
    {
        "Name": "ctgAPLB01041392",
        "Length": 844
    },
    {
        "Name": "ctgAPLB01041394",
        "Length": 592
    },
    {
        "Name": "ctgAPLB01041395",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01041396",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01041397",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01041398",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01041399",
        "Length": 1039
    },
    {
        "Name": "ctgAPLB01041402",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01041404",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01041405",
        "Length": 1368
    },
    {
        "Name": "ctgAPLB01041406",
        "Length": 1452
    },
    {
        "Name": "ctgAPLB01041409",
        "Length": 1374
    },
    {
        "Name": "ctgAPLB01041410",
        "Length": 1119
    },
    {
        "Name": "ctgAPLB01041415",
        "Length": 596
    },
    {
        "Name": "ctgAPLB01041416",
        "Length": 699
    },
    {
        "Name": "ctgAPLB01041417",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01041418",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01041419",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01041420",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01041422",
        "Length": 1297
    },
    {
        "Name": "ctgAPLB01041423",
        "Length": 6268
    },
    {
        "Name": "ctgAPLB01041428",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01041429",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01041430",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01041431",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01041432",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01041433",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01041434",
        "Length": 893
    },
    {
        "Name": "ctgAPLB01041437",
        "Length": 1291
    },
    {
        "Name": "ctgAPLB01041442",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01041443",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01041444",
        "Length": 2130
    },
    {
        "Name": "ctgAPLB01041445",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01041447",
        "Length": 1131
    },
    {
        "Name": "ctgAPLB01041450",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01041451",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01041452",
        "Length": 849
    },
    {
        "Name": "ctgAPLB01041453",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01041454",
        "Length": 1935
    },
    {
        "Name": "ctgAPLB01041455",
        "Length": 910
    },
    {
        "Name": "ctgAPLB01041456",
        "Length": 620
    },
    {
        "Name": "ctgAPLB01041457",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01041458",
        "Length": 15458
    },
    {
        "Name": "ctgAPLB01041459",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01041460",
        "Length": 984
    },
    {
        "Name": "ctgAPLB01041461",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01041462",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01041463",
        "Length": 944
    },
    {
        "Name": "ctgAPLB01041464",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01041465",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01041469",
        "Length": 771
    },
    {
        "Name": "ctgAPLB01041470",
        "Length": 1332
    },
    {
        "Name": "ctgAPLB01041473",
        "Length": 1138
    },
    {
        "Name": "ctgAPLB01041474",
        "Length": 1135
    },
    {
        "Name": "ctgAPLB01041475",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01041477",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01041480",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01041481",
        "Length": 1108
    },
    {
        "Name": "ctgAPLB01041482",
        "Length": 879
    },
    {
        "Name": "ctgAPLB01041483",
        "Length": 456
    },
    {
        "Name": "ctgAPLB01041486",
        "Length": 1218
    },
    {
        "Name": "ctgAPLB01041487",
        "Length": 1105
    },
    {
        "Name": "ctgAPLB01041489",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01041494",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01041495",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01041496",
        "Length": 1432
    },
    {
        "Name": "ctgAPLB01041497",
        "Length": 5495
    },
    {
        "Name": "ctgAPLB01041498",
        "Length": 2637
    },
    {
        "Name": "ctgAPLB01041502",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01041503",
        "Length": 8389
    },
    {
        "Name": "ctgAPLB01041504",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01041505",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01041506",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01041507",
        "Length": 587
    },
    {
        "Name": "ctgAPLB01041508",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01041509",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01041512",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01041513",
        "Length": 1098
    },
    {
        "Name": "ctgAPLB01041514",
        "Length": 1814
    },
    {
        "Name": "ctgAPLB01041519",
        "Length": 707
    },
    {
        "Name": "ctgAPLB01041520",
        "Length": 1026
    },
    {
        "Name": "ctgAPLB01041523",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01041524",
        "Length": 795
    },
    {
        "Name": "ctgAPLB01041525",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01041526",
        "Length": 593
    },
    {
        "Name": "ctgAPLB01041529",
        "Length": 1393
    },
    {
        "Name": "ctgAPLB01041532",
        "Length": 466
    },
    {
        "Name": "ctgAPLB01041533",
        "Length": 1779
    },
    {
        "Name": "ctgAPLB01041539",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01041540",
        "Length": 1119
    },
    {
        "Name": "ctgAPLB01041541",
        "Length": 1169
    },
    {
        "Name": "ctgAPLB01041542",
        "Length": 868
    },
    {
        "Name": "ctgAPLB01041543",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01041544",
        "Length": 1159
    },
    {
        "Name": "ctgAPLB01041545",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01041546",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01041547",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01041548",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01041549",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01041550",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01041552",
        "Length": 1780
    },
    {
        "Name": "ctgAPLB01041553",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01041554",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01041555",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01041556",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01041557",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01041560",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01041561",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01041562",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01041563",
        "Length": 2620
    },
    {
        "Name": "ctgAPLB01041564",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01041565",
        "Length": 1724
    },
    {
        "Name": "ctgAPLB01041566",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01041567",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01041568",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01041569",
        "Length": 669
    },
    {
        "Name": "ctgAPLB01041570",
        "Length": 862
    },
    {
        "Name": "ctgAPLB01041573",
        "Length": 830
    },
    {
        "Name": "ctgAPLB01041574",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01041575",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01041580",
        "Length": 1374
    },
    {
        "Name": "ctgAPLB01041581",
        "Length": 843
    },
    {
        "Name": "ctgAPLB01041582",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01041583",
        "Length": 1430
    },
    {
        "Name": "ctgAPLB01041586",
        "Length": 1169
    },
    {
        "Name": "ctgAPLB01041589",
        "Length": 1313
    },
    {
        "Name": "ctgAPLB01041590",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01041591",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01041592",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01041596",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01041597",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01041598",
        "Length": 1703
    },
    {
        "Name": "ctgAPLB01041599",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01041600",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01041601",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01041602",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01041603",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01041604",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01041605",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01041606",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01041607",
        "Length": 1440
    },
    {
        "Name": "ctgAPLB01041610",
        "Length": 669
    },
    {
        "Name": "ctgAPLB01041611",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01041612",
        "Length": 829
    },
    {
        "Name": "ctgAPLB01041613",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01041616",
        "Length": 16276
    },
    {
        "Name": "ctgAPLB01041617",
        "Length": 2141
    },
    {
        "Name": "ctgAPLB01041618",
        "Length": 418
    },
    {
        "Name": "ctgAPLB01041619",
        "Length": 1107
    },
    {
        "Name": "ctgAPLB01041620",
        "Length": 621
    },
    {
        "Name": "ctgAPLB01041621",
        "Length": 997
    },
    {
        "Name": "ctgAPLB01041624",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01041627",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01041628",
        "Length": 1344
    },
    {
        "Name": "ctgAPLB01041629",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01041630",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01041637",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01041638",
        "Length": 1025
    },
    {
        "Name": "ctgAPLB01041642",
        "Length": 1443
    },
    {
        "Name": "ctgAPLB01041643",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01041646",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01041647",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01041648",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01041652",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01041653",
        "Length": 1178
    },
    {
        "Name": "ctgAPLB01041654",
        "Length": 5204
    },
    {
        "Name": "ctgAPLB01041655",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01041659",
        "Length": 3502
    },
    {
        "Name": "ctgAPLB01041662",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01041663",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01041665",
        "Length": 1973
    },
    {
        "Name": "ctgAPLB01041666",
        "Length": 1183
    },
    {
        "Name": "ctgAPLB01041667",
        "Length": 1285
    },
    {
        "Name": "ctgAPLB01041668",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01041669",
        "Length": 1214
    },
    {
        "Name": "ctgAPLB01041672",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01041673",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01041681",
        "Length": 26604
    },
    {
        "Name": "ctgAPLB01041682",
        "Length": 2368
    },
    {
        "Name": "ctgAPLB01041683",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01041686",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01041687",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01041688",
        "Length": 1530
    },
    {
        "Name": "ctgAPLB01041689",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01041690",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01041691",
        "Length": 1824
    },
    {
        "Name": "ctgAPLB01041692",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01041695",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01041696",
        "Length": 1611
    },
    {
        "Name": "ctgAPLB01041697",
        "Length": 940
    },
    {
        "Name": "ctgAPLB01041698",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01041701",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01041702",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01041703",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01041704",
        "Length": 782
    },
    {
        "Name": "ctgAPLB01041705",
        "Length": 865
    },
    {
        "Name": "ctgAPLB01041706",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01041707",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01041708",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01041709",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01041710",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01041712",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01041715",
        "Length": 12142
    },
    {
        "Name": "ctgAPLB01041716",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01041717",
        "Length": 1178
    },
    {
        "Name": "ctgAPLB01041718",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01041719",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01041720",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01041721",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01041723",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01041724",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01041725",
        "Length": 1332
    },
    {
        "Name": "ctgAPLB01041726",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01041727",
        "Length": 2739
    },
    {
        "Name": "ctgAPLB01041730",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01041731",
        "Length": 959
    },
    {
        "Name": "ctgAPLB01041732",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01041733",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01041734",
        "Length": 653
    },
    {
        "Name": "ctgAPLB01041735",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01041736",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01041737",
        "Length": 1321
    },
    {
        "Name": "ctgAPLB01041738",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01041739",
        "Length": 1348
    },
    {
        "Name": "ctgAPLB01041740",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01041741",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01041742",
        "Length": 17477
    },
    {
        "Name": "ctgAPLB01041745",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01041746",
        "Length": 1352
    },
    {
        "Name": "ctgAPLB01041747",
        "Length": 1715
    },
    {
        "Name": "ctgAPLB01041748",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01041749",
        "Length": 2123
    },
    {
        "Name": "ctgAPLB01041750",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01041751",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01041752",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01041753",
        "Length": 7298
    },
    {
        "Name": "ctgAPLB01041756",
        "Length": 2989
    },
    {
        "Name": "ctgAPLB01041757",
        "Length": 3477
    },
    {
        "Name": "ctgAPLB01041758",
        "Length": 676
    },
    {
        "Name": "ctgAPLB01041759",
        "Length": 1255
    },
    {
        "Name": "ctgAPLB01041762",
        "Length": 1368
    },
    {
        "Name": "ctgAPLB01041764",
        "Length": 2069
    },
    {
        "Name": "ctgAPLB01041765",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01041766",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01041771",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01041775",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01041776",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01041777",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01041778",
        "Length": 6055
    },
    {
        "Name": "ctgAPLB01041779",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01041780",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01041781",
        "Length": 2847
    },
    {
        "Name": "ctgAPLB01041782",
        "Length": 1959
    },
    {
        "Name": "ctgAPLB01041783",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01041784",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01041785",
        "Length": 925
    },
    {
        "Name": "ctgAPLB01041786",
        "Length": 739
    },
    {
        "Name": "ctgAPLB01041787",
        "Length": 2362
    },
    {
        "Name": "ctgAPLB01041788",
        "Length": 1482
    },
    {
        "Name": "ctgAPLB01041789",
        "Length": 3304
    },
    {
        "Name": "ctgAPLB01041790",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01041791",
        "Length": 947
    },
    {
        "Name": "ctgAPLB01041792",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01041793",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01041794",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01041795",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01041796",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01041797",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01041798",
        "Length": 1465
    },
    {
        "Name": "ctgAPLB01041799",
        "Length": 807
    },
    {
        "Name": "ctgAPLB01041800",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01041803",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01041804",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01041805",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01041806",
        "Length": 860
    },
    {
        "Name": "ctgAPLB01041807",
        "Length": 799
    },
    {
        "Name": "ctgAPLB01041808",
        "Length": 644
    },
    {
        "Name": "ctgAPLB01041809",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01041810",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01041815",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01041816",
        "Length": 1075
    },
    {
        "Name": "ctgAPLB01041817",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01041820",
        "Length": 1149
    },
    {
        "Name": "ctgAPLB01041821",
        "Length": 1573
    },
    {
        "Name": "ctgAPLB01041822",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01041826",
        "Length": 790
    },
    {
        "Name": "ctgAPLB01041827",
        "Length": 830
    },
    {
        "Name": "ctgAPLB01041828",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01041831",
        "Length": 1178
    },
    {
        "Name": "ctgAPLB01041832",
        "Length": 1388
    },
    {
        "Name": "ctgAPLB01041833",
        "Length": 1396
    },
    {
        "Name": "ctgAPLB01041836",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01041837",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01041838",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01041839",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01041840",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01041845",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01041846",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01041847",
        "Length": 1664
    },
    {
        "Name": "ctgAPLB01041849",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01041850",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01041851",
        "Length": 744
    },
    {
        "Name": "ctgAPLB01041852",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01041853",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01041854",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01041855",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01041858",
        "Length": 1391
    },
    {
        "Name": "ctgAPLB01041859",
        "Length": 865
    },
    {
        "Name": "ctgAPLB01041860",
        "Length": 891
    },
    {
        "Name": "ctgAPLB01041861",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01041862",
        "Length": 3319
    },
    {
        "Name": "ctgAPLB01041863",
        "Length": 806
    },
    {
        "Name": "ctgAPLB01041866",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01041867",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01041869",
        "Length": 1145
    },
    {
        "Name": "ctgAPLB01041870",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01041871",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01041874",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01041875",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01041876",
        "Length": 1386
    },
    {
        "Name": "ctgAPLB01041879",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01041880",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01041883",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01041884",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01041885",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01041886",
        "Length": 924
    },
    {
        "Name": "ctgAPLB01041889",
        "Length": 1105
    },
    {
        "Name": "ctgAPLB01041890",
        "Length": 885
    },
    {
        "Name": "ctgAPLB01041893",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01041896",
        "Length": 1396
    },
    {
        "Name": "ctgAPLB01041897",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01041898",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01041899",
        "Length": 819
    },
    {
        "Name": "ctgAPLB01041900",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01041901",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01041904",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01041905",
        "Length": 1712
    },
    {
        "Name": "ctgAPLB01041906",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01041907",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01041908",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01041911",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01041913",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01041914",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01041915",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01041916",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01041919",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01041920",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01041921",
        "Length": 1449
    },
    {
        "Name": "ctgAPLB01041922",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01041923",
        "Length": 1125
    },
    {
        "Name": "ctgAPLB01041927",
        "Length": 702
    },
    {
        "Name": "ctgAPLB01041928",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01041931",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01041932",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01041933",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01041934",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01041935",
        "Length": 2823
    },
    {
        "Name": "ctgAPLB01041936",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01041937",
        "Length": 844
    },
    {
        "Name": "ctgAPLB01041938",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01041939",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01041944",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01041945",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01041946",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01041952",
        "Length": 3901
    },
    {
        "Name": "ctgAPLB01041953",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01041954",
        "Length": 1102
    },
    {
        "Name": "ctgAPLB01041955",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01041956",
        "Length": 2336
    },
    {
        "Name": "ctgAPLB01041957",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01041958",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01041959",
        "Length": 1311
    },
    {
        "Name": "ctgAPLB01041960",
        "Length": 616
    },
    {
        "Name": "ctgAPLB01041961",
        "Length": 2846
    },
    {
        "Name": "ctgAPLB01041962",
        "Length": 1228
    },
    {
        "Name": "ctgAPLB01041963",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01041964",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01041967",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01041968",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01041970",
        "Length": 780
    },
    {
        "Name": "ctgAPLB01041971",
        "Length": 13807
    },
    {
        "Name": "ctgAPLB01041974",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01041976",
        "Length": 557
    },
    {
        "Name": "ctgAPLB01041977",
        "Length": 1527
    },
    {
        "Name": "ctgAPLB01041978",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01041979",
        "Length": 1084
    },
    {
        "Name": "ctgAPLB01041980",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01041982",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01041983",
        "Length": 1315
    },
    {
        "Name": "ctgAPLB01041984",
        "Length": 3667
    },
    {
        "Name": "ctgAPLB01041985",
        "Length": 601
    },
    {
        "Name": "ctgAPLB01041986",
        "Length": 959
    },
    {
        "Name": "ctgAPLB01041987",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01041988",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01041989",
        "Length": 1284
    },
    {
        "Name": "ctgAPLB01041990",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01041991",
        "Length": 2012
    },
    {
        "Name": "ctgAPLB01041992",
        "Length": 3123
    },
    {
        "Name": "ctgAPLB01041996",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01041997",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01041998",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01041999",
        "Length": 770
    },
    {
        "Name": "ctgAPLB01042001",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01042002",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01042003",
        "Length": 900
    },
    {
        "Name": "ctgAPLB01042004",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01042005",
        "Length": 1362
    },
    {
        "Name": "ctgAPLB01042006",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01042007",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01042008",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01042009",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01042010",
        "Length": 1050
    },
    {
        "Name": "ctgAPLB01042011",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01042012",
        "Length": 1719
    },
    {
        "Name": "ctgAPLB01042015",
        "Length": 1126
    },
    {
        "Name": "ctgAPLB01042016",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01042017",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01042020",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01042021",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01042026",
        "Length": 2525
    },
    {
        "Name": "ctgAPLB01042027",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01042028",
        "Length": 873
    },
    {
        "Name": "ctgAPLB01042029",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01042030",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01042031",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01042032",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01042033",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01042036",
        "Length": 1006
    },
    {
        "Name": "ctgAPLB01042037",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01042042",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01042043",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01042044",
        "Length": 909
    },
    {
        "Name": "ctgAPLB01042045",
        "Length": 1005
    },
    {
        "Name": "ctgAPLB01042046",
        "Length": 699
    },
    {
        "Name": "ctgAPLB01042047",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01042048",
        "Length": 744
    },
    {
        "Name": "ctgAPLB01042049",
        "Length": 1215
    },
    {
        "Name": "ctgAPLB01042050",
        "Length": 804
    },
    {
        "Name": "ctgAPLB01042051",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01042054",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01042057",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01042058",
        "Length": 1079
    },
    {
        "Name": "ctgAPLB01042059",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01042060",
        "Length": 1336
    },
    {
        "Name": "ctgAPLB01042061",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01042062",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01042063",
        "Length": 2925
    },
    {
        "Name": "ctgAPLB01042064",
        "Length": 4000
    },
    {
        "Name": "ctgAPLB01042065",
        "Length": 902
    },
    {
        "Name": "ctgAPLB01042066",
        "Length": 1356
    },
    {
        "Name": "ctgAPLB01042067",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01042068",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01042069",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01042074",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01042075",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01042076",
        "Length": 592
    },
    {
        "Name": "ctgAPLB01042077",
        "Length": 2859
    },
    {
        "Name": "ctgAPLB01042078",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01042081",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01042082",
        "Length": 871
    },
    {
        "Name": "ctgAPLB01042083",
        "Length": 942
    },
    {
        "Name": "ctgAPLB01042084",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01042085",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01042086",
        "Length": 1187
    },
    {
        "Name": "ctgAPLB01042087",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01042088",
        "Length": 1305
    },
    {
        "Name": "ctgAPLB01042089",
        "Length": 633
    },
    {
        "Name": "ctgAPLB01042090",
        "Length": 2051
    },
    {
        "Name": "ctgAPLB01042091",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01042092",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01042093",
        "Length": 591
    },
    {
        "Name": "ctgAPLB01042094",
        "Length": 857
    },
    {
        "Name": "ctgAPLB01042095",
        "Length": 1163
    },
    {
        "Name": "ctgAPLB01042096",
        "Length": 849
    },
    {
        "Name": "ctgAPLB01042097",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01042102",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01042103",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01042104",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01042105",
        "Length": 1406
    },
    {
        "Name": "ctgAPLB01042106",
        "Length": 796
    },
    {
        "Name": "ctgAPLB01042107",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01042110",
        "Length": 1153
    },
    {
        "Name": "ctgAPLB01042111",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01042112",
        "Length": 1783
    },
    {
        "Name": "ctgAPLB01042115",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01042116",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01042117",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01042118",
        "Length": 798
    },
    {
        "Name": "ctgAPLB01042119",
        "Length": 889
    },
    {
        "Name": "ctgAPLB01042122",
        "Length": 581
    },
    {
        "Name": "ctgAPLB01042123",
        "Length": 1823
    },
    {
        "Name": "ctgAPLB01042124",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01042127",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01042128",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01042129",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01042130",
        "Length": 1058
    },
    {
        "Name": "ctgAPLB01042131",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01042132",
        "Length": 866
    },
    {
        "Name": "ctgAPLB01042133",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01042134",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01042135",
        "Length": 1522
    },
    {
        "Name": "ctgAPLB01042136",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01042139",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01042140",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01042143",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01042144",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01042147",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01042148",
        "Length": 641
    },
    {
        "Name": "ctgAPLB01042149",
        "Length": 1267
    },
    {
        "Name": "ctgAPLB01042150",
        "Length": 1151
    },
    {
        "Name": "ctgAPLB01042151",
        "Length": 830
    },
    {
        "Name": "ctgAPLB01042152",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01042153",
        "Length": 942
    },
    {
        "Name": "ctgAPLB01042154",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01042155",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01042160",
        "Length": 686
    },
    {
        "Name": "ctgAPLB01042161",
        "Length": 1094
    },
    {
        "Name": "ctgAPLB01042162",
        "Length": 780
    },
    {
        "Name": "ctgAPLB01042163",
        "Length": 1023
    },
    {
        "Name": "ctgAPLB01042164",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01042165",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01042166",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01042167",
        "Length": 1870
    },
    {
        "Name": "ctgAPLB01042168",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01042169",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01042170",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01042171",
        "Length": 866
    },
    {
        "Name": "ctgAPLB01042172",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01042175",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01042176",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01042177",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01042178",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01042179",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01042180",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01042181",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01042184",
        "Length": 1055
    },
    {
        "Name": "ctgAPLB01042185",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01042186",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01042187",
        "Length": 724
    },
    {
        "Name": "ctgAPLB01042189",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01042190",
        "Length": 8293
    },
    {
        "Name": "ctgAPLB01042193",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01042194",
        "Length": 620
    },
    {
        "Name": "ctgAPLB01042197",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01042198",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01042199",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01042200",
        "Length": 1395
    },
    {
        "Name": "ctgAPLB01042201",
        "Length": 1053
    },
    {
        "Name": "ctgAPLB01042202",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01042208",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01042209",
        "Length": 668
    },
    {
        "Name": "ctgAPLB01042213",
        "Length": 2957
    },
    {
        "Name": "ctgAPLB01042214",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01042215",
        "Length": 931
    },
    {
        "Name": "ctgAPLB01042216",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01042217",
        "Length": 1209
    },
    {
        "Name": "ctgAPLB01042218",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01042219",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01042220",
        "Length": 860
    },
    {
        "Name": "ctgAPLB01042221",
        "Length": 1282
    },
    {
        "Name": "ctgAPLB01042222",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01042224",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01042225",
        "Length": 920
    },
    {
        "Name": "ctgAPLB01042226",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01042227",
        "Length": 1525
    },
    {
        "Name": "ctgAPLB01042228",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01042231",
        "Length": 1250
    },
    {
        "Name": "ctgAPLB01042232",
        "Length": 867
    },
    {
        "Name": "ctgAPLB01042233",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01042234",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01042235",
        "Length": 1225
    },
    {
        "Name": "ctgAPLB01042236",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01042237",
        "Length": 1077
    },
    {
        "Name": "ctgAPLB01042238",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01042239",
        "Length": 635
    },
    {
        "Name": "ctgAPLB01042240",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01042241",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01042242",
        "Length": 1434
    },
    {
        "Name": "ctgAPLB01042243",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01042244",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01042245",
        "Length": 754
    },
    {
        "Name": "ctgAPLB01042246",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01042247",
        "Length": 1585
    },
    {
        "Name": "ctgAPLB01042250",
        "Length": 805
    },
    {
        "Name": "ctgAPLB01042251",
        "Length": 813
    },
    {
        "Name": "ctgAPLB01042252",
        "Length": 1503
    },
    {
        "Name": "ctgAPLB01042253",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01042254",
        "Length": 1243
    },
    {
        "Name": "ctgAPLB01042255",
        "Length": 2017
    },
    {
        "Name": "ctgAPLB01042257",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01042258",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01042260",
        "Length": 628
    },
    {
        "Name": "ctgAPLB01042263",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01042266",
        "Length": 1115
    },
    {
        "Name": "ctgAPLB01042267",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01042268",
        "Length": 1232
    },
    {
        "Name": "ctgAPLB01042269",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01042270",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01042271",
        "Length": 828
    },
    {
        "Name": "ctgAPLB01042272",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01042273",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01042274",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01042276",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01042277",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01042278",
        "Length": 834
    },
    {
        "Name": "ctgAPLB01042279",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01042280",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01042281",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01042287",
        "Length": 587
    },
    {
        "Name": "ctgAPLB01042288",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01042289",
        "Length": 2054
    },
    {
        "Name": "ctgAPLB01042292",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01042295",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01042296",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01042297",
        "Length": 1060
    },
    {
        "Name": "ctgAPLB01042298",
        "Length": 1488
    },
    {
        "Name": "ctgAPLB01042299",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01042301",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01042307",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01042308",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01042309",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01042310",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01042311",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01042312",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01042313",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01042314",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01042317",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01042318",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01042321",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01042328",
        "Length": 1457
    },
    {
        "Name": "ctgAPLB01042331",
        "Length": 2167
    },
    {
        "Name": "ctgAPLB01042332",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01042333",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01042334",
        "Length": 927
    },
    {
        "Name": "ctgAPLB01042335",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01042336",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01042337",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01042339",
        "Length": 2383
    },
    {
        "Name": "ctgAPLB01042340",
        "Length": 642
    },
    {
        "Name": "ctgAPLB01042341",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01042345",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01042346",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01042349",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01042351",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01042352",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01042353",
        "Length": 3488
    },
    {
        "Name": "ctgAPLB01042354",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01042355",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01042356",
        "Length": 2836
    },
    {
        "Name": "ctgAPLB01042359",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01042360",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01042361",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01042362",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01042363",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01042364",
        "Length": 649
    },
    {
        "Name": "ctgAPLB01042365",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01042366",
        "Length": 421
    },
    {
        "Name": "ctgAPLB01042367",
        "Length": 5370
    },
    {
        "Name": "ctgAPLB01042368",
        "Length": 971
    },
    {
        "Name": "ctgAPLB01042371",
        "Length": 652
    },
    {
        "Name": "ctgAPLB01042375",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01042376",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01042377",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01042378",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01042381",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01042384",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01042385",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01042386",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01042391",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01042392",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01042393",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01042394",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01042396",
        "Length": 765
    },
    {
        "Name": "ctgAPLB01042397",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01042400",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01042401",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01042402",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01042403",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01042404",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01042405",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01042406",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01042407",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01042408",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01042411",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01042413",
        "Length": 1152
    },
    {
        "Name": "ctgAPLB01042414",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01042415",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01042417",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01042418",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01042419",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01042420",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01042421",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01042422",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01042423",
        "Length": 724
    },
    {
        "Name": "ctgAPLB01042424",
        "Length": 1221
    },
    {
        "Name": "ctgAPLB01042425",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01042428",
        "Length": 1039
    },
    {
        "Name": "ctgAPLB01042429",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01042430",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01042431",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01042432",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01042433",
        "Length": 1161
    },
    {
        "Name": "ctgAPLB01042434",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01042435",
        "Length": 594
    },
    {
        "Name": "ctgAPLB01042436",
        "Length": 659
    },
    {
        "Name": "ctgAPLB01042439",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01042441",
        "Length": 826
    },
    {
        "Name": "ctgAPLB01042443",
        "Length": 6875
    },
    {
        "Name": "ctgAPLB01042446",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01042447",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01042448",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01042449",
        "Length": 984
    },
    {
        "Name": "ctgAPLB01042450",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01042451",
        "Length": 805
    },
    {
        "Name": "ctgAPLB01042452",
        "Length": 1484
    },
    {
        "Name": "ctgAPLB01042453",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01042454",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01042455",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01042456",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01042457",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01042458",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01042459",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01042460",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01042466",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01042467",
        "Length": 2804
    },
    {
        "Name": "ctgAPLB01042468",
        "Length": 898
    },
    {
        "Name": "ctgAPLB01042471",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01042472",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01042473",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01042474",
        "Length": 775
    },
    {
        "Name": "ctgAPLB01042476",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01042477",
        "Length": 887
    },
    {
        "Name": "ctgAPLB01042478",
        "Length": 877
    },
    {
        "Name": "ctgAPLB01042479",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01042480",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01042481",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01042482",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01042483",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01042486",
        "Length": 1115
    },
    {
        "Name": "ctgAPLB01042487",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01042488",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01042489",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01042490",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01042491",
        "Length": 2445
    },
    {
        "Name": "ctgAPLB01042494",
        "Length": 813
    },
    {
        "Name": "ctgAPLB01042495",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01042496",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01042497",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01042500",
        "Length": 1558
    },
    {
        "Name": "ctgAPLB01042503",
        "Length": 1245
    },
    {
        "Name": "ctgAPLB01042506",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01042507",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01042508",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01042509",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01042512",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01042516",
        "Length": 557
    },
    {
        "Name": "ctgAPLB01042517",
        "Length": 1235
    },
    {
        "Name": "ctgAPLB01042520",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01042521",
        "Length": 1028
    },
    {
        "Name": "ctgAPLB01042524",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01042525",
        "Length": 1207
    },
    {
        "Name": "ctgAPLB01042526",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01042527",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01042528",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01042529",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01042532",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01042535",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01042538",
        "Length": 944
    },
    {
        "Name": "ctgAPLB01042543",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01042544",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01042545",
        "Length": 788
    },
    {
        "Name": "ctgAPLB01042546",
        "Length": 1091
    },
    {
        "Name": "ctgAPLB01042547",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01042548",
        "Length": 689
    },
    {
        "Name": "ctgAPLB01042549",
        "Length": 439
    },
    {
        "Name": "ctgAPLB01042553",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01042554",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01042555",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01042556",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01042557",
        "Length": 919
    },
    {
        "Name": "ctgAPLB01042558",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01042559",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01042560",
        "Length": 1043
    },
    {
        "Name": "ctgAPLB01042562",
        "Length": 1416
    },
    {
        "Name": "ctgAPLB01042563",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01042564",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01042567",
        "Length": 1445
    },
    {
        "Name": "ctgAPLB01042568",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01042569",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01042570",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01042571",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01042572",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01042573",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01042574",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01042575",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01042579",
        "Length": 1263
    },
    {
        "Name": "ctgAPLB01042584",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01042585",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01042588",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01042589",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01042590",
        "Length": 707
    },
    {
        "Name": "ctgAPLB01042591",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01042592",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01042593",
        "Length": 819
    },
    {
        "Name": "ctgAPLB01042594",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01042597",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01042601",
        "Length": 960
    },
    {
        "Name": "ctgAPLB01042602",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01042603",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01042604",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01042605",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01042610",
        "Length": 1234
    },
    {
        "Name": "ctgAPLB01042611",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01042612",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01042613",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01042614",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01042615",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01042616",
        "Length": 1976
    },
    {
        "Name": "ctgAPLB01042617",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01042618",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01042619",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01042620",
        "Length": 940
    },
    {
        "Name": "ctgAPLB01042623",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01042624",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01042625",
        "Length": 858
    },
    {
        "Name": "ctgAPLB01042626",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01042627",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01042628",
        "Length": 2658
    },
    {
        "Name": "ctgAPLB01042629",
        "Length": 2474
    },
    {
        "Name": "ctgAPLB01042630",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01042631",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01042632",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01042633",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01042634",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01042635",
        "Length": 537
    },
    {
        "Name": "ctgAPLB01042636",
        "Length": 865
    },
    {
        "Name": "ctgAPLB01042638",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01042639",
        "Length": 856
    },
    {
        "Name": "ctgAPLB01042640",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01042641",
        "Length": 1561
    },
    {
        "Name": "ctgAPLB01042642",
        "Length": 470
    },
    {
        "Name": "ctgAPLB01042643",
        "Length": 1113
    },
    {
        "Name": "ctgAPLB01042644",
        "Length": 670
    },
    {
        "Name": "ctgAPLB01042645",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01042647",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01042650",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01042651",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01042652",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01042653",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01042654",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01042656",
        "Length": 978
    },
    {
        "Name": "ctgAPLB01042657",
        "Length": 816
    },
    {
        "Name": "ctgAPLB01042660",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01042664",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01042665",
        "Length": 683
    },
    {
        "Name": "ctgAPLB01042666",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01042667",
        "Length": 750
    },
    {
        "Name": "ctgAPLB01042668",
        "Length": 1115
    },
    {
        "Name": "ctgAPLB01042669",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01042670",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01042674",
        "Length": 596
    },
    {
        "Name": "ctgAPLB01042675",
        "Length": 770
    },
    {
        "Name": "ctgAPLB01042676",
        "Length": 1922
    },
    {
        "Name": "ctgAPLB01042677",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01042678",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01042681",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01042682",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01042683",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01042684",
        "Length": 761
    },
    {
        "Name": "ctgAPLB01042685",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01042686",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01042688",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01042689",
        "Length": 4010
    },
    {
        "Name": "ctgAPLB01042690",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01042691",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01042692",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01042693",
        "Length": 1422
    },
    {
        "Name": "ctgAPLB01042694",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01042697",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01042698",
        "Length": 1557
    },
    {
        "Name": "ctgAPLB01042699",
        "Length": 775
    },
    {
        "Name": "ctgAPLB01042704",
        "Length": 1740
    },
    {
        "Name": "ctgAPLB01042705",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01042706",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01042707",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01042708",
        "Length": 796
    },
    {
        "Name": "ctgAPLB01042709",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01042712",
        "Length": 1346
    },
    {
        "Name": "ctgAPLB01042713",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01042714",
        "Length": 4289
    },
    {
        "Name": "ctgAPLB01042715",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01042716",
        "Length": 970
    },
    {
        "Name": "ctgAPLB01042717",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01042718",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01042719",
        "Length": 816
    },
    {
        "Name": "ctgAPLB01042720",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01042721",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01042722",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01042723",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01042724",
        "Length": 816
    },
    {
        "Name": "ctgAPLB01042725",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01042728",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01042729",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01042732",
        "Length": 795
    },
    {
        "Name": "ctgAPLB01042733",
        "Length": 928
    },
    {
        "Name": "ctgAPLB01042734",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01042735",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01042736",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01042737",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01042738",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01042739",
        "Length": 1746
    },
    {
        "Name": "ctgAPLB01042740",
        "Length": 2242
    },
    {
        "Name": "ctgAPLB01042743",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01042744",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01042745",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01042746",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01042747",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01042748",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01042751",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01042754",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01042755",
        "Length": 1797
    },
    {
        "Name": "ctgAPLB01042756",
        "Length": 1254
    },
    {
        "Name": "ctgAPLB01042759",
        "Length": 1060
    },
    {
        "Name": "ctgAPLB01042760",
        "Length": 1000
    },
    {
        "Name": "ctgAPLB01042761",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01042762",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01042763",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01042764",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01042766",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01042767",
        "Length": 664
    },
    {
        "Name": "ctgAPLB01042768",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01042769",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01042770",
        "Length": 642
    },
    {
        "Name": "ctgAPLB01042771",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01042772",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01042773",
        "Length": 1495
    },
    {
        "Name": "ctgAPLB01042774",
        "Length": 2792
    },
    {
        "Name": "ctgAPLB01042775",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01042776",
        "Length": 3776
    },
    {
        "Name": "ctgAPLB01042779",
        "Length": 587
    },
    {
        "Name": "ctgAPLB01042780",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01042781",
        "Length": 2523
    },
    {
        "Name": "ctgAPLB01042782",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01042783",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01042784",
        "Length": 662
    },
    {
        "Name": "ctgAPLB01042785",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01042786",
        "Length": 3463
    },
    {
        "Name": "ctgAPLB01042787",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01042788",
        "Length": 2127
    },
    {
        "Name": "ctgAPLB01042789",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01042792",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01042793",
        "Length": 1123
    },
    {
        "Name": "ctgAPLB01042794",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01042795",
        "Length": 552
    },
    {
        "Name": "ctgAPLB01042796",
        "Length": 2597
    },
    {
        "Name": "ctgAPLB01042797",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01042799",
        "Length": 1747
    },
    {
        "Name": "ctgAPLB01042800",
        "Length": 1518
    },
    {
        "Name": "ctgAPLB01042801",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01042802",
        "Length": 795
    },
    {
        "Name": "ctgAPLB01042803",
        "Length": 750
    },
    {
        "Name": "ctgAPLB01042804",
        "Length": 1082
    },
    {
        "Name": "ctgAPLB01042805",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01042807",
        "Length": 1726
    },
    {
        "Name": "ctgAPLB01042808",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01042809",
        "Length": 3412
    },
    {
        "Name": "ctgAPLB01042810",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01042811",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01042812",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01042813",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01042814",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01042815",
        "Length": 6015
    },
    {
        "Name": "ctgAPLB01042816",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01042817",
        "Length": 1201
    },
    {
        "Name": "ctgAPLB01042818",
        "Length": 1142
    },
    {
        "Name": "ctgAPLB01042819",
        "Length": 552
    },
    {
        "Name": "ctgAPLB01042820",
        "Length": 931
    },
    {
        "Name": "ctgAPLB01042821",
        "Length": 1185
    },
    {
        "Name": "ctgAPLB01042822",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01042823",
        "Length": 5028
    },
    {
        "Name": "ctgAPLB01042824",
        "Length": 767
    },
    {
        "Name": "ctgAPLB01042825",
        "Length": 1220
    },
    {
        "Name": "ctgAPLB01042826",
        "Length": 864
    },
    {
        "Name": "ctgAPLB01042827",
        "Length": 1190
    },
    {
        "Name": "ctgAPLB01042828",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01042829",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01042830",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01042831",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01042832",
        "Length": 618
    },
    {
        "Name": "ctgAPLB01042837",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01042840",
        "Length": 1090
    },
    {
        "Name": "ctgAPLB01042841",
        "Length": 798
    },
    {
        "Name": "ctgAPLB01042844",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01042845",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01042846",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01042847",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01042848",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01042849",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01042850",
        "Length": 875
    },
    {
        "Name": "ctgAPLB01042851",
        "Length": 739
    },
    {
        "Name": "ctgAPLB01042852",
        "Length": 938
    },
    {
        "Name": "ctgAPLB01042853",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01042854",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01042857",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01042858",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01042859",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01042860",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01042861",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01042862",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01042863",
        "Length": 3016
    },
    {
        "Name": "ctgAPLB01042864",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01042865",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01042866",
        "Length": 782
    },
    {
        "Name": "ctgAPLB01042867",
        "Length": 2090
    },
    {
        "Name": "ctgAPLB01042868",
        "Length": 1217
    },
    {
        "Name": "ctgAPLB01042871",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01042872",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01042878",
        "Length": 1557
    },
    {
        "Name": "ctgAPLB01042879",
        "Length": 6170
    },
    {
        "Name": "ctgAPLB01042880",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01042881",
        "Length": 2203
    },
    {
        "Name": "ctgAPLB01042882",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01042883",
        "Length": 1358
    },
    {
        "Name": "ctgAPLB01042884",
        "Length": 891
    },
    {
        "Name": "ctgAPLB01042889",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01042890",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01042891",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01042892",
        "Length": 1307
    },
    {
        "Name": "ctgAPLB01042893",
        "Length": 2645
    },
    {
        "Name": "ctgAPLB01042894",
        "Length": 1072
    },
    {
        "Name": "ctgAPLB01042895",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01042898",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01042899",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01042900",
        "Length": 640
    },
    {
        "Name": "ctgAPLB01042901",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01042902",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01042903",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01042904",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01042907",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01042908",
        "Length": 1438
    },
    {
        "Name": "ctgAPLB01042909",
        "Length": 2685
    },
    {
        "Name": "ctgAPLB01042910",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01042911",
        "Length": 776
    },
    {
        "Name": "ctgAPLB01042912",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01042915",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01042916",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01042917",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01042920",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01042921",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01042922",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01042923",
        "Length": 1128
    },
    {
        "Name": "ctgAPLB01042924",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01042925",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01042927",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01042928",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01042929",
        "Length": 3276
    },
    {
        "Name": "ctgAPLB01042930",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01042933",
        "Length": 733
    },
    {
        "Name": "ctgAPLB01042934",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01042935",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01042936",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01042937",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01042938",
        "Length": 1058
    },
    {
        "Name": "ctgAPLB01042939",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01042940",
        "Length": 624
    },
    {
        "Name": "ctgAPLB01042941",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01042942",
        "Length": 1236
    },
    {
        "Name": "ctgAPLB01042943",
        "Length": 1444
    },
    {
        "Name": "ctgAPLB01042944",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01042945",
        "Length": 834
    },
    {
        "Name": "ctgAPLB01042946",
        "Length": 683
    },
    {
        "Name": "ctgAPLB01042947",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01042948",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01042949",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01042950",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01042951",
        "Length": 3762
    },
    {
        "Name": "ctgAPLB01042952",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01042953",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01042956",
        "Length": 825
    },
    {
        "Name": "ctgAPLB01042957",
        "Length": 1533
    },
    {
        "Name": "ctgAPLB01042958",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01042959",
        "Length": 11427
    },
    {
        "Name": "ctgAPLB01042960",
        "Length": 779
    },
    {
        "Name": "ctgAPLB01042961",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01042962",
        "Length": 783
    },
    {
        "Name": "ctgAPLB01042963",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01042964",
        "Length": 1753
    },
    {
        "Name": "ctgAPLB01042965",
        "Length": 674
    },
    {
        "Name": "ctgAPLB01042966",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01042967",
        "Length": 2232
    },
    {
        "Name": "ctgAPLB01042968",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01042970",
        "Length": 1132
    },
    {
        "Name": "ctgAPLB01042971",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01042972",
        "Length": 4830
    },
    {
        "Name": "ctgAPLB01042973",
        "Length": 3673
    },
    {
        "Name": "ctgAPLB01042974",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01042975",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01042976",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01042979",
        "Length": 3317
    },
    {
        "Name": "ctgAPLB01042980",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01042981",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01042982",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01042983",
        "Length": 5059
    },
    {
        "Name": "ctgAPLB01042986",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01042987",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01042988",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01042989",
        "Length": 1062
    },
    {
        "Name": "ctgAPLB01042990",
        "Length": 818
    },
    {
        "Name": "ctgAPLB01042991",
        "Length": 765
    },
    {
        "Name": "ctgAPLB01042993",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01042994",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01042995",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01042996",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01042997",
        "Length": 582
    },
    {
        "Name": "ctgAPLB01042998",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01042999",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01043000",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01043003",
        "Length": 621
    },
    {
        "Name": "ctgAPLB01043004",
        "Length": 1027
    },
    {
        "Name": "ctgAPLB01043005",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01043006",
        "Length": 2959
    },
    {
        "Name": "ctgAPLB01043007",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01043008",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01043011",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01043012",
        "Length": 638
    },
    {
        "Name": "ctgAPLB01043013",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01043014",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01043015",
        "Length": 1437
    },
    {
        "Name": "ctgAPLB01043016",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01043017",
        "Length": 1427
    },
    {
        "Name": "ctgAPLB01043018",
        "Length": 1513
    },
    {
        "Name": "ctgAPLB01043019",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01043020",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01043021",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01043022",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01043023",
        "Length": 1171
    },
    {
        "Name": "ctgAPLB01043024",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01043025",
        "Length": 3032
    },
    {
        "Name": "ctgAPLB01043026",
        "Length": 888
    },
    {
        "Name": "ctgAPLB01043027",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01043028",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01043029",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01043030",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01043031",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01043034",
        "Length": 1304
    },
    {
        "Name": "ctgAPLB01043035",
        "Length": 578
    },
    {
        "Name": "ctgAPLB01043036",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01043037",
        "Length": 1401
    },
    {
        "Name": "ctgAPLB01043038",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01043039",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01043040",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01043041",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01043042",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01043045",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01043046",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01043047",
        "Length": 6271
    },
    {
        "Name": "ctgAPLB01043048",
        "Length": 1420
    },
    {
        "Name": "ctgAPLB01043049",
        "Length": 2166
    },
    {
        "Name": "ctgAPLB01043050",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01043051",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01043052",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01043053",
        "Length": 1108
    },
    {
        "Name": "ctgAPLB01043054",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01043055",
        "Length": 904
    },
    {
        "Name": "ctgAPLB01043056",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01043057",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01043058",
        "Length": 960
    },
    {
        "Name": "ctgAPLB01043059",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01043060",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01043061",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01043062",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01043063",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01043064",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01043065",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01043066",
        "Length": 1193
    },
    {
        "Name": "ctgAPLB01043067",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01043068",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01043069",
        "Length": 586
    },
    {
        "Name": "ctgAPLB01043070",
        "Length": 707
    },
    {
        "Name": "ctgAPLB01043073",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01043074",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01043075",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01043076",
        "Length": 840
    },
    {
        "Name": "ctgAPLB01043077",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01043078",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01043079",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01043080",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01043083",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01043084",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01043085",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01043086",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01043087",
        "Length": 659
    },
    {
        "Name": "ctgAPLB01043088",
        "Length": 1575
    },
    {
        "Name": "ctgAPLB01043089",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01043093",
        "Length": 1050
    },
    {
        "Name": "ctgAPLB01043097",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01043098",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01043100",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01043101",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01043104",
        "Length": 1790
    },
    {
        "Name": "ctgAPLB01043105",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01043108",
        "Length": 2132
    },
    {
        "Name": "ctgAPLB01043109",
        "Length": 5036
    },
    {
        "Name": "ctgAPLB01043111",
        "Length": 2632
    },
    {
        "Name": "ctgAPLB01043112",
        "Length": 582
    },
    {
        "Name": "ctgAPLB01043113",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01043114",
        "Length": 3185
    },
    {
        "Name": "ctgAPLB01043115",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01043116",
        "Length": 4870
    },
    {
        "Name": "ctgAPLB01043117",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01043118",
        "Length": 683
    },
    {
        "Name": "ctgAPLB01043119",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01043120",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01043121",
        "Length": 1056
    },
    {
        "Name": "ctgAPLB01043122",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01043123",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01043124",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01043125",
        "Length": 4532
    },
    {
        "Name": "ctgAPLB01043126",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01043127",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01043128",
        "Length": 619
    },
    {
        "Name": "ctgAPLB01043129",
        "Length": 1069
    },
    {
        "Name": "ctgAPLB01043130",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01043131",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01043133",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01043134",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01043135",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01043138",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01043141",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01043143",
        "Length": 627
    },
    {
        "Name": "ctgAPLB01043144",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01043145",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01043148",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01043149",
        "Length": 625
    },
    {
        "Name": "ctgAPLB01043150",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01043153",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01043154",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01043155",
        "Length": 800
    },
    {
        "Name": "ctgAPLB01043158",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01043159",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01043165",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01043167",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01043170",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01043171",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01043172",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01043173",
        "Length": 3012
    },
    {
        "Name": "ctgAPLB01043174",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01043175",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01043178",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01043179",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01043180",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01043181",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01043183",
        "Length": 915
    },
    {
        "Name": "ctgAPLB01043184",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01043187",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01043188",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01043189",
        "Length": 978
    },
    {
        "Name": "ctgAPLB01043190",
        "Length": 1688
    },
    {
        "Name": "ctgAPLB01043191",
        "Length": 1411
    },
    {
        "Name": "ctgAPLB01043194",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01043195",
        "Length": 796
    },
    {
        "Name": "ctgAPLB01043196",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01043197",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01043198",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01043201",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01043202",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01043204",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01043207",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01043208",
        "Length": 1812
    },
    {
        "Name": "ctgAPLB01043209",
        "Length": 1155
    },
    {
        "Name": "ctgAPLB01043210",
        "Length": 1886
    },
    {
        "Name": "ctgAPLB01043211",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01043212",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01043213",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01043214",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01043217",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01043218",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01043219",
        "Length": 1004
    },
    {
        "Name": "ctgAPLB01043220",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01043223",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01043224",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01043225",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01043226",
        "Length": 885
    },
    {
        "Name": "ctgAPLB01043227",
        "Length": 2333
    },
    {
        "Name": "ctgAPLB01043228",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01043229",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043232",
        "Length": 1522
    },
    {
        "Name": "ctgAPLB01043233",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01043234",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01043235",
        "Length": 798
    },
    {
        "Name": "ctgAPLB01043236",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01043237",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01043240",
        "Length": 814
    },
    {
        "Name": "ctgAPLB01043241",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01043242",
        "Length": 1128
    },
    {
        "Name": "ctgAPLB01043243",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01043244",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01043245",
        "Length": 1161
    },
    {
        "Name": "ctgAPLB01043246",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01043248",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043249",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01043250",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01043251",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01043252",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01043253",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01043254",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01043255",
        "Length": 7462
    },
    {
        "Name": "ctgAPLB01043256",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01043257",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01043258",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01043259",
        "Length": 714
    },
    {
        "Name": "ctgAPLB01043260",
        "Length": 1173
    },
    {
        "Name": "ctgAPLB01043263",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01043264",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01043265",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01043266",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01043269",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01043271",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01043272",
        "Length": 1368
    },
    {
        "Name": "ctgAPLB01043273",
        "Length": 1115
    },
    {
        "Name": "ctgAPLB01043274",
        "Length": 1480
    },
    {
        "Name": "ctgAPLB01043275",
        "Length": 3948
    },
    {
        "Name": "ctgAPLB01043276",
        "Length": 1113
    },
    {
        "Name": "ctgAPLB01043277",
        "Length": 866
    },
    {
        "Name": "ctgAPLB01043278",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01043279",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01043280",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01043281",
        "Length": 618
    },
    {
        "Name": "ctgAPLB01043284",
        "Length": 875
    },
    {
        "Name": "ctgAPLB01043285",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01043290",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01043291",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01043292",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01043293",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01043294",
        "Length": 1068
    },
    {
        "Name": "ctgAPLB01043295",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01043296",
        "Length": 848
    },
    {
        "Name": "ctgAPLB01043299",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01043300",
        "Length": 2007
    },
    {
        "Name": "ctgAPLB01043301",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01043302",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01043303",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01043304",
        "Length": 1472
    },
    {
        "Name": "ctgAPLB01043305",
        "Length": 699
    },
    {
        "Name": "ctgAPLB01043306",
        "Length": 1182
    },
    {
        "Name": "ctgAPLB01043307",
        "Length": 1182
    },
    {
        "Name": "ctgAPLB01043308",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01043309",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01043310",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01043311",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01043314",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01043315",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01043316",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01043317",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01043318",
        "Length": 1431
    },
    {
        "Name": "ctgAPLB01043320",
        "Length": 1208
    },
    {
        "Name": "ctgAPLB01043322",
        "Length": 1002
    },
    {
        "Name": "ctgAPLB01043323",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01043324",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01043325",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01043326",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01043327",
        "Length": 1563
    },
    {
        "Name": "ctgAPLB01043328",
        "Length": 895
    },
    {
        "Name": "ctgAPLB01043329",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01043330",
        "Length": 920
    },
    {
        "Name": "ctgAPLB01043331",
        "Length": 688
    },
    {
        "Name": "ctgAPLB01043334",
        "Length": 815
    },
    {
        "Name": "ctgAPLB01043335",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01043336",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01043338",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01043339",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01043340",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01043341",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01043352",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01043353",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01043354",
        "Length": 2577
    },
    {
        "Name": "ctgAPLB01043355",
        "Length": 937
    },
    {
        "Name": "ctgAPLB01043356",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01043359",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01043360",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01043361",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01043362",
        "Length": 775
    },
    {
        "Name": "ctgAPLB01043363",
        "Length": 811
    },
    {
        "Name": "ctgAPLB01043364",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01043365",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01043366",
        "Length": 1313
    },
    {
        "Name": "ctgAPLB01043369",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01043370",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01043371",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01043372",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01043373",
        "Length": 991
    },
    {
        "Name": "ctgAPLB01043374",
        "Length": 3770
    },
    {
        "Name": "ctgAPLB01043377",
        "Length": 1881
    },
    {
        "Name": "ctgAPLB01043378",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01043379",
        "Length": 903
    },
    {
        "Name": "ctgAPLB01043380",
        "Length": 867
    },
    {
        "Name": "ctgAPLB01043381",
        "Length": 2583
    },
    {
        "Name": "ctgAPLB01043384",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01043385",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01043386",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01043387",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01043388",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01043389",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01043390",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01043391",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01043392",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01043393",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01043394",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01043395",
        "Length": 920
    },
    {
        "Name": "ctgAPLB01043396",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01043397",
        "Length": 1313
    },
    {
        "Name": "ctgAPLB01043400",
        "Length": 942
    },
    {
        "Name": "ctgAPLB01043401",
        "Length": 620
    },
    {
        "Name": "ctgAPLB01043402",
        "Length": 1106
    },
    {
        "Name": "ctgAPLB01043405",
        "Length": 1966
    },
    {
        "Name": "ctgAPLB01043406",
        "Length": 2554
    },
    {
        "Name": "ctgAPLB01043407",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01043410",
        "Length": 2479
    },
    {
        "Name": "ctgAPLB01043411",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01043412",
        "Length": 1092
    },
    {
        "Name": "ctgAPLB01043413",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01043414",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01043415",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01043416",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01043418",
        "Length": 922
    },
    {
        "Name": "ctgAPLB01043419",
        "Length": 1065
    },
    {
        "Name": "ctgAPLB01043422",
        "Length": 805
    },
    {
        "Name": "ctgAPLB01043423",
        "Length": 1094
    },
    {
        "Name": "ctgAPLB01043424",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01043425",
        "Length": 634
    },
    {
        "Name": "ctgAPLB01043428",
        "Length": 618
    },
    {
        "Name": "ctgAPLB01043429",
        "Length": 1148
    },
    {
        "Name": "ctgAPLB01043430",
        "Length": 836
    },
    {
        "Name": "ctgAPLB01043431",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01043432",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01043437",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01043438",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01043439",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01043440",
        "Length": 864
    },
    {
        "Name": "ctgAPLB01043441",
        "Length": 744
    },
    {
        "Name": "ctgAPLB01043442",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01043443",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01043444",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01043445",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01043446",
        "Length": 2078
    },
    {
        "Name": "ctgAPLB01043447",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01043448",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01043449",
        "Length": 795
    },
    {
        "Name": "ctgAPLB01043450",
        "Length": 669
    },
    {
        "Name": "ctgAPLB01043451",
        "Length": 805
    },
    {
        "Name": "ctgAPLB01043452",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01043453",
        "Length": 2486
    },
    {
        "Name": "ctgAPLB01043454",
        "Length": 2681
    },
    {
        "Name": "ctgAPLB01043455",
        "Length": 1393
    },
    {
        "Name": "ctgAPLB01043456",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01043457",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01043458",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01043459",
        "Length": 663
    },
    {
        "Name": "ctgAPLB01043460",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01043461",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01043462",
        "Length": 973
    },
    {
        "Name": "ctgAPLB01043463",
        "Length": 581
    },
    {
        "Name": "ctgAPLB01043464",
        "Length": 6872
    },
    {
        "Name": "ctgAPLB01043465",
        "Length": 3650
    },
    {
        "Name": "ctgAPLB01043466",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01043467",
        "Length": 1170
    },
    {
        "Name": "ctgAPLB01043468",
        "Length": 482
    },
    {
        "Name": "ctgAPLB01043469",
        "Length": 1042
    },
    {
        "Name": "ctgAPLB01043470",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01043471",
        "Length": 1005
    },
    {
        "Name": "ctgAPLB01043472",
        "Length": 1479
    },
    {
        "Name": "ctgAPLB01043473",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01043474",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01043475",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01043476",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01043477",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01043478",
        "Length": 1367
    },
    {
        "Name": "ctgAPLB01043481",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01043482",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01043483",
        "Length": 1577
    },
    {
        "Name": "ctgAPLB01043484",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01043485",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01043486",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01043487",
        "Length": 780
    },
    {
        "Name": "ctgAPLB01043488",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01043489",
        "Length": 816
    },
    {
        "Name": "ctgAPLB01043490",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01043491",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01043492",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01043493",
        "Length": 996
    },
    {
        "Name": "ctgAPLB01043494",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01043495",
        "Length": 591
    },
    {
        "Name": "ctgAPLB01043497",
        "Length": 953
    },
    {
        "Name": "ctgAPLB01043498",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01043499",
        "Length": 2029
    },
    {
        "Name": "ctgAPLB01043500",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01043501",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01043502",
        "Length": 783
    },
    {
        "Name": "ctgAPLB01043503",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01043504",
        "Length": 2980
    },
    {
        "Name": "ctgAPLB01043505",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01043506",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01043507",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01043510",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01043511",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01043512",
        "Length": 560
    },
    {
        "Name": "ctgAPLB01043513",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01043514",
        "Length": 576
    },
    {
        "Name": "ctgAPLB01043515",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01043518",
        "Length": 807
    },
    {
        "Name": "ctgAPLB01043519",
        "Length": 872
    },
    {
        "Name": "ctgAPLB01043520",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01043521",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01043522",
        "Length": 1194
    },
    {
        "Name": "ctgAPLB01043523",
        "Length": 1436
    },
    {
        "Name": "ctgAPLB01043524",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01043525",
        "Length": 448
    },
    {
        "Name": "ctgAPLB01043526",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01043527",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01043528",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01043529",
        "Length": 470
    },
    {
        "Name": "ctgAPLB01043530",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01043531",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01043532",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01043533",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01043534",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01043535",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01043536",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01043537",
        "Length": 3602
    },
    {
        "Name": "ctgAPLB01043538",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01043541",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01043542",
        "Length": 2623
    },
    {
        "Name": "ctgAPLB01043543",
        "Length": 958
    },
    {
        "Name": "ctgAPLB01043544",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01043545",
        "Length": 2807
    },
    {
        "Name": "ctgAPLB01043546",
        "Length": 1483
    },
    {
        "Name": "ctgAPLB01043547",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01043548",
        "Length": 775
    },
    {
        "Name": "ctgAPLB01043549",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01043550",
        "Length": 1096
    },
    {
        "Name": "ctgAPLB01043551",
        "Length": 878
    },
    {
        "Name": "ctgAPLB01043552",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01043553",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01043554",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01043555",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01043556",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01043557",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01043558",
        "Length": 633
    },
    {
        "Name": "ctgAPLB01043559",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01043560",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01043561",
        "Length": 813
    },
    {
        "Name": "ctgAPLB01043562",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01043563",
        "Length": 879
    },
    {
        "Name": "ctgAPLB01043564",
        "Length": 1484
    },
    {
        "Name": "ctgAPLB01043565",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01043567",
        "Length": 2151
    },
    {
        "Name": "ctgAPLB01043568",
        "Length": 1038
    },
    {
        "Name": "ctgAPLB01043569",
        "Length": 2340
    },
    {
        "Name": "ctgAPLB01043570",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01043571",
        "Length": 898
    },
    {
        "Name": "ctgAPLB01043572",
        "Length": 12287
    },
    {
        "Name": "ctgAPLB01043573",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01043574",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01043575",
        "Length": 895
    },
    {
        "Name": "ctgAPLB01043578",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01043581",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01043582",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01043583",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01043586",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01043587",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01043588",
        "Length": 2429
    },
    {
        "Name": "ctgAPLB01043589",
        "Length": 1557
    },
    {
        "Name": "ctgAPLB01043595",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01043596",
        "Length": 754
    },
    {
        "Name": "ctgAPLB01043597",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01043598",
        "Length": 1457
    },
    {
        "Name": "ctgAPLB01043599",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01043600",
        "Length": 862
    },
    {
        "Name": "ctgAPLB01043601",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01043604",
        "Length": 1299
    },
    {
        "Name": "ctgAPLB01043605",
        "Length": 2444
    },
    {
        "Name": "ctgAPLB01043606",
        "Length": 919
    },
    {
        "Name": "ctgAPLB01043607",
        "Length": 10390
    },
    {
        "Name": "ctgAPLB01043610",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01043611",
        "Length": 652
    },
    {
        "Name": "ctgAPLB01043612",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01043613",
        "Length": 1059
    },
    {
        "Name": "ctgAPLB01043614",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01043615",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01043616",
        "Length": 606
    },
    {
        "Name": "ctgAPLB01043617",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01043618",
        "Length": 925
    },
    {
        "Name": "ctgAPLB01043619",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01043620",
        "Length": 1167
    },
    {
        "Name": "ctgAPLB01043621",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01043622",
        "Length": 679
    },
    {
        "Name": "ctgAPLB01043623",
        "Length": 996
    },
    {
        "Name": "ctgAPLB01043624",
        "Length": 1231
    },
    {
        "Name": "ctgAPLB01043625",
        "Length": 950
    },
    {
        "Name": "ctgAPLB01043626",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01043627",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01043628",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01043629",
        "Length": 826
    },
    {
        "Name": "ctgAPLB01043630",
        "Length": 802
    },
    {
        "Name": "ctgAPLB01043631",
        "Length": 755
    },
    {
        "Name": "ctgAPLB01043633",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01043634",
        "Length": 972
    },
    {
        "Name": "ctgAPLB01043635",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01043636",
        "Length": 839
    },
    {
        "Name": "ctgAPLB01043637",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01043638",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01043639",
        "Length": 1345
    },
    {
        "Name": "ctgAPLB01043640",
        "Length": 587
    },
    {
        "Name": "ctgAPLB01043643",
        "Length": 757
    },
    {
        "Name": "ctgAPLB01043644",
        "Length": 1007
    },
    {
        "Name": "ctgAPLB01043645",
        "Length": 2579
    },
    {
        "Name": "ctgAPLB01043646",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01043647",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01043648",
        "Length": 633
    },
    {
        "Name": "ctgAPLB01043649",
        "Length": 821
    },
    {
        "Name": "ctgAPLB01043650",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01043651",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01043652",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01043653",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01043654",
        "Length": 874
    },
    {
        "Name": "ctgAPLB01043655",
        "Length": 736
    },
    {
        "Name": "ctgAPLB01043656",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01043657",
        "Length": 3839
    },
    {
        "Name": "ctgAPLB01043658",
        "Length": 640
    },
    {
        "Name": "ctgAPLB01043659",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01043660",
        "Length": 2422
    },
    {
        "Name": "ctgAPLB01043661",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01043662",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01043663",
        "Length": 1316
    },
    {
        "Name": "ctgAPLB01043664",
        "Length": 2122
    },
    {
        "Name": "ctgAPLB01043665",
        "Length": 1059
    },
    {
        "Name": "ctgAPLB01043666",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01043667",
        "Length": 876
    },
    {
        "Name": "ctgAPLB01043668",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01043669",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01043670",
        "Length": 875
    },
    {
        "Name": "ctgAPLB01043671",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01043672",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01043673",
        "Length": 1033
    },
    {
        "Name": "ctgAPLB01043674",
        "Length": 1142
    },
    {
        "Name": "ctgAPLB01043677",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01043678",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01043679",
        "Length": 955
    },
    {
        "Name": "ctgAPLB01043680",
        "Length": 1763
    },
    {
        "Name": "ctgAPLB01043683",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01043688",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01043689",
        "Length": 642
    },
    {
        "Name": "ctgAPLB01043690",
        "Length": 979
    },
    {
        "Name": "ctgAPLB01043692",
        "Length": 1122
    },
    {
        "Name": "ctgAPLB01043693",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01043694",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01043695",
        "Length": 2142
    },
    {
        "Name": "ctgAPLB01043696",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01043697",
        "Length": 2403
    },
    {
        "Name": "ctgAPLB01043698",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01043699",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01043700",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01043701",
        "Length": 1326
    },
    {
        "Name": "ctgAPLB01043702",
        "Length": 1072
    },
    {
        "Name": "ctgAPLB01043703",
        "Length": 1334
    },
    {
        "Name": "ctgAPLB01043704",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01043705",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01043706",
        "Length": 1116
    },
    {
        "Name": "ctgAPLB01043707",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01043708",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01043709",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01043711",
        "Length": 931
    },
    {
        "Name": "ctgAPLB01043712",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01043713",
        "Length": 1235
    },
    {
        "Name": "ctgAPLB01043714",
        "Length": 1257
    },
    {
        "Name": "ctgAPLB01043715",
        "Length": 1032
    },
    {
        "Name": "ctgAPLB01043716",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01043717",
        "Length": 1150
    },
    {
        "Name": "ctgAPLB01043718",
        "Length": 1180
    },
    {
        "Name": "ctgAPLB01043719",
        "Length": 3183
    },
    {
        "Name": "ctgAPLB01043720",
        "Length": 2200
    },
    {
        "Name": "ctgAPLB01043722",
        "Length": 2023
    },
    {
        "Name": "ctgAPLB01043725",
        "Length": 7727
    },
    {
        "Name": "ctgAPLB01043726",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01043727",
        "Length": 653
    },
    {
        "Name": "ctgAPLB01043728",
        "Length": 944
    },
    {
        "Name": "ctgAPLB01043729",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01043732",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01043733",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01043735",
        "Length": 1525
    },
    {
        "Name": "ctgAPLB01043736",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01043739",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01043742",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01043743",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01043744",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01043745",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01043746",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01043747",
        "Length": 625
    },
    {
        "Name": "ctgAPLB01043748",
        "Length": 1327
    },
    {
        "Name": "ctgAPLB01043751",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01043754",
        "Length": 1449
    },
    {
        "Name": "ctgAPLB01043755",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01043756",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01043757",
        "Length": 2436
    },
    {
        "Name": "ctgAPLB01043760",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01043761",
        "Length": 2231
    },
    {
        "Name": "ctgAPLB01043766",
        "Length": 978
    },
    {
        "Name": "ctgAPLB01043767",
        "Length": 2451
    },
    {
        "Name": "ctgAPLB01043768",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01043771",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043772",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043773",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043774",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043775",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043776",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043777",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043778",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043779",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043780",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043781",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043782",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043783",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043784",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043785",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043786",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043787",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043788",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043789",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043790",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043791",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043792",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043793",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043794",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043795",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043796",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043798",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043799",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043800",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043801",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043802",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043803",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043804",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043805",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043806",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043807",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043808",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043809",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043810",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043811",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043812",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043813",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043814",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043815",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043816",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043817",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043818",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043819",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043820",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043821",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043822",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043823",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043824",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043825",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043826",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043827",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043828",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043830",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043831",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043832",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043833",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043834",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043835",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043836",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043837",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043838",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043839",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043841",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043842",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043843",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043844",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043845",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043846",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043847",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043848",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043849",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043850",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043851",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043852",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043853",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043854",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043855",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043856",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043857",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043858",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043859",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043860",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043861",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043862",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043863",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043864",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043865",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043866",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043867",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043868",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043869",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043870",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043871",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043872",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043873",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043874",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043875",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043876",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043877",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043878",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043879",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043880",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043881",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043882",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043883",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043884",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043885",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043886",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043887",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043888",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043889",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043890",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043891",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043892",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043893",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043894",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043895",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043896",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043897",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043898",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043899",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043900",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043901",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043902",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043903",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043904",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043905",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043906",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043907",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043908",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043909",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043910",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043911",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01043912",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043913",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043914",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043915",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043916",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043917",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043918",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043919",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043920",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043921",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043922",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043923",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043924",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043925",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043926",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043927",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043928",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043929",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043930",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043931",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043932",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043933",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043934",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043935",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043936",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043937",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043938",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043939",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043940",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043941",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043942",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043943",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043944",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043945",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043946",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043947",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043948",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043949",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043950",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043951",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043952",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043953",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043954",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043955",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043956",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043957",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043958",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043959",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043960",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043961",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043962",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043963",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043964",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043965",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043966",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043967",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043968",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043969",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043970",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043971",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043972",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043973",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043974",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043975",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043976",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043977",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043978",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043979",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043980",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043981",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043982",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043983",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043984",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043985",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043986",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043987",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043988",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043989",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043990",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043991",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043992",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043993",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043994",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043995",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043996",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043997",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01043998",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01043999",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044000",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044001",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044002",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044003",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01044004",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044005",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044006",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044007",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044008",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044009",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044010",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044011",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044012",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044014",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044015",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044016",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044017",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044018",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044019",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044020",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01044021",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044022",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044023",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044024",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044025",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044026",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044027",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044028",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044029",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044030",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044031",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044032",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044033",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044034",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044035",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044036",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044037",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044038",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044039",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044040",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044041",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044042",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044043",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044044",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044045",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044046",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044047",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044048",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044049",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044050",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044051",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044052",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044053",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044054",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044055",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044056",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044057",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044058",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044059",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044060",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044061",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044062",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044063",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044064",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044065",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044066",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044067",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044068",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044069",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044070",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044071",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044072",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044073",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044074",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044075",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044076",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044077",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044078",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044079",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044080",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044081",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044082",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044083",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044084",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044085",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044086",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044087",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044088",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044089",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044090",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044091",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044092",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044093",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044094",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044095",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044096",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044097",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044098",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044099",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044100",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044101",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044102",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044103",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044104",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044105",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044106",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044107",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044108",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044109",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044110",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044111",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044112",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044113",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044114",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044115",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044116",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044117",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044118",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044119",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044120",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044121",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044122",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044123",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044124",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044125",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044126",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044127",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044128",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044129",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044130",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044131",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044132",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044133",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044134",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044135",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044136",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044137",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044138",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044139",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044140",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044141",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044142",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044143",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044144",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044145",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044146",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044147",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044148",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044149",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044150",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044151",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044152",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044153",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044154",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044155",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044156",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044157",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044158",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044159",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044160",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044161",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044162",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044163",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044164",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044165",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044166",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044167",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044168",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044169",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044170",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044171",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044172",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044173",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044174",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044175",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044176",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044177",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044178",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044179",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044180",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044181",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044182",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044183",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044184",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044185",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044186",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044187",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044188",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044189",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044190",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044191",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044192",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044193",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044194",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044195",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044196",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044197",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044198",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044199",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044200",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044201",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044202",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044203",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044204",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044205",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044206",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044207",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044208",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044209",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044210",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044211",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044212",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044213",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01044214",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044215",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044216",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044217",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044219",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044220",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044221",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044222",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044223",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044224",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044225",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044226",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044227",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044228",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044229",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044230",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044231",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044232",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044233",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044234",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044235",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044236",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044237",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044238",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044239",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044240",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044241",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044242",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044243",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044244",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044245",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044246",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044247",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044248",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044249",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044250",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044251",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044252",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044253",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044254",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044255",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044256",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044257",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044258",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044259",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044260",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044261",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044262",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044263",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044264",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044265",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044266",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044267",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044268",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044269",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044270",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044271",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044272",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044273",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044274",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044275",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044276",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044277",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044278",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044279",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044280",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044281",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044282",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044283",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044284",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044285",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044286",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044287",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044288",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01044289",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044290",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044291",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044292",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044293",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044294",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044295",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044296",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044297",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044298",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044299",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044300",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044301",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044302",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044303",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044304",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044305",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044306",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044307",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044308",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044309",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044310",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044311",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044312",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044313",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044314",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044315",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044316",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044317",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044318",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044319",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044320",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044321",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044322",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044323",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044324",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044325",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044326",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044327",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044328",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044329",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044330",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044331",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044332",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044333",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044334",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044335",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044336",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044337",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044338",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044339",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044340",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044341",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044342",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044343",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044344",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044345",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044346",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044347",
        "Length": 201
    },
    {
        "Name": "ctgAPLB01044348",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044349",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044350",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044351",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044352",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044353",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044354",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044355",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044356",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044357",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044358",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044359",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044360",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044361",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044362",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044363",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044364",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044365",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044366",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044367",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044368",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044369",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044370",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044371",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044372",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044373",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044374",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044375",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044376",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044377",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044378",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044379",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044380",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044381",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044382",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044383",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044384",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044385",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044386",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044387",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044388",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044389",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044390",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044391",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044392",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044393",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044394",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044395",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044396",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044397",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044398",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044399",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044400",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044401",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044402",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044403",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044404",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044405",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044406",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044407",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044408",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044409",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044410",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044411",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044412",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044413",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044414",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044415",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044416",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044417",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044418",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044419",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044420",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044421",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044422",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044423",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044424",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044425",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044426",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044427",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044428",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044429",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044430",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044431",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044432",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044433",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044434",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044435",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044436",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044437",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044438",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044439",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044440",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044441",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044442",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044443",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044444",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044445",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044446",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044447",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044448",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044449",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044450",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044451",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044452",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044453",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044454",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044455",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044456",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044457",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044458",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044459",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044460",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044461",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044462",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044463",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044464",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044465",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044466",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044467",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044468",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044469",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044470",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044471",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044472",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044473",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044474",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044475",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044476",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044477",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044478",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044479",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044480",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044481",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044482",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044483",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044484",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044485",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044486",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044487",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044488",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044489",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044490",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044491",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044492",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044493",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044494",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044495",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044496",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044497",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044498",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044499",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044501",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044502",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044503",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044504",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044505",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044506",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044507",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044508",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044509",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044510",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044511",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044512",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044513",
        "Length": 205
    },
    {
        "Name": "ctgAPLB01044514",
        "Length": 202
    },
    {
        "Name": "ctgAPLB01044515",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044516",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044517",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044518",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044519",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044520",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044521",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044522",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044523",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044524",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044525",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044526",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044527",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044528",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044529",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044530",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044531",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044532",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01044533",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044534",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044535",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044536",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044537",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044538",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044539",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044540",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044541",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044542",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044543",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044544",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044545",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044546",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044547",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044548",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044549",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044550",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044551",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044552",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044553",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044554",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044555",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044556",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044557",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044558",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044559",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044560",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044561",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044562",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044563",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044564",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044565",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044566",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044567",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044568",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044569",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044570",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044571",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044572",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044573",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044574",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044575",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044576",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044577",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044578",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044579",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044580",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044581",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044582",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044583",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044584",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044585",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044586",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044587",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044588",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044589",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044590",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044591",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044592",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044593",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044594",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044595",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044596",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044597",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044598",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044599",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044600",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044601",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044602",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044603",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044604",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044605",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044606",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044607",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044608",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044609",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044610",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044611",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044612",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044613",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044614",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044615",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044616",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044617",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044618",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044619",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044620",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044621",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044622",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044623",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044624",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044625",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044626",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044627",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044628",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044629",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044630",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044631",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044632",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044633",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044634",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044635",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044636",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044637",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044638",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044639",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044640",
        "Length": 204
    },
    {
        "Name": "ctgAPLB01044641",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044642",
        "Length": 200
    },
    {
        "Name": "ctgAPLB01044643",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044644",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044645",
        "Length": 206
    },
    {
        "Name": "ctgAPLB01044646",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01044647",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044648",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044649",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044650",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044651",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044652",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044653",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044654",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044655",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044656",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044657",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044658",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044659",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044660",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044661",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044662",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044663",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044664",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044665",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044666",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044667",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044668",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044669",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044670",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044671",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044672",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044673",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044674",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044675",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044676",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044677",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044678",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044679",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044680",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044681",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044682",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044683",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044684",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044685",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044686",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044687",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044688",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044689",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044690",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044691",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044692",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044693",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044694",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044695",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044696",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044697",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044698",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044699",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044700",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044701",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044702",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044703",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044704",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044705",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044706",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044707",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044708",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044709",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044710",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044711",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044712",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044713",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044714",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044715",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044716",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044717",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044718",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044719",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044720",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044721",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044722",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044723",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044724",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044725",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044726",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044727",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044729",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044730",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044731",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044732",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044733",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044734",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044735",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044736",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044737",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044738",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044739",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044740",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044742",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044743",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044744",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044745",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044746",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044747",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044748",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044749",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044750",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044751",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044752",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044753",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044754",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044755",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044756",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044757",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044758",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044759",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044760",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044761",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044762",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044763",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044764",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044765",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044766",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044767",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044768",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044769",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044770",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044771",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044772",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044773",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044774",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044775",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044776",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044777",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044778",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044779",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044780",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044781",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044782",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044783",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044784",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044785",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044786",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044787",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044788",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044789",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044790",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044791",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044792",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044793",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044794",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044795",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044796",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044797",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044798",
        "Length": 208
    },
    {
        "Name": "ctgAPLB01044799",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044800",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044801",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044802",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044803",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044804",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044805",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044806",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044807",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044808",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044809",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044810",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044811",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044812",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044813",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044814",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044815",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044816",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044817",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044818",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044819",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044820",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044821",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044822",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044823",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044824",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044825",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044826",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044827",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044828",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044829",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044830",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044831",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044832",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044833",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044834",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044835",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044836",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044837",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044838",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044839",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044840",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044841",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044842",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044843",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044844",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044845",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044846",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044847",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044848",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044849",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044850",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044851",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044852",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044853",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044854",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044855",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044856",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044857",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044858",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044859",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044860",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044861",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044862",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044863",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044864",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044865",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044866",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044867",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044868",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044869",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044870",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01044871",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044872",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044873",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044874",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044875",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044876",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044877",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044878",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044879",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044880",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044881",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044882",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044883",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044884",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044885",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044886",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044887",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044888",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044889",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044890",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044891",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044892",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044893",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044895",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044896",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044897",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044898",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044899",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044900",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044901",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044902",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044903",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044904",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044905",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044906",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044907",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044908",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044909",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044910",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044911",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044912",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044913",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044914",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044915",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044916",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044917",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01044918",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044919",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044920",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044921",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044922",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044923",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044924",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044925",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044926",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044927",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044928",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044929",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044930",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044931",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044932",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044933",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044934",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044935",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044936",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044937",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044938",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044939",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044940",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044941",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044942",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044943",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044944",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044945",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044946",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044947",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044948",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044949",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044950",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044951",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044952",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044953",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044954",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044955",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044956",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044957",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044958",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044959",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044960",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044961",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044962",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044963",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044964",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044965",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044966",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044967",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044968",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044969",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044970",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044971",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044972",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044973",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044974",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044975",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044976",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044977",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044978",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044979",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044980",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044981",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044982",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044983",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044984",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044985",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044986",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044987",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044988",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044989",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01044990",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044991",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044992",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044993",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044994",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044995",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044996",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044997",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044998",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01044999",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045000",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045001",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045002",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045003",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01045004",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045005",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045006",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045007",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045008",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045009",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045010",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045011",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045012",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045013",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045014",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045015",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045016",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045017",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045018",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045019",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045020",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045021",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045022",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045023",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045024",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045025",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045026",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045027",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045028",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045029",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045030",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045031",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045032",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045033",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045034",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045035",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045036",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045037",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045038",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045039",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045040",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045041",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045042",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045044",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045045",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045046",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045047",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045048",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045049",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045050",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01045051",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045052",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045053",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045054",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045055",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045056",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045057",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045058",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045059",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045060",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045061",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045062",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045063",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045064",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045065",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045066",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045067",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045068",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045069",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045070",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045071",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045072",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045073",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045074",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045075",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045076",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045077",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045078",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045079",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045080",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045081",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045082",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045083",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045084",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045085",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045086",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045087",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045088",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045089",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045090",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01045091",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045092",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045093",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045094",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045095",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045096",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045097",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045098",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045099",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045100",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045101",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045102",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045103",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045104",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045105",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045106",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045107",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045108",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045109",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045110",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045111",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045112",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045113",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045114",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045115",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045116",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045117",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045118",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045119",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045120",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045121",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045122",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045123",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045124",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045125",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045126",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045127",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045128",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045129",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045130",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045131",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045132",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045133",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01045134",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045135",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045136",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045137",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045138",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045139",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045140",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045141",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045142",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045143",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045144",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045145",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045146",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045147",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045148",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045149",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045150",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045151",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045152",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045153",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045154",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045155",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045156",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045157",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045158",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045159",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045160",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045161",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045162",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045163",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045164",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045165",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045166",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045167",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045168",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045169",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045170",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045171",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045172",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045173",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045174",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045175",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045176",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01045177",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045178",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045179",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045180",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045181",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045182",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045183",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045184",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045185",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045186",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045187",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045188",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045189",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045190",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045191",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045192",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045193",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045194",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045195",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045196",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045197",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045198",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045199",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01045200",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045201",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045202",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045203",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045204",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045205",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045206",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045207",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045208",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045209",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045210",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045211",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045212",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045213",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045214",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045215",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045216",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045217",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045218",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045219",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045220",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045221",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045222",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045223",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045224",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045225",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045226",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045227",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045228",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045229",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045230",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045231",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045232",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045233",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045234",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045235",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045236",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045237",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045238",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045239",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045240",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045241",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045242",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045243",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045244",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045245",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045246",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045247",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045248",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045249",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045250",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045251",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045252",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045253",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045254",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045255",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045256",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045257",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045258",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045259",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045260",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045261",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045262",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045263",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045264",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01045265",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045266",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045267",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045268",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045269",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045270",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045271",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045272",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045273",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045274",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045275",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045276",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045277",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045278",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045279",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045280",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045281",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045282",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045283",
        "Length": 209
    },
    {
        "Name": "ctgAPLB01045284",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045285",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045286",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045287",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045288",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045289",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045290",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045291",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045292",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045293",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045294",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045295",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045296",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045297",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045298",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045299",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045300",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045301",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045302",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045303",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045304",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045305",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045306",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045307",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045308",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045309",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045310",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01045311",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045312",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045313",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045314",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045315",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045316",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045317",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045318",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045319",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045320",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045321",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045322",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045323",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045324",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045325",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045326",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045327",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045328",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045329",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045330",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045331",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045332",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045333",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045334",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045335",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045336",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045337",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045338",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045339",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045340",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045341",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045342",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045343",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045344",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045345",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045346",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045347",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045348",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045349",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045350",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045351",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045352",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045353",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045354",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045355",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045356",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045357",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045358",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045359",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045360",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045361",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045362",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045363",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045364",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045365",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045366",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045367",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045368",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045369",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045370",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045371",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045372",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045373",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045374",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045375",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045376",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045377",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045378",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045379",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045380",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045381",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045382",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045383",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045384",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045385",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045386",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045387",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045388",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045389",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045390",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045391",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045392",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045393",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045394",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045395",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045396",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045397",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045398",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045399",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045400",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045401",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045402",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045403",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045404",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045405",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045406",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045407",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045408",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045409",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045410",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045411",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045412",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045413",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045414",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045415",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045416",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045417",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045418",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045419",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045420",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045421",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045422",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045423",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045424",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045425",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045426",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045427",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045428",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045429",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045430",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045431",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045432",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045433",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045434",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045435",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045436",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045437",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045438",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045439",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045440",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045441",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045442",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045443",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045444",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045445",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045446",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045447",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045448",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045449",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045450",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045451",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045452",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045453",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045454",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045455",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045456",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045457",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045458",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045459",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045460",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045461",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045462",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045463",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045464",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045465",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045466",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045467",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045468",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045469",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045470",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045471",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045472",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045473",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045474",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045475",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045476",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045477",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045478",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045479",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045480",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045482",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045483",
        "Length": 214
    },
    {
        "Name": "ctgAPLB01045484",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045485",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045486",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045487",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045488",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045489",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045490",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045491",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045492",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045493",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045494",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045495",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045496",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045497",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045498",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045499",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045500",
        "Length": 210
    },
    {
        "Name": "ctgAPLB01045501",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045502",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045503",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045504",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045505",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045506",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045507",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045508",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01045509",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045510",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045511",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045512",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045513",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045514",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045515",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045516",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045517",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045518",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045519",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045520",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045521",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045522",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045523",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045524",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045525",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045526",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045527",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045528",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045529",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045530",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045531",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045532",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045533",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045534",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045535",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045536",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045537",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045538",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045540",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045541",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045542",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045543",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045544",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045545",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045546",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045547",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045548",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045549",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01045550",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045551",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045552",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045553",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045554",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045555",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045556",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045557",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045558",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045559",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045560",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045561",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045562",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045563",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045564",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045565",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045566",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045567",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045568",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045569",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045570",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045571",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045572",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045573",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045574",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045575",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045576",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045577",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045578",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045579",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045580",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045581",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045582",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045583",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045584",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045585",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045586",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045587",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045588",
        "Length": 216
    },
    {
        "Name": "ctgAPLB01045589",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045590",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045591",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045592",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045593",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045594",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045595",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045596",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045597",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045598",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045599",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045600",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045601",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045602",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045603",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045604",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045605",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045606",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045607",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045608",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045609",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045610",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045611",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045612",
        "Length": 215
    },
    {
        "Name": "ctgAPLB01045613",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045614",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045615",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045616",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045617",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045618",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045619",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045620",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045621",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045622",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045623",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045624",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045625",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045626",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045627",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045628",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045629",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045630",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045631",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045632",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045633",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045634",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045635",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045636",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045637",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045638",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045639",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045640",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045641",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045642",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045643",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045644",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045645",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045646",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045647",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045648",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045649",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045650",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045651",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045652",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045653",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045654",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045655",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045656",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045657",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045658",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045659",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045660",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045661",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045662",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045663",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045664",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045665",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045666",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045667",
        "Length": 203
    },
    {
        "Name": "ctgAPLB01045668",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045669",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045670",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045671",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045672",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045673",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045674",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045675",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045676",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045677",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045678",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045679",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045680",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045681",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045682",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045683",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045684",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045685",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045686",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045687",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045688",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045690",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045691",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045692",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045693",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045694",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045695",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045696",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045697",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045698",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045699",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045700",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045701",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045702",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045703",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045704",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045705",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045706",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045707",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045708",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045709",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045710",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045711",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045712",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045713",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01045714",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045715",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045716",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045717",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045718",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045719",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045720",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045721",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045722",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045723",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045724",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045725",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045726",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045727",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045728",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045729",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045730",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045731",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045732",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045733",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045734",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045735",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045736",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045737",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045738",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045739",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045740",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01045741",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01045742",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045743",
        "Length": 219
    },
    {
        "Name": "ctgAPLB01045744",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045745",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045746",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045747",
        "Length": 220
    },
    {
        "Name": "ctgAPLB01045748",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045749",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045750",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045751",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045752",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045753",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045754",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01045755",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045756",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045757",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045758",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045759",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045760",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045761",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045762",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045763",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045764",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045765",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045766",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045767",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045768",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045769",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045770",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045771",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045772",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045773",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045774",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045775",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045776",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045777",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045778",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045779",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045780",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045781",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045782",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045783",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045784",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045785",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045786",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045787",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045788",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045789",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045790",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045791",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045792",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045793",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045794",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045795",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045796",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045797",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045798",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045799",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045800",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045801",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045802",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045803",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045804",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045805",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045806",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045807",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045808",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045809",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045810",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045811",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045812",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045813",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045814",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045815",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045816",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045817",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045818",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045819",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045820",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045821",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045822",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045823",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045824",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045825",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045826",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045827",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045828",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045829",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045830",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045831",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045832",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045833",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045834",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045835",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045836",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045837",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045838",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045839",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045840",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045841",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045842",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045843",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045844",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045845",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045846",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045847",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045848",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045849",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045850",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045851",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045852",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045853",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045854",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045855",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045856",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045857",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045858",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045859",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045860",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045861",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045862",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045863",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045864",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045865",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045866",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045867",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045868",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045869",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045870",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045871",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045872",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045873",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045874",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045875",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045876",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045877",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045878",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045879",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045880",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045881",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045882",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045883",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045884",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045885",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045886",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045887",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045888",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045889",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045890",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045891",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045892",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045893",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045894",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045895",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045896",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045897",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045898",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045899",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045900",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045901",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045902",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045903",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045904",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045905",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045906",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045907",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045908",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045909",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045910",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045911",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045912",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045913",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045914",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045915",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045916",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045917",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045918",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045919",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045920",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045921",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045922",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045923",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045924",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045925",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045926",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045927",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045928",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045929",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045930",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045931",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045932",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045933",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045934",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045935",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045936",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045937",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045938",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045939",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045940",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045941",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045942",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045943",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045944",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045945",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045946",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045947",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045948",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045949",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01045951",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045952",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045953",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045954",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045955",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045956",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045957",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045958",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045959",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045960",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045961",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045962",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045963",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045964",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045965",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045966",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045967",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045968",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045969",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045970",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045971",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045972",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045973",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045974",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045975",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045976",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045977",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045978",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045979",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045980",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045981",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045982",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045983",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045984",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01045985",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045986",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045987",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045988",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045989",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045990",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045991",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045992",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01045993",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045994",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045995",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045996",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045997",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045998",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01045999",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046000",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046001",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046002",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046003",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046004",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01046005",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046006",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046007",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046008",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046009",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046010",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046011",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046012",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046013",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046014",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046015",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046016",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046017",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046018",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046019",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046020",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046021",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046022",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046023",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046024",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046025",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046026",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046027",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046028",
        "Length": 221
    },
    {
        "Name": "ctgAPLB01046029",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046030",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046031",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046032",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046033",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046034",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046035",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046036",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046037",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046038",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046039",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046040",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046041",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046042",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046043",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046044",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046045",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046046",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046047",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046048",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046049",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046050",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046051",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046052",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046053",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046054",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046055",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046056",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046057",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046058",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046059",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046060",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046061",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046062",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046063",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046064",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046065",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046066",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046067",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046068",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046069",
        "Length": 213
    },
    {
        "Name": "ctgAPLB01046070",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046071",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046072",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046073",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046074",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046075",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046076",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046077",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046078",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046079",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046080",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046081",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046082",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046083",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046084",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046085",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046086",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046087",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046088",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046089",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046090",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046091",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046092",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046093",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046094",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046095",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046096",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046097",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046098",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046099",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046100",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046101",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046102",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046103",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046104",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046105",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046106",
        "Length": 217
    },
    {
        "Name": "ctgAPLB01046107",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046108",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046109",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046110",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046111",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046112",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046113",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046114",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046115",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046116",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046117",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046118",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046119",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046120",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046121",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046122",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046123",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046124",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046125",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046126",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046127",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046128",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046129",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046130",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046131",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046132",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046133",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046134",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046135",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046136",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046137",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046138",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046139",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046140",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046141",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046142",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046143",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046144",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046145",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046146",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046147",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046148",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046149",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046150",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046151",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046152",
        "Length": 218
    },
    {
        "Name": "ctgAPLB01046153",
        "Length": 224
    },
    {
        "Name": "ctgAPLB01046154",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046155",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046156",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046157",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046158",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046159",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046160",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046161",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046162",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046163",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046164",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046165",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046166",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046167",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046168",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046169",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046170",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046171",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046172",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046173",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046174",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046175",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046176",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046177",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046178",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046179",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046180",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046181",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046182",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046183",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046184",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046185",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046186",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046187",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046188",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046189",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046190",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046191",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046192",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046193",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046194",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046195",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046196",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046198",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046199",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046200",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046201",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046202",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046203",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046204",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046205",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046206",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046207",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046208",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046209",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046210",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046211",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046212",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046213",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046214",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046215",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046216",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046217",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046218",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046219",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046220",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046221",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046222",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046223",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046224",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046225",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046226",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046227",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046228",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046229",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046230",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046231",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046232",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046233",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046234",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046235",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046236",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046237",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046238",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046239",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046240",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046241",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046242",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046243",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046244",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046245",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046246",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046247",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046248",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046249",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046250",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046251",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046252",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046253",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046254",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046255",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046256",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046257",
        "Length": 207
    },
    {
        "Name": "ctgAPLB01046258",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046259",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046260",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046261",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046262",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046263",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046264",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046265",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046266",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046267",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046268",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046269",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046270",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046271",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046272",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046273",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046274",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046275",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046276",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046277",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046278",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046279",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046280",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046281",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046282",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046283",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046284",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046285",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046286",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046287",
        "Length": 227
    },
    {
        "Name": "ctgAPLB01046288",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046289",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046290",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046291",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046292",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046293",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046294",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046295",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046296",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046297",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046298",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046299",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046300",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046301",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046302",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046303",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046304",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046305",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046306",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046307",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046308",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046309",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046310",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046311",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046312",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046313",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046314",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046315",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046316",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046317",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046318",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046319",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046320",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046321",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046322",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046323",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046324",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046325",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046326",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046327",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046328",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046329",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046330",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046331",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046332",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046333",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046334",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046335",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046336",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046337",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046338",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046339",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046340",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046341",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046342",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046343",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046344",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046345",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046346",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046347",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046348",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046349",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046350",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046351",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046352",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046353",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046354",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046355",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046356",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046357",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046358",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046359",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046360",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046361",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046362",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046363",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046364",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046365",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046366",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046367",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046368",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046369",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046370",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046371",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046372",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046373",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046374",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046375",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046376",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046377",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046378",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046379",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046380",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046381",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046382",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046383",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046384",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046385",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046386",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046387",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046388",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046389",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046390",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046391",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046392",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046393",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046394",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046395",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046396",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046397",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046398",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046399",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046400",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046401",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046402",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046403",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046404",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046405",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046406",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046407",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046408",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046409",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046410",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046411",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046412",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046413",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046414",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046415",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046416",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046417",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046418",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046419",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046420",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046421",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046422",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046423",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046424",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046425",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046426",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046427",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046428",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01046429",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046430",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046431",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046432",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046433",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046434",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046435",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046436",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046437",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046438",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046439",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046440",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046441",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046442",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046443",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046444",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046445",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046446",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046447",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046448",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046449",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046450",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046451",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046452",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046453",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046454",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046455",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046456",
        "Length": 225
    },
    {
        "Name": "ctgAPLB01046457",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046458",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046459",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046460",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046461",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046462",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046463",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046464",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046465",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046466",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046467",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046468",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046469",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046470",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046471",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046472",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046473",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046474",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046475",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046476",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046477",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046478",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046479",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046480",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046481",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046482",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046483",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046484",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046485",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046486",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046487",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046488",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046489",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046490",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046491",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046492",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046493",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046494",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046495",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046496",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046497",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046498",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046499",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046500",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046501",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046502",
        "Length": 211
    },
    {
        "Name": "ctgAPLB01046503",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046504",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046505",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046506",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046507",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046508",
        "Length": 228
    },
    {
        "Name": "ctgAPLB01046509",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046510",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046511",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046512",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046513",
        "Length": 212
    },
    {
        "Name": "ctgAPLB01046514",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01046515",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046516",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046517",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046518",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046519",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046520",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046521",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046522",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046523",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046524",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046525",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046526",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046527",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046528",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046529",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046530",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046531",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046532",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046533",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046534",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046535",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046536",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046537",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046538",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046539",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046540",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046541",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046542",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046543",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046544",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046545",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046546",
        "Length": 233
    },
    {
        "Name": "ctgAPLB01046547",
        "Length": 223
    },
    {
        "Name": "ctgAPLB01046548",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046549",
        "Length": 230
    },
    {
        "Name": "ctgAPLB01046550",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046551",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046552",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046553",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046554",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046555",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046556",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046557",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046558",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046559",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046560",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046561",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046562",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046563",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046564",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046565",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046566",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046567",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046568",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046569",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046570",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046571",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046572",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046573",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046574",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046575",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046576",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046577",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046578",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046579",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046580",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046581",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046582",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046583",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046584",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046585",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046586",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046587",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046588",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046589",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046590",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046591",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046592",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046593",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046594",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046595",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046596",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046597",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046598",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046599",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046600",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046601",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046602",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046603",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046604",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046605",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046606",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046607",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046608",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046609",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046610",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046611",
        "Length": 229
    },
    {
        "Name": "ctgAPLB01046612",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046613",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046614",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046615",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046616",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046617",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046618",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046619",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046620",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046621",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046622",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046623",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046624",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046625",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046626",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046627",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046628",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046629",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046630",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046631",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046633",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046634",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046635",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046636",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046637",
        "Length": 232
    },
    {
        "Name": "ctgAPLB01046638",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046639",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046640",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046641",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046642",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046643",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046644",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046645",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046646",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046647",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046648",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046649",
        "Length": 226
    },
    {
        "Name": "ctgAPLB01046650",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046651",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046652",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046653",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046654",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046655",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046656",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046657",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046658",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046659",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046660",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046661",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046662",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046663",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046664",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046665",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046666",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046667",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046668",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046669",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046670",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046671",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046672",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046673",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046674",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046675",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046676",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046677",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046678",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046679",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046680",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046681",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046682",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046683",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046684",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046685",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046686",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046687",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046688",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046689",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046690",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046691",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046692",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046693",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046694",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046695",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046696",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046697",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046698",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046699",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046700",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046701",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046702",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046703",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046704",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046705",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046706",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046707",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046708",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046709",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046710",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046711",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046712",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046713",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046714",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046715",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046716",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046717",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046718",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046719",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046720",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046721",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046722",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046723",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046724",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046725",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046726",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046727",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046728",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046729",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046730",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046731",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046732",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046733",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046734",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046735",
        "Length": 222
    },
    {
        "Name": "ctgAPLB01046736",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046737",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046738",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046739",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046740",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046741",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046742",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046743",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046744",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046745",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046746",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046747",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046748",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046749",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046750",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046751",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046752",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046753",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046754",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046755",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046756",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046757",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046758",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046759",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046760",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046761",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046762",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046763",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046764",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046765",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046766",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046767",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046768",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046769",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046770",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046771",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046772",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046773",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046774",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046775",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046776",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046777",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046778",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046779",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046780",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046781",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046782",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046783",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046784",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046785",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046786",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046787",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046788",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046789",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046790",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046791",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046792",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046793",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046794",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046795",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046796",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046797",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046798",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046799",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046800",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046801",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046802",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046803",
        "Length": 2055
    },
    {
        "Name": "ctgAPLB01046804",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01046805",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046806",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046807",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046808",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046809",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046810",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046811",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046812",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046813",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046814",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046815",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046816",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046817",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046818",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046819",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01046820",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046821",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046822",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046823",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046824",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046825",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046826",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046827",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046828",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046829",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046830",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046831",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046832",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046833",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046834",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046835",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046836",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046837",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046838",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046839",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046840",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046841",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046842",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046843",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046844",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046845",
        "Length": 235
    },
    {
        "Name": "ctgAPLB01046846",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046847",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046848",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046849",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046850",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046851",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046852",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046853",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046854",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046855",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046856",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046857",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046858",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046859",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046860",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046861",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046862",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046863",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046864",
        "Length": 238
    },
    {
        "Name": "ctgAPLB01046865",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046866",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046867",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046868",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046869",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046870",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046871",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046872",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046873",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046874",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046875",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046876",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046878",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046879",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046880",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046881",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046882",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046883",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046884",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046885",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046886",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046887",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046888",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046889",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046890",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046891",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046892",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046893",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046894",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046895",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046896",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046897",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046898",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046899",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046900",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046901",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046902",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046903",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046904",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046905",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046906",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046907",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046908",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046909",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046910",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046911",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046912",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046913",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046914",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046915",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046916",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046917",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046918",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046919",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046920",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046921",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046922",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046923",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046924",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046925",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046926",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046927",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046928",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046929",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046930",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046931",
        "Length": 236
    },
    {
        "Name": "ctgAPLB01046932",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046933",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046934",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046935",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046936",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046937",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046938",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046939",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046940",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046941",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046942",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046943",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046944",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046945",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046946",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046947",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046948",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046949",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046950",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046951",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046952",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046953",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046954",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046955",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046956",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046957",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046958",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046959",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046960",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046961",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046962",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046963",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046964",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046965",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046966",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046967",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046968",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046969",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046970",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046971",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046972",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046973",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046974",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046975",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046976",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046977",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046978",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046979",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046980",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046981",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046982",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01046983",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046984",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046985",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046986",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01046987",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046988",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046989",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046990",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046991",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046992",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01046993",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046994",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046995",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046996",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046997",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046998",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01046999",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047000",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047001",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047002",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047003",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047004",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047005",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047006",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047007",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047008",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047009",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01047010",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047011",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047012",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047013",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047014",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047015",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047016",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047017",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047018",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047019",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047020",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047021",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047022",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047023",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047024",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047025",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047026",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047027",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047028",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047029",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047030",
        "Length": 240
    },
    {
        "Name": "ctgAPLB01047031",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047032",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047033",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047034",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047035",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01047036",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047037",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047038",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047039",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047040",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047041",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047043",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047044",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047045",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047046",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047047",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047048",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047049",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047051",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047052",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047053",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047054",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047055",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047056",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047057",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047058",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047059",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047060",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047061",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047062",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047063",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047064",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047065",
        "Length": 242
    },
    {
        "Name": "ctgAPLB01047066",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047067",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047068",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047069",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047070",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047071",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047072",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047073",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047074",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047075",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01047076",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047077",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047078",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047079",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047080",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047081",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047082",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047083",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047084",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047085",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047086",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047087",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047088",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047089",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047090",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047091",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047092",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047093",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047094",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047095",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047096",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047097",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047098",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047099",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047100",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047101",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047102",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047103",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047104",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047105",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047106",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047107",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047108",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047109",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047110",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047111",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047112",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047113",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047114",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047115",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047116",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047117",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047118",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047119",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047120",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047121",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047122",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047123",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047124",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047125",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047126",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047127",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047128",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047129",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047130",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047131",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047132",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047133",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047134",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047135",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047136",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047137",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047138",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047139",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047140",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047141",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047142",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047143",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047144",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047145",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047146",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047147",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047148",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047149",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047150",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047151",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047152",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047153",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047154",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01047155",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047156",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047157",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047158",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047159",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047160",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047161",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047162",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047163",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047164",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047165",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047166",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047167",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047168",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047169",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047170",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047171",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047172",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047173",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047174",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047175",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047176",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047177",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047178",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047179",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047180",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047181",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047182",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047183",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047184",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047185",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047186",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047187",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047188",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047189",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047190",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047191",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047192",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047193",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047194",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047195",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047196",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047197",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047198",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047199",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047200",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047201",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047202",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047203",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047204",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047205",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047206",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047207",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047208",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047209",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047210",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047211",
        "Length": 241
    },
    {
        "Name": "ctgAPLB01047212",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047213",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047214",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047215",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047216",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047217",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047218",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047219",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047220",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047221",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047222",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047223",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047224",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047225",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047226",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047227",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047228",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047229",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047230",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047231",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047232",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047233",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047234",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047235",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047236",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047237",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047238",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047239",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047240",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047241",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047242",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047243",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047244",
        "Length": 245
    },
    {
        "Name": "ctgAPLB01047245",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047246",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047247",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047248",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047249",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047250",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047251",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047252",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047253",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047254",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047255",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047256",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047257",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047258",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047259",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047260",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047261",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047262",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047264",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047265",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047266",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047267",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047268",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047269",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047270",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047271",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047272",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047273",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047274",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047275",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047276",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047277",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047278",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047279",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047280",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047281",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047282",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047283",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047284",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047285",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047286",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01047287",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047288",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047289",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047290",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047291",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047292",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047293",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047294",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047295",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047296",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047297",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047298",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047299",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047300",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047301",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047302",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047303",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047304",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047305",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047306",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047307",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047308",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047309",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047310",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047311",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047312",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047313",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047314",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047315",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047316",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047317",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047318",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047319",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047320",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047321",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047322",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047323",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047324",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047325",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047326",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047327",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047328",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047329",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047330",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047331",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047332",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047333",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047334",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047335",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047336",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047337",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047338",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047339",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047340",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047341",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047342",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047343",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047344",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047345",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047346",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047347",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047348",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047349",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047350",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047351",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047352",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047353",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047354",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047355",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047356",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047357",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047358",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047359",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047360",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047361",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047362",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047363",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047364",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047365",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047366",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047367",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047368",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047369",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047370",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047371",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047372",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047373",
        "Length": 237
    },
    {
        "Name": "ctgAPLB01047374",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047375",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047376",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047377",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047378",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047379",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047380",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047381",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047382",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047383",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047384",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047385",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047386",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047387",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047388",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047389",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047390",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047391",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047392",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047393",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047394",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047395",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047396",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047397",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047398",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047399",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047400",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047401",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047402",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047403",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047404",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047405",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047406",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047407",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047408",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047409",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047410",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047411",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047412",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047413",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047414",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047415",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047416",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047417",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047418",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047419",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047420",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047421",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01047422",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047423",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047424",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047425",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047426",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047427",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047428",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047429",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047430",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047431",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047432",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047433",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047434",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047435",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047436",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047437",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047438",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047439",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047440",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047441",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047442",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047443",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047444",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047445",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047446",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047447",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047448",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047449",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047450",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047451",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047452",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047453",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047454",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047455",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047456",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047457",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047458",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047459",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047460",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047461",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047462",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047463",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047464",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047465",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047466",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047467",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047468",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047469",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047470",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047471",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047472",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047473",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047474",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047475",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047476",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047477",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047478",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047479",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047480",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047481",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047482",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047483",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047484",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047485",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047486",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047487",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047488",
        "Length": 249
    },
    {
        "Name": "ctgAPLB01047489",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047490",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047491",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047492",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047493",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047494",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047495",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047496",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047497",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047498",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047499",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047500",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047501",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047502",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047503",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047504",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047505",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047506",
        "Length": 247
    },
    {
        "Name": "ctgAPLB01047507",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047508",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047509",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047510",
        "Length": 244
    },
    {
        "Name": "ctgAPLB01047511",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047512",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047513",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047514",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047515",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047516",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047517",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047518",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047519",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047520",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047521",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047522",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047523",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047524",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047525",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047526",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047527",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047528",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047529",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047530",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047531",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047532",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047533",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047534",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047535",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047536",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047537",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047538",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047539",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047540",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047541",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047542",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047543",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047544",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047545",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047546",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047547",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047548",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047549",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047550",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047552",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047553",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047554",
        "Length": 239
    },
    {
        "Name": "ctgAPLB01047555",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047556",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047557",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047558",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047559",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047560",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047561",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047562",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047563",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047564",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047565",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047566",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047567",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047568",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047569",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047570",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047571",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047572",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047573",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047574",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047575",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047576",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047577",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047578",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047579",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047580",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047581",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047582",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047583",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047584",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047585",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047586",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047587",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047588",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047589",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047590",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047591",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047592",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047593",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047594",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047595",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047596",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047597",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047598",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047599",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047600",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047601",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047602",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047603",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047604",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047605",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047606",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047607",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047608",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047609",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047610",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047611",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047612",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047613",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047614",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047615",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047616",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047617",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047618",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047619",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047620",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047621",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047622",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047623",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047624",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047625",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047626",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047627",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047628",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047629",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047630",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047631",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047632",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047633",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047634",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047635",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047636",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047637",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047638",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047639",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047640",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047641",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047642",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047643",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047644",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047645",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047646",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047647",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047648",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047649",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047650",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047651",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047652",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047653",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047654",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047655",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047656",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047657",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047658",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047659",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047660",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047661",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047662",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047663",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047664",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047665",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047666",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047667",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047668",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047669",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047670",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047671",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047672",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047674",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047675",
        "Length": 234
    },
    {
        "Name": "ctgAPLB01047676",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047677",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047678",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047679",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047680",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047681",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047682",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047683",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047684",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047685",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047686",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047687",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047688",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047689",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047690",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047691",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047692",
        "Length": 246
    },
    {
        "Name": "ctgAPLB01047693",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047694",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01047695",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047696",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047697",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047698",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047699",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047700",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01047701",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047702",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047703",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047704",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047705",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047706",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047707",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047708",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047709",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047710",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047711",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047712",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047713",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047714",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047716",
        "Length": 248
    },
    {
        "Name": "ctgAPLB01047717",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047718",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047719",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047720",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047721",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047722",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047723",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047724",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047725",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047726",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047727",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01047728",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047729",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047730",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047731",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047732",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047733",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047734",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047735",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047736",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047737",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047738",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047739",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047740",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047741",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047742",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047743",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047744",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047745",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047746",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047747",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047748",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047749",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047750",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047751",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047752",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047753",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047754",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047755",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047756",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047757",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047758",
        "Length": 250
    },
    {
        "Name": "ctgAPLB01047759",
        "Length": 251
    },
    {
        "Name": "ctgAPLB01047760",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047761",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047762",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047763",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047764",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047765",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047766",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047767",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047768",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047769",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047770",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047771",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047772",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047773",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047774",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047775",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047776",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047777",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047778",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047779",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047780",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047781",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047782",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047783",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047784",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047785",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047786",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047787",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047788",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047789",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047790",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047791",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047792",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047793",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047794",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047795",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047796",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047797",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047798",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047799",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047800",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047801",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047802",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047803",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047804",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047805",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047806",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047807",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047808",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047809",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047810",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047811",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047812",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047813",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047814",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047815",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047816",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047817",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047818",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047819",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047820",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047821",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047822",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047823",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047824",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047825",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047826",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047827",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047828",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047829",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047830",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047831",
        "Length": 254
    },
    {
        "Name": "ctgAPLB01047832",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047833",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047834",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047835",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047836",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047837",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047838",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047839",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047840",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047841",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047842",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047843",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047844",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047845",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01047846",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047847",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047848",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047849",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047850",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047851",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047852",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047853",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01047854",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047855",
        "Length": 256
    },
    {
        "Name": "ctgAPLB01047857",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047858",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047859",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047860",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047861",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047862",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047863",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047864",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01047865",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047866",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047867",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047868",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047869",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047870",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047871",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047872",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047873",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047874",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047875",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047876",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047877",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047878",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047879",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047880",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047881",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047882",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047883",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047884",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047885",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01047886",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047887",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047888",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047889",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047890",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047891",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047892",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047893",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047894",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047895",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047896",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047897",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047898",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047899",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047900",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047901",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047902",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047903",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047904",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047905",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047906",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01047907",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047908",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047909",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047910",
        "Length": 257
    },
    {
        "Name": "ctgAPLB01047911",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047912",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047913",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047914",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047915",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047916",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047917",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047918",
        "Length": 264
    },
    {
        "Name": "ctgAPLB01047919",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047920",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047921",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047922",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047923",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01047924",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047925",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047926",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047927",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047928",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047929",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047930",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047931",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047932",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047933",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047934",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047935",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047936",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047937",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047938",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047939",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047940",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047941",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047942",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047943",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047944",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047945",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047946",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047947",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047948",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047949",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047950",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047951",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047952",
        "Length": 265
    },
    {
        "Name": "ctgAPLB01047953",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047954",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047955",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047956",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047957",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047958",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047959",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047960",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047961",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047962",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047963",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047964",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047965",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047966",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047967",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047968",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047969",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047970",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047971",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047972",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047973",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047974",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047975",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047976",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047977",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047978",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047979",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047980",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047981",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047982",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047983",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047984",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047985",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047986",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047988",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047989",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047990",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047991",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01047992",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01047993",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01047994",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047995",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047996",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01047997",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01047998",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01047999",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01048000",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048001",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048002",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048003",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048004",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048005",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048006",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048007",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048008",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01048009",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048010",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048011",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01048012",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048013",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048014",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048015",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048016",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048017",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048018",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048019",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048020",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01048021",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048022",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048023",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048024",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048025",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01048026",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048027",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048028",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048029",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048030",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048031",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048032",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048033",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01048034",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048035",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048036",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048037",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048038",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048039",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048040",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048041",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048042",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01048043",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01048044",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048045",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048046",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048047",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048048",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048049",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048050",
        "Length": 262
    },
    {
        "Name": "ctgAPLB01048051",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048052",
        "Length": 269
    },
    {
        "Name": "ctgAPLB01048053",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048054",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048055",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048056",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048057",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048058",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048059",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048060",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048061",
        "Length": 253
    },
    {
        "Name": "ctgAPLB01048062",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048063",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048064",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048065",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048066",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048067",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048068",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048069",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048070",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048071",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048072",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048073",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048074",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048075",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048076",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048077",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048078",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048079",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048080",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048081",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048082",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048083",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048084",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048085",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048086",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048087",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048088",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048089",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048090",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048091",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048092",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048093",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048094",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048095",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048096",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048097",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048098",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048099",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048100",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048101",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048102",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048103",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048104",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048105",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048106",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048107",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048108",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048109",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048110",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048111",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048112",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048113",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048114",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048115",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048116",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048117",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048118",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048119",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048120",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048121",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048122",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048123",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048124",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048125",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048126",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048127",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048128",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048129",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048130",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048131",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048132",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048133",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048134",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048135",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048136",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048137",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048138",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048139",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048140",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048141",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048142",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048143",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048144",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048145",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048146",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048147",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048148",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048149",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048150",
        "Length": 272
    },
    {
        "Name": "ctgAPLB01048151",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048152",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048153",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048154",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048155",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048156",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048157",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048158",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048159",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048161",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048162",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048163",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048164",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048165",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048166",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048167",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048168",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048169",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048170",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048171",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048172",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048173",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048174",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048175",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048176",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048177",
        "Length": 259
    },
    {
        "Name": "ctgAPLB01048178",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048179",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048180",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048181",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048182",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048183",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048184",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048185",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048186",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048187",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048188",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048189",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048190",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048191",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048192",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048194",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048195",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048196",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048197",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048198",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048199",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048200",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048201",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048202",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048203",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048204",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048205",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048206",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048207",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048208",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048209",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048210",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048211",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048212",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048213",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048214",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048215",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048216",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048217",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048218",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048219",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048220",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048221",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048222",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048223",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048224",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048225",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048226",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048227",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048228",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048229",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048230",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048231",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048232",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048233",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048234",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048235",
        "Length": 275
    },
    {
        "Name": "ctgAPLB01048236",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048237",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048238",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048239",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048240",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048241",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048242",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048243",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048244",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048245",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048246",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048247",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048248",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048249",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048250",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048251",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048252",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048253",
        "Length": 260
    },
    {
        "Name": "ctgAPLB01048254",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048255",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048256",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048257",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048258",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048259",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048260",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048261",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048262",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048263",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048264",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048265",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048266",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048267",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048268",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048269",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048270",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048271",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048272",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048273",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048274",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048275",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048276",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048277",
        "Length": 273
    },
    {
        "Name": "ctgAPLB01048278",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048279",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048280",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048281",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048282",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048283",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048284",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048285",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048286",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048287",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048288",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048289",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048290",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01048291",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048292",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048293",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048294",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048295",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048296",
        "Length": 261
    },
    {
        "Name": "ctgAPLB01048297",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048298",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048299",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048300",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048301",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048302",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048303",
        "Length": 268
    },
    {
        "Name": "ctgAPLB01048304",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048305",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048306",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048307",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048308",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048309",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048310",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048311",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048312",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048313",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048314",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048315",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048316",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048317",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048318",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048319",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048320",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048321",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048322",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048323",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048324",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048325",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048326",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048327",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048328",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048329",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048330",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048331",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048332",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048333",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048334",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048335",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048336",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048337",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048338",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048339",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048340",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048341",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048342",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048343",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048344",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048345",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048346",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048347",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048348",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048349",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048350",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048351",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048352",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048353",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048354",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048355",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048356",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048357",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048358",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048359",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048360",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048361",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048362",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048363",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048364",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048365",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048366",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048367",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048368",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048369",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048370",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048371",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048372",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048373",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048374",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048375",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048376",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048377",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048378",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048379",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048380",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048381",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048382",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048383",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048384",
        "Length": 263
    },
    {
        "Name": "ctgAPLB01048385",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048386",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048387",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048388",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048389",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048390",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048391",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048392",
        "Length": 278
    },
    {
        "Name": "ctgAPLB01048393",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048394",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048395",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048396",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048397",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048398",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048399",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048400",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048401",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048402",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048403",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048404",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048405",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048407",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048408",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048409",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048410",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048411",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048412",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048413",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048414",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048415",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048416",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048417",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048418",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048419",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048420",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048421",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048422",
        "Length": 252
    },
    {
        "Name": "ctgAPLB01048423",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048424",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048425",
        "Length": 280
    },
    {
        "Name": "ctgAPLB01048426",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048427",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048428",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048429",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048430",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048431",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048432",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048433",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048434",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048435",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048436",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048437",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048438",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048439",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048440",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048441",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048442",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048443",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048444",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048445",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048446",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048447",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048448",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048449",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048450",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048451",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048452",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048453",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048454",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048455",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048456",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048457",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048458",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048459",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048460",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048461",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048462",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048463",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048464",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048465",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048466",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048467",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01048468",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048469",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048470",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048471",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048472",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048473",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048474",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048475",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048476",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048477",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048478",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048479",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048480",
        "Length": 266
    },
    {
        "Name": "ctgAPLB01048481",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048482",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048483",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048484",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048485",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048486",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048487",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048488",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048489",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048490",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048491",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048492",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048493",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048494",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048495",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048496",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048497",
        "Length": 284
    },
    {
        "Name": "ctgAPLB01048498",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048499",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048500",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048501",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048502",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048503",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048504",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048505",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048506",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048507",
        "Length": 270
    },
    {
        "Name": "ctgAPLB01048508",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048509",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048510",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048511",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048512",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048513",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048514",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048515",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048516",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048517",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048518",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048519",
        "Length": 255
    },
    {
        "Name": "ctgAPLB01048520",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048521",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048522",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048523",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048524",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048525",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048526",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048527",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048528",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048529",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048530",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048531",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048532",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048533",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048534",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048535",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048536",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048537",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048538",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048539",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048540",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048541",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048542",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048543",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048544",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048545",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048546",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048547",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048548",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048549",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048550",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048551",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048552",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048553",
        "Length": 282
    },
    {
        "Name": "ctgAPLB01048554",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048555",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048556",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048557",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048558",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048559",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048560",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048561",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048562",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048563",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048564",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048565",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048566",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048567",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048568",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048569",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048570",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048571",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048572",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048573",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048574",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048575",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048576",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048577",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048578",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048579",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048580",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048581",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048582",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048583",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048584",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048585",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048586",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048587",
        "Length": 288
    },
    {
        "Name": "ctgAPLB01048588",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048589",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048590",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048591",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048592",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048593",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048594",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048595",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048596",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048597",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048598",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048599",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048600",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048601",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048602",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048603",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048604",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048605",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048606",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048607",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048608",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048609",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048610",
        "Length": 289
    },
    {
        "Name": "ctgAPLB01048611",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048612",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048613",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048614",
        "Length": 287
    },
    {
        "Name": "ctgAPLB01048615",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048616",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048617",
        "Length": 276
    },
    {
        "Name": "ctgAPLB01048618",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048619",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048620",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048621",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048623",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048624",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048625",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048626",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048627",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048628",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048629",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048630",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048631",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048632",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048633",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048634",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048635",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048636",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048637",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048638",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048639",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048640",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048641",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048642",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048643",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048644",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048645",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048646",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048647",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048648",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048650",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048651",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048652",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048653",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048654",
        "Length": 271
    },
    {
        "Name": "ctgAPLB01048655",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048656",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048657",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048658",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048659",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048661",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048662",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048663",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048664",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048665",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048666",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048667",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048668",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048669",
        "Length": 243
    },
    {
        "Name": "ctgAPLB01048670",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048671",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048672",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048673",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048674",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048675",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048676",
        "Length": 277
    },
    {
        "Name": "ctgAPLB01048677",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048678",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048679",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048680",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048681",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048682",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048683",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048684",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048685",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048686",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048687",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048688",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048689",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048690",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048691",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01048692",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048693",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048694",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048695",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048696",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048697",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048698",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048699",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048700",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048701",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048702",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048703",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048704",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048705",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048706",
        "Length": 294
    },
    {
        "Name": "ctgAPLB01048707",
        "Length": 274
    },
    {
        "Name": "ctgAPLB01048708",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048709",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048710",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048711",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048712",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048713",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048714",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048715",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048716",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048717",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048718",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048719",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048720",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048721",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048722",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048723",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048724",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048725",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048726",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048727",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048728",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048729",
        "Length": 279
    },
    {
        "Name": "ctgAPLB01048730",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048731",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048732",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048733",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048734",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048735",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048736",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048737",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048738",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048739",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048740",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048741",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048742",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048743",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048744",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048745",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048746",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048747",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048748",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048749",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048750",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048751",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048752",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048753",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048754",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048755",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048756",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048757",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048758",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048759",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048760",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048761",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048762",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048763",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048764",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048765",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048766",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048767",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048768",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048769",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048770",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048771",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048772",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048773",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048774",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048775",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048776",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048777",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048778",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048779",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048780",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048781",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048782",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048783",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048784",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048785",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048786",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048787",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048788",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048789",
        "Length": 297
    },
    {
        "Name": "ctgAPLB01048790",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048791",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048792",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048793",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048794",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048795",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048796",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048797",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048798",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048799",
        "Length": 286
    },
    {
        "Name": "ctgAPLB01048800",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048801",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048802",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048803",
        "Length": 293
    },
    {
        "Name": "ctgAPLB01048804",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048805",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048806",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048807",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048808",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048809",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048810",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048811",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048812",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048813",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01048814",
        "Length": 299
    },
    {
        "Name": "ctgAPLB01048815",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048816",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048817",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048818",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048819",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048820",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048821",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048822",
        "Length": 295
    },
    {
        "Name": "ctgAPLB01048823",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048824",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048825",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048826",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048827",
        "Length": 285
    },
    {
        "Name": "ctgAPLB01048828",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048829",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048830",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048831",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048832",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048833",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048834",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048835",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048836",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048837",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048838",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048839",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048840",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048841",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048842",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048843",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048844",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048845",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048846",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048847",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048848",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048850",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048851",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048852",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048853",
        "Length": 283
    },
    {
        "Name": "ctgAPLB01048854",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048855",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048856",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048857",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048858",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048859",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048860",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048861",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048862",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048863",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048864",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048865",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048866",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048867",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048868",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048869",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048870",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048871",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048872",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048873",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048874",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048875",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048876",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048877",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048878",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048879",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048880",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048881",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048882",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048883",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048884",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048885",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048886",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048887",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048888",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048889",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048890",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048891",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048892",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048893",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048894",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048895",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048896",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048897",
        "Length": 301
    },
    {
        "Name": "ctgAPLB01048898",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048899",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048900",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048901",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048902",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048903",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048904",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048905",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048906",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048907",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048908",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048909",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048910",
        "Length": 302
    },
    {
        "Name": "ctgAPLB01048911",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048912",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048913",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048914",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048915",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048916",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048917",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048918",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048919",
        "Length": 303
    },
    {
        "Name": "ctgAPLB01048920",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048921",
        "Length": 300
    },
    {
        "Name": "ctgAPLB01048922",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048923",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048924",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048925",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048926",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048927",
        "Length": 290
    },
    {
        "Name": "ctgAPLB01048928",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048929",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048930",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048931",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048932",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048934",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048935",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048936",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048937",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048938",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048939",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048940",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048941",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048942",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048943",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048944",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048945",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048946",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048947",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048948",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048949",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048950",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048951",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048952",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048953",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048954",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048955",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048956",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048957",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048958",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048959",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01048960",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048961",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048962",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01048963",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048964",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048965",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048966",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048967",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048968",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048969",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01048970",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048971",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048972",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048973",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048974",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048975",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048976",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048977",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048978",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048979",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048980",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048981",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048982",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048983",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01048984",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048985",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048986",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048987",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01048988",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048989",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048990",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048991",
        "Length": 307
    },
    {
        "Name": "ctgAPLB01048992",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048993",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01048994",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048995",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048996",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048997",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048998",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01048999",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049000",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049001",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049002",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049003",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049004",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049005",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049006",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049007",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049008",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049009",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049010",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049011",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049012",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049013",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049014",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049015",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049016",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049017",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049018",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049019",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049020",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049021",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049022",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049023",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049024",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01049025",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049026",
        "Length": 306
    },
    {
        "Name": "ctgAPLB01049027",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049028",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049029",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049030",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049031",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049032",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049033",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049034",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049035",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049036",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049037",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049038",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049039",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049040",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049041",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049042",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049043",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049044",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049045",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049046",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049047",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049048",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049049",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049050",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049051",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049052",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049053",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049054",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049055",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049056",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049057",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049058",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049059",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049060",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049061",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049062",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049063",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049064",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049065",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049066",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049067",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049068",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049069",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049070",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049071",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049072",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049073",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049074",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049075",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049076",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049077",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049078",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049079",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049080",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049081",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049082",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049083",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049084",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049085",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049086",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049087",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049088",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049089",
        "Length": 296
    },
    {
        "Name": "ctgAPLB01049090",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049091",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049092",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049093",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049094",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049095",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049096",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049097",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049098",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049099",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049100",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049101",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049102",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049103",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049104",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049105",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049106",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049107",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049108",
        "Length": 311
    },
    {
        "Name": "ctgAPLB01049109",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049110",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049111",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049112",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049113",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049114",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049115",
        "Length": 313
    },
    {
        "Name": "ctgAPLB01049116",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049117",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049118",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049119",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049120",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049121",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049122",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049123",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049124",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049125",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049126",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049127",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049128",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049129",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049130",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049131",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049132",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049133",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049134",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049135",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049136",
        "Length": 317
    },
    {
        "Name": "ctgAPLB01049137",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049138",
        "Length": 291
    },
    {
        "Name": "ctgAPLB01049139",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049140",
        "Length": 315
    },
    {
        "Name": "ctgAPLB01049141",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049142",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049143",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049144",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049145",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049146",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049147",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049148",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049149",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049150",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049151",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049152",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049153",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049154",
        "Length": 310
    },
    {
        "Name": "ctgAPLB01049155",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049156",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049157",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049158",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049159",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049160",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049161",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049162",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049163",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049164",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049165",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049166",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049167",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049168",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049169",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049170",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049171",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049172",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049173",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049174",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049175",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049176",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049177",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049178",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049179",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049180",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049181",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049182",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049183",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049184",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049185",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049186",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049187",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049188",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049189",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049190",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049191",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049192",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049193",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049194",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049195",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049196",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049197",
        "Length": 320
    },
    {
        "Name": "ctgAPLB01049198",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049199",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049200",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049201",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049202",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049203",
        "Length": 321
    },
    {
        "Name": "ctgAPLB01049204",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049205",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049206",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049207",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049208",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049209",
        "Length": 316
    },
    {
        "Name": "ctgAPLB01049210",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049211",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049212",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049213",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049214",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049215",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049216",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049217",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049218",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049220",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049221",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049222",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049223",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049224",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049225",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049226",
        "Length": 318
    },
    {
        "Name": "ctgAPLB01049227",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049228",
        "Length": 322
    },
    {
        "Name": "ctgAPLB01049229",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049230",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049231",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049232",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049233",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049234",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049235",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049236",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049237",
        "Length": 323
    },
    {
        "Name": "ctgAPLB01049238",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049239",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049240",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049241",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049242",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049243",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049244",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049245",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049246",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049247",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049248",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049249",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049250",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049251",
        "Length": 319
    },
    {
        "Name": "ctgAPLB01049252",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049253",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049254",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049255",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049256",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049257",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049258",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049259",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049260",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049261",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049262",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049263",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049264",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049265",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049266",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049267",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049268",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049269",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049270",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049271",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049272",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049273",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049274",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049275",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049276",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049277",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049278",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049279",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049280",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049281",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049282",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049283",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049284",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049285",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049286",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049287",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049288",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049289",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049290",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049291",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049292",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049293",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049294",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049295",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049296",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049297",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049298",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049299",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049300",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049301",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049302",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049303",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049304",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049305",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049307",
        "Length": 314
    },
    {
        "Name": "ctgAPLB01049308",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049309",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049310",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049311",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049312",
        "Length": 328
    },
    {
        "Name": "ctgAPLB01049313",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049314",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049315",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049316",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049317",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049318",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049319",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049320",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049321",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049322",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049323",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049324",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049325",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049326",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049327",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049328",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049329",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049330",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049331",
        "Length": 330
    },
    {
        "Name": "ctgAPLB01049333",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049334",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049335",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049336",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01049337",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049338",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049339",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049340",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049341",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049342",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049343",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049344",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049345",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049346",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049347",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049348",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049349",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049350",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049351",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049352",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049353",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049354",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049355",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049356",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049357",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049358",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049359",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049360",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049361",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049362",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049363",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049364",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049365",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049366",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049367",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049368",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049369",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049370",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049371",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049372",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049373",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049374",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049375",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049376",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049377",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049378",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049379",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049380",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049381",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049382",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049383",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049384",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049385",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049386",
        "Length": 334
    },
    {
        "Name": "ctgAPLB01049387",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049388",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049389",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049391",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049392",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049393",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049394",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049395",
        "Length": 267
    },
    {
        "Name": "ctgAPLB01049396",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049397",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049398",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049399",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049400",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049401",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049402",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049403",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049404",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049405",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049406",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049407",
        "Length": 309
    },
    {
        "Name": "ctgAPLB01049408",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049409",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049410",
        "Length": 312
    },
    {
        "Name": "ctgAPLB01049411",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049412",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049413",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049414",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049415",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049416",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049417",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049418",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049419",
        "Length": 337
    },
    {
        "Name": "ctgAPLB01049420",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049421",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049422",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049423",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049424",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049425",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049426",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049427",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049428",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049429",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049430",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049431",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049432",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049433",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049434",
        "Length": 338
    },
    {
        "Name": "ctgAPLB01049435",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049436",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049437",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049438",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049439",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049440",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049441",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049442",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049443",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049444",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049445",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049446",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049447",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049448",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049449",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049450",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049451",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049452",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049453",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049454",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049455",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049456",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049457",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049458",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049459",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049460",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049461",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049462",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049463",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049464",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049465",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049466",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049467",
        "Length": 341
    },
    {
        "Name": "ctgAPLB01049468",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049469",
        "Length": 340
    },
    {
        "Name": "ctgAPLB01049470",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049471",
        "Length": 339
    },
    {
        "Name": "ctgAPLB01049472",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049473",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049474",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049475",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049476",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049477",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049478",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049479",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049480",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049481",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049482",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049483",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049484",
        "Length": 281
    },
    {
        "Name": "ctgAPLB01049485",
        "Length": 342
    },
    {
        "Name": "ctgAPLB01049486",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049487",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049488",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049489",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049490",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049491",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049492",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049493",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049494",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049495",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049496",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049497",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049498",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049499",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049500",
        "Length": 292
    },
    {
        "Name": "ctgAPLB01049501",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049502",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049503",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049504",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049505",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049506",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049507",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049508",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049509",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049510",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049511",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049512",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049513",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01049514",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049515",
        "Length": 324
    },
    {
        "Name": "ctgAPLB01049516",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049517",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049518",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049519",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049520",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049521",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049522",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049523",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049524",
        "Length": 346
    },
    {
        "Name": "ctgAPLB01049525",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049526",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049527",
        "Length": 325
    },
    {
        "Name": "ctgAPLB01049528",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049529",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049530",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049531",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049532",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049533",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049534",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049535",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049536",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049537",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049538",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049539",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049540",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049541",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049542",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049543",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049544",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049545",
        "Length": 326
    },
    {
        "Name": "ctgAPLB01049546",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049547",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049548",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049549",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049550",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049551",
        "Length": 349
    },
    {
        "Name": "ctgAPLB01049552",
        "Length": 327
    },
    {
        "Name": "ctgAPLB01049553",
        "Length": 347
    },
    {
        "Name": "ctgAPLB01049554",
        "Length": 308
    },
    {
        "Name": "ctgAPLB01049555",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049556",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049557",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049558",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049559",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049560",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049561",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049562",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049563",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049564",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049565",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049566",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049567",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049568",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049569",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049570",
        "Length": 351
    },
    {
        "Name": "ctgAPLB01049571",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049572",
        "Length": 329
    },
    {
        "Name": "ctgAPLB01049573",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049574",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049575",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049576",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049577",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049578",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049579",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049580",
        "Length": 352
    },
    {
        "Name": "ctgAPLB01049582",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049583",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049584",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049585",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049586",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049587",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049588",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049589",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049590",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049591",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049592",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049593",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049594",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049595",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049596",
        "Length": 353
    },
    {
        "Name": "ctgAPLB01049597",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049598",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049599",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049600",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049601",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049602",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049603",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049604",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049605",
        "Length": 348
    },
    {
        "Name": "ctgAPLB01049606",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049607",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049608",
        "Length": 345
    },
    {
        "Name": "ctgAPLB01049609",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049610",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049611",
        "Length": 333
    },
    {
        "Name": "ctgAPLB01049612",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049613",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01049614",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049615",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049616",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049617",
        "Length": 355
    },
    {
        "Name": "ctgAPLB01049618",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049619",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049620",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049621",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049622",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049623",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049624",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049625",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049626",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049627",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049628",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049629",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049630",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049631",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049632",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049633",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049634",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049635",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049636",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049637",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049638",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049639",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049640",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049641",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049642",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049643",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049644",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049645",
        "Length": 358
    },
    {
        "Name": "ctgAPLB01049646",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049647",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049648",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049649",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049650",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049651",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049652",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049653",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049654",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01049655",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049656",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049657",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049658",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049659",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049660",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049661",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049662",
        "Length": 350
    },
    {
        "Name": "ctgAPLB01049663",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049664",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049665",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049666",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049667",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049668",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049669",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049670",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049671",
        "Length": 359
    },
    {
        "Name": "ctgAPLB01049672",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049673",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01049674",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049675",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049676",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049677",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049678",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049679",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049680",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049681",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049682",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049683",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049684",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049685",
        "Length": 362
    },
    {
        "Name": "ctgAPLB01049686",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049687",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049688",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049689",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049690",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049691",
        "Length": 357
    },
    {
        "Name": "ctgAPLB01049692",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049693",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049694",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049695",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049696",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049697",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049698",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049699",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049700",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049701",
        "Length": 364
    },
    {
        "Name": "ctgAPLB01049702",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049703",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049704",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049705",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049706",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049707",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049708",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049709",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049710",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049711",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049712",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049713",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049714",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049715",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049716",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049717",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049718",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049719",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049720",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049721",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049722",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01049723",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049724",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049725",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049726",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049727",
        "Length": 365
    },
    {
        "Name": "ctgAPLB01049728",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049729",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049730",
        "Length": 366
    },
    {
        "Name": "ctgAPLB01049731",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049732",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049733",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049734",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049735",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049736",
        "Length": 343
    },
    {
        "Name": "ctgAPLB01049737",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049738",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049739",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049740",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049741",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049742",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049743",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049744",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049745",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049746",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049747",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01049748",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01049749",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049750",
        "Length": 367
    },
    {
        "Name": "ctgAPLB01049751",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049752",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049753",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049754",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01049755",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049756",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049757",
        "Length": 332
    },
    {
        "Name": "ctgAPLB01049758",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01049759",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049760",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049761",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01049762",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049763",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049764",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049765",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049766",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049767",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049768",
        "Length": 368
    },
    {
        "Name": "ctgAPLB01049769",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049770",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049771",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049772",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049773",
        "Length": 356
    },
    {
        "Name": "ctgAPLB01049774",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049775",
        "Length": 370
    },
    {
        "Name": "ctgAPLB01049776",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049777",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049778",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049779",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049780",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049781",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049782",
        "Length": 369
    },
    {
        "Name": "ctgAPLB01049783",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049784",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049785",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049786",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049787",
        "Length": 373
    },
    {
        "Name": "ctgAPLB01049788",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049789",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049790",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049791",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049792",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049793",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049794",
        "Length": 372
    },
    {
        "Name": "ctgAPLB01049795",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049796",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049797",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049798",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049799",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01049800",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049801",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049802",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049803",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049804",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049805",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049806",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049807",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049808",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049809",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049810",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049811",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049812",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049813",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049814",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049815",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049816",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049817",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049818",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049819",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049820",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049821",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01049822",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049823",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049824",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049825",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01049826",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049827",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049828",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049829",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049830",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049831",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049832",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049833",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049834",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049835",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01049836",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049837",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049838",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049839",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049840",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049841",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049842",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049843",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049844",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049845",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049846",
        "Length": 380
    },
    {
        "Name": "ctgAPLB01049847",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049848",
        "Length": 379
    },
    {
        "Name": "ctgAPLB01049849",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01049850",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049851",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049852",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049853",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049854",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049855",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049856",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049857",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049858",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049859",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049860",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049861",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049862",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049863",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049864",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049865",
        "Length": 386
    },
    {
        "Name": "ctgAPLB01049866",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049867",
        "Length": 386
    },
    {
        "Name": "ctgAPLB01049868",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049869",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049870",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049871",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049872",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049873",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049874",
        "Length": 385
    },
    {
        "Name": "ctgAPLB01049875",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049876",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049877",
        "Length": 386
    },
    {
        "Name": "ctgAPLB01049878",
        "Length": 384
    },
    {
        "Name": "ctgAPLB01049879",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049880",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049881",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049882",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049883",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049884",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049885",
        "Length": 383
    },
    {
        "Name": "ctgAPLB01049886",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049887",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049888",
        "Length": 298
    },
    {
        "Name": "ctgAPLB01049889",
        "Length": 374
    },
    {
        "Name": "ctgAPLB01049890",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049891",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049892",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049893",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049894",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049895",
        "Length": 386
    },
    {
        "Name": "ctgAPLB01049896",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049897",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049898",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049899",
        "Length": 390
    },
    {
        "Name": "ctgAPLB01049900",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01049901",
        "Length": 387
    },
    {
        "Name": "ctgAPLB01049902",
        "Length": 390
    },
    {
        "Name": "ctgAPLB01049903",
        "Length": 390
    },
    {
        "Name": "ctgAPLB01049904",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049905",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01049906",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01049907",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049908",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049909",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049910",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01049911",
        "Length": 389
    },
    {
        "Name": "ctgAPLB01049912",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049913",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049914",
        "Length": 391
    },
    {
        "Name": "ctgAPLB01049915",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049916",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049917",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049918",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049919",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049920",
        "Length": 392
    },
    {
        "Name": "ctgAPLB01049921",
        "Length": 390
    },
    {
        "Name": "ctgAPLB01049922",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049923",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049925",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049926",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049927",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049928",
        "Length": 396
    },
    {
        "Name": "ctgAPLB01049929",
        "Length": 395
    },
    {
        "Name": "ctgAPLB01049930",
        "Length": 363
    },
    {
        "Name": "ctgAPLB01049931",
        "Length": 395
    },
    {
        "Name": "ctgAPLB01049932",
        "Length": 395
    },
    {
        "Name": "ctgAPLB01049933",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01049934",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049935",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049936",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049937",
        "Length": 396
    },
    {
        "Name": "ctgAPLB01049938",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01049939",
        "Length": 394
    },
    {
        "Name": "ctgAPLB01049940",
        "Length": 395
    },
    {
        "Name": "ctgAPLB01049941",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049942",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049943",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049944",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049945",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01049946",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049947",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01049948",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01049949",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049950",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049951",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049952",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049953",
        "Length": 395
    },
    {
        "Name": "ctgAPLB01049954",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049955",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049956",
        "Length": 401
    },
    {
        "Name": "ctgAPLB01049957",
        "Length": 397
    },
    {
        "Name": "ctgAPLB01049958",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049959",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049960",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049961",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049962",
        "Length": 402
    },
    {
        "Name": "ctgAPLB01049963",
        "Length": 396
    },
    {
        "Name": "ctgAPLB01049964",
        "Length": 396
    },
    {
        "Name": "ctgAPLB01049965",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049966",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049967",
        "Length": 399
    },
    {
        "Name": "ctgAPLB01049968",
        "Length": 393
    },
    {
        "Name": "ctgAPLB01049969",
        "Length": 402
    },
    {
        "Name": "ctgAPLB01049970",
        "Length": 401
    },
    {
        "Name": "ctgAPLB01049971",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01049972",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01049973",
        "Length": 401
    },
    {
        "Name": "ctgAPLB01049974",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049975",
        "Length": 402
    },
    {
        "Name": "ctgAPLB01049976",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049977",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01049978",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01049979",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049980",
        "Length": 400
    },
    {
        "Name": "ctgAPLB01049981",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049982",
        "Length": 382
    },
    {
        "Name": "ctgAPLB01049983",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01049984",
        "Length": 336
    },
    {
        "Name": "ctgAPLB01049985",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049987",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01049988",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049989",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049990",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049991",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01049992",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049993",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049994",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01049995",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01049996",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01049997",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01049998",
        "Length": 406
    },
    {
        "Name": "ctgAPLB01049999",
        "Length": 305
    },
    {
        "Name": "ctgAPLB01050000",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050001",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050002",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050003",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050004",
        "Length": 335
    },
    {
        "Name": "ctgAPLB01050005",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050006",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050007",
        "Length": 406
    },
    {
        "Name": "ctgAPLB01050008",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01050009",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050010",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050011",
        "Length": 405
    },
    {
        "Name": "ctgAPLB01050012",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050013",
        "Length": 375
    },
    {
        "Name": "ctgAPLB01050014",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050015",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050016",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050017",
        "Length": 304
    },
    {
        "Name": "ctgAPLB01050018",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050019",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01050020",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050021",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050022",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050023",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050024",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050025",
        "Length": 409
    },
    {
        "Name": "ctgAPLB01050026",
        "Length": 406
    },
    {
        "Name": "ctgAPLB01050027",
        "Length": 376
    },
    {
        "Name": "ctgAPLB01050028",
        "Length": 409
    },
    {
        "Name": "ctgAPLB01050029",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050030",
        "Length": 407
    },
    {
        "Name": "ctgAPLB01050031",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050032",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01050033",
        "Length": 409
    },
    {
        "Name": "ctgAPLB01050034",
        "Length": 408
    },
    {
        "Name": "ctgAPLB01050035",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050036",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050037",
        "Length": 406
    },
    {
        "Name": "ctgAPLB01050038",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01050039",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050040",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01050041",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050042",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01050043",
        "Length": 378
    },
    {
        "Name": "ctgAPLB01050044",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050045",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050046",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050047",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050048",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050049",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050050",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01050051",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050052",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050053",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01050054",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01050055",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050056",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01050057",
        "Length": 403
    },
    {
        "Name": "ctgAPLB01050058",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050059",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050060",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01050061",
        "Length": 412
    },
    {
        "Name": "ctgAPLB01050062",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050063",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050064",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050065",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050066",
        "Length": 414
    },
    {
        "Name": "ctgAPLB01050067",
        "Length": 416
    },
    {
        "Name": "ctgAPLB01050068",
        "Length": 418
    },
    {
        "Name": "ctgAPLB01050069",
        "Length": 417
    },
    {
        "Name": "ctgAPLB01050070",
        "Length": 381
    },
    {
        "Name": "ctgAPLB01050071",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050072",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050073",
        "Length": 417
    },
    {
        "Name": "ctgAPLB01050074",
        "Length": 417
    },
    {
        "Name": "ctgAPLB01050075",
        "Length": 416
    },
    {
        "Name": "ctgAPLB01050076",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050077",
        "Length": 416
    },
    {
        "Name": "ctgAPLB01050078",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050080",
        "Length": 416
    },
    {
        "Name": "ctgAPLB01050081",
        "Length": 418
    },
    {
        "Name": "ctgAPLB01050082",
        "Length": 411
    },
    {
        "Name": "ctgAPLB01050083",
        "Length": 420
    },
    {
        "Name": "ctgAPLB01050084",
        "Length": 331
    },
    {
        "Name": "ctgAPLB01050085",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050086",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01050087",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01050088",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050089",
        "Length": 421
    },
    {
        "Name": "ctgAPLB01050090",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050091",
        "Length": 423
    },
    {
        "Name": "ctgAPLB01050092",
        "Length": 418
    },
    {
        "Name": "ctgAPLB01050093",
        "Length": 422
    },
    {
        "Name": "ctgAPLB01050094",
        "Length": 422
    },
    {
        "Name": "ctgAPLB01050095",
        "Length": 423
    },
    {
        "Name": "ctgAPLB01050096",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01050097",
        "Length": 422
    },
    {
        "Name": "ctgAPLB01050098",
        "Length": 425
    },
    {
        "Name": "ctgAPLB01050099",
        "Length": 422
    },
    {
        "Name": "ctgAPLB01050100",
        "Length": 377
    },
    {
        "Name": "ctgAPLB01050101",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050102",
        "Length": 423
    },
    {
        "Name": "ctgAPLB01050103",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01050104",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050105",
        "Length": 420
    },
    {
        "Name": "ctgAPLB01050106",
        "Length": 420
    },
    {
        "Name": "ctgAPLB01050107",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050108",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050109",
        "Length": 425
    },
    {
        "Name": "ctgAPLB01050110",
        "Length": 425
    },
    {
        "Name": "ctgAPLB01050111",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050112",
        "Length": 421
    },
    {
        "Name": "ctgAPLB01050113",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01050114",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01050115",
        "Length": 427
    },
    {
        "Name": "ctgAPLB01050116",
        "Length": 425
    },
    {
        "Name": "ctgAPLB01050117",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050118",
        "Length": 427
    },
    {
        "Name": "ctgAPLB01050119",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01050120",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01050121",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050122",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050123",
        "Length": 427
    },
    {
        "Name": "ctgAPLB01050124",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01050125",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050126",
        "Length": 425
    },
    {
        "Name": "ctgAPLB01050127",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050128",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01050129",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01050130",
        "Length": 426
    },
    {
        "Name": "ctgAPLB01050131",
        "Length": 430
    },
    {
        "Name": "ctgAPLB01050132",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01050133",
        "Length": 430
    },
    {
        "Name": "ctgAPLB01050135",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01050136",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01050137",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050138",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01050139",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050140",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050141",
        "Length": 430
    },
    {
        "Name": "ctgAPLB01050142",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01050143",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050144",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050145",
        "Length": 431
    },
    {
        "Name": "ctgAPLB01050146",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050147",
        "Length": 427
    },
    {
        "Name": "ctgAPLB01050148",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050149",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050150",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050151",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050152",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050153",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050154",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050155",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01050156",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050157",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01050158",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050159",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050160",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050161",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050162",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050163",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050164",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01050165",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050166",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050167",
        "Length": 413
    },
    {
        "Name": "ctgAPLB01050168",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050169",
        "Length": 432
    },
    {
        "Name": "ctgAPLB01050170",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01050171",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01050172",
        "Length": 398
    },
    {
        "Name": "ctgAPLB01050173",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050174",
        "Length": 439
    },
    {
        "Name": "ctgAPLB01050175",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050176",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050177",
        "Length": 434
    },
    {
        "Name": "ctgAPLB01050178",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050179",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050180",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050181",
        "Length": 438
    },
    {
        "Name": "ctgAPLB01050182",
        "Length": 439
    },
    {
        "Name": "ctgAPLB01050183",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01050185",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01050186",
        "Length": 437
    },
    {
        "Name": "ctgAPLB01050187",
        "Length": 433
    },
    {
        "Name": "ctgAPLB01050188",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050189",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050190",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050191",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050192",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050193",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050194",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050195",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050196",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01050197",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050198",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050199",
        "Length": 371
    },
    {
        "Name": "ctgAPLB01050200",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050201",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01050202",
        "Length": 440
    },
    {
        "Name": "ctgAPLB01050203",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01050204",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050205",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01050206",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050207",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01050208",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01050209",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01050210",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01050211",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01050212",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050213",
        "Length": 443
    },
    {
        "Name": "ctgAPLB01050214",
        "Length": 435
    },
    {
        "Name": "ctgAPLB01050215",
        "Length": 404
    },
    {
        "Name": "ctgAPLB01050216",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050217",
        "Length": 436
    },
    {
        "Name": "ctgAPLB01050218",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050219",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050220",
        "Length": 442
    },
    {
        "Name": "ctgAPLB01050221",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050222",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050223",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050224",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050225",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050226",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01050227",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050228",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050229",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01050230",
        "Length": 448
    },
    {
        "Name": "ctgAPLB01050231",
        "Length": 445
    },
    {
        "Name": "ctgAPLB01050232",
        "Length": 448
    },
    {
        "Name": "ctgAPLB01050233",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01050234",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050235",
        "Length": 439
    },
    {
        "Name": "ctgAPLB01050236",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050237",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01050238",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01050239",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01050240",
        "Length": 447
    },
    {
        "Name": "ctgAPLB01050241",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01050242",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050243",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050244",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050245",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050246",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050247",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01050248",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01050249",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050250",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01050251",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01050252",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050253",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01050254",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01050255",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01050256",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050257",
        "Length": 354
    },
    {
        "Name": "ctgAPLB01050258",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050259",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050260",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01050261",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050262",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01050263",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01050264",
        "Length": 410
    },
    {
        "Name": "ctgAPLB01050265",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050266",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050267",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050268",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050269",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050270",
        "Length": 456
    },
    {
        "Name": "ctgAPLB01050271",
        "Length": 450
    },
    {
        "Name": "ctgAPLB01050272",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050273",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050275",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050276",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050277",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050278",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050279",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050280",
        "Length": 452
    },
    {
        "Name": "ctgAPLB01050281",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01050282",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050283",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050284",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01050285",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050286",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01050287",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050288",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01050289",
        "Length": 459
    },
    {
        "Name": "ctgAPLB01050290",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01050291",
        "Length": 457
    },
    {
        "Name": "ctgAPLB01050292",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050293",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050294",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01050295",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01050296",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050297",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050298",
        "Length": 461
    },
    {
        "Name": "ctgAPLB01050299",
        "Length": 461
    },
    {
        "Name": "ctgAPLB01050300",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050301",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01050302",
        "Length": 454
    },
    {
        "Name": "ctgAPLB01050303",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01050304",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01050305",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01050306",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050307",
        "Length": 464
    },
    {
        "Name": "ctgAPLB01050308",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050309",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050310",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050311",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01050312",
        "Length": 428
    },
    {
        "Name": "ctgAPLB01050313",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050314",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01050315",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050316",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050317",
        "Length": 465
    },
    {
        "Name": "ctgAPLB01050318",
        "Length": 458
    },
    {
        "Name": "ctgAPLB01050319",
        "Length": 466
    },
    {
        "Name": "ctgAPLB01050320",
        "Length": 461
    },
    {
        "Name": "ctgAPLB01050321",
        "Length": 424
    },
    {
        "Name": "ctgAPLB01050322",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01050323",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050324",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01050325",
        "Length": 463
    },
    {
        "Name": "ctgAPLB01050326",
        "Length": 466
    },
    {
        "Name": "ctgAPLB01050327",
        "Length": 429
    },
    {
        "Name": "ctgAPLB01050328",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050329",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050330",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01050331",
        "Length": 444
    },
    {
        "Name": "ctgAPLB01050332",
        "Length": 466
    },
    {
        "Name": "ctgAPLB01050333",
        "Length": 470
    },
    {
        "Name": "ctgAPLB01050334",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050335",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050336",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01050337",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050338",
        "Length": 466
    },
    {
        "Name": "ctgAPLB01050339",
        "Length": 470
    },
    {
        "Name": "ctgAPLB01050341",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01050342",
        "Length": 344
    },
    {
        "Name": "ctgAPLB01050343",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01050344",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01050345",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01050346",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01050347",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01050348",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01050349",
        "Length": 467
    },
    {
        "Name": "ctgAPLB01050350",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01050351",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01050352",
        "Length": 473
    },
    {
        "Name": "ctgAPLB01050353",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01050354",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01050355",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050356",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01050357",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01050358",
        "Length": 472
    },
    {
        "Name": "ctgAPLB01050360",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050361",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050362",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01050363",
        "Length": 474
    },
    {
        "Name": "ctgAPLB01050364",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050365",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050366",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01050367",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01050368",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01050369",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01050370",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050371",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050372",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050373",
        "Length": 475
    },
    {
        "Name": "ctgAPLB01050374",
        "Length": 476
    },
    {
        "Name": "ctgAPLB01050375",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050376",
        "Length": 477
    },
    {
        "Name": "ctgAPLB01050377",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050378",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01050379",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050380",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01050381",
        "Length": 469
    },
    {
        "Name": "ctgAPLB01050382",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050383",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01050384",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050385",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01050386",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050387",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01050388",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050389",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01050390",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050391",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01050392",
        "Length": 471
    },
    {
        "Name": "ctgAPLB01050393",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050394",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050395",
        "Length": 481
    },
    {
        "Name": "ctgAPLB01050396",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050397",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050398",
        "Length": 446
    },
    {
        "Name": "ctgAPLB01050399",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01050400",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01050401",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01050402",
        "Length": 448
    },
    {
        "Name": "ctgAPLB01050403",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01050404",
        "Length": 479
    },
    {
        "Name": "ctgAPLB01050405",
        "Length": 483
    },
    {
        "Name": "ctgAPLB01050406",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01050407",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01050408",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01050409",
        "Length": 487
    },
    {
        "Name": "ctgAPLB01050410",
        "Length": 484
    },
    {
        "Name": "ctgAPLB01050411",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01050412",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01050413",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01050414",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01050415",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01050416",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01050417",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01050418",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01050419",
        "Length": 485
    },
    {
        "Name": "ctgAPLB01050420",
        "Length": 488
    },
    {
        "Name": "ctgAPLB01050421",
        "Length": 449
    },
    {
        "Name": "ctgAPLB01050422",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01050423",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01050424",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01050425",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01050426",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01050427",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01050428",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01050429",
        "Length": 491
    },
    {
        "Name": "ctgAPLB01050430",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01050431",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01050432",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01050433",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01050434",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01050435",
        "Length": 453
    },
    {
        "Name": "ctgAPLB01050436",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01050437",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01050438",
        "Length": 490
    },
    {
        "Name": "ctgAPLB01050439",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01050440",
        "Length": 489
    },
    {
        "Name": "ctgAPLB01050441",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01050442",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01050443",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050444",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01050445",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050446",
        "Length": 492
    },
    {
        "Name": "ctgAPLB01050447",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050448",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01050449",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050450",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01050451",
        "Length": 494
    },
    {
        "Name": "ctgAPLB01050452",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01050453",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01050454",
        "Length": 496
    },
    {
        "Name": "ctgAPLB01050455",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050456",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050457",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01050458",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050459",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01050460",
        "Length": 462
    },
    {
        "Name": "ctgAPLB01050461",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050462",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050463",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01050464",
        "Length": 499
    },
    {
        "Name": "ctgAPLB01050465",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050466",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01050467",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01050468",
        "Length": 497
    },
    {
        "Name": "ctgAPLB01050469",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050470",
        "Length": 419
    },
    {
        "Name": "ctgAPLB01050471",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050472",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050473",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050474",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050475",
        "Length": 498
    },
    {
        "Name": "ctgAPLB01050476",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050477",
        "Length": 501
    },
    {
        "Name": "ctgAPLB01050478",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01050479",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050480",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050481",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01050482",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050483",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01050484",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01050485",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01050486",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050487",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050488",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050489",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050490",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050491",
        "Length": 502
    },
    {
        "Name": "ctgAPLB01050492",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01050493",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050494",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01050495",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050496",
        "Length": 420
    },
    {
        "Name": "ctgAPLB01050497",
        "Length": 500
    },
    {
        "Name": "ctgAPLB01050498",
        "Length": 415
    },
    {
        "Name": "ctgAPLB01050499",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01050500",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01050501",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01050502",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01050503",
        "Length": 503
    },
    {
        "Name": "ctgAPLB01050504",
        "Length": 421
    },
    {
        "Name": "ctgAPLB01050505",
        "Length": 460
    },
    {
        "Name": "ctgAPLB01050506",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050507",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01050508",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01050509",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01050510",
        "Length": 420
    },
    {
        "Name": "ctgAPLB01050511",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01050512",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01050513",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01050514",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01050516",
        "Length": 510
    },
    {
        "Name": "ctgAPLB01050517",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01050518",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01050519",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01050520",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01050521",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01050522",
        "Length": 514
    },
    {
        "Name": "ctgAPLB01050523",
        "Length": 511
    },
    {
        "Name": "ctgAPLB01050524",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01050525",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01050526",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01050527",
        "Length": 478
    },
    {
        "Name": "ctgAPLB01050528",
        "Length": 493
    },
    {
        "Name": "ctgAPLB01050529",
        "Length": 506
    },
    {
        "Name": "ctgAPLB01050530",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01050531",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01050532",
        "Length": 512
    },
    {
        "Name": "ctgAPLB01050533",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01050534",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01050535",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01050536",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01050537",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01050538",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01050539",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01050540",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01050541",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01050542",
        "Length": 495
    },
    {
        "Name": "ctgAPLB01050543",
        "Length": 516
    },
    {
        "Name": "ctgAPLB01050544",
        "Length": 520
    },
    {
        "Name": "ctgAPLB01050545",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01050546",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01050547",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01050548",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01050549",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01050550",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01050551",
        "Length": 468
    },
    {
        "Name": "ctgAPLB01050552",
        "Length": 515
    },
    {
        "Name": "ctgAPLB01050553",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01050554",
        "Length": 518
    },
    {
        "Name": "ctgAPLB01050555",
        "Length": 519
    },
    {
        "Name": "ctgAPLB01050556",
        "Length": 513
    },
    {
        "Name": "ctgAPLB01050557",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01050558",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01050559",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01050560",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01050561",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01050562",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01050563",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050564",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01050565",
        "Length": 525
    },
    {
        "Name": "ctgAPLB01050566",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01050567",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01050568",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01050569",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01050570",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01050571",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01050572",
        "Length": 528
    },
    {
        "Name": "ctgAPLB01050573",
        "Length": 504
    },
    {
        "Name": "ctgAPLB01050574",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01050575",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01050576",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050577",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01050578",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01050579",
        "Length": 527
    },
    {
        "Name": "ctgAPLB01050580",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01050581",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01050582",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01050583",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01050584",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01050585",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01050586",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01050587",
        "Length": 524
    },
    {
        "Name": "ctgAPLB01050588",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01050589",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01050590",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01050591",
        "Length": 531
    },
    {
        "Name": "ctgAPLB01050592",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01050593",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01050594",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01050595",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01050596",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01050597",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01050598",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01050599",
        "Length": 535
    },
    {
        "Name": "ctgAPLB01050600",
        "Length": 480
    },
    {
        "Name": "ctgAPLB01050601",
        "Length": 537
    },
    {
        "Name": "ctgAPLB01050602",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01050603",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01050604",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01050605",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01050606",
        "Length": 536
    },
    {
        "Name": "ctgAPLB01050607",
        "Length": 537
    },
    {
        "Name": "ctgAPLB01050608",
        "Length": 521
    },
    {
        "Name": "ctgAPLB01050609",
        "Length": 451
    },
    {
        "Name": "ctgAPLB01050610",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01050611",
        "Length": 441
    },
    {
        "Name": "ctgAPLB01050612",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01050613",
        "Length": 534
    },
    {
        "Name": "ctgAPLB01050614",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01050615",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01050616",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01050617",
        "Length": 539
    },
    {
        "Name": "ctgAPLB01050618",
        "Length": 533
    },
    {
        "Name": "ctgAPLB01050619",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01050620",
        "Length": 537
    },
    {
        "Name": "ctgAPLB01050621",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01050622",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01050623",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01050624",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01050625",
        "Length": 544
    },
    {
        "Name": "ctgAPLB01050626",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01050627",
        "Length": 540
    },
    {
        "Name": "ctgAPLB01050628",
        "Length": 542
    },
    {
        "Name": "ctgAPLB01050629",
        "Length": 538
    },
    {
        "Name": "ctgAPLB01050630",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01050631",
        "Length": 360
    },
    {
        "Name": "ctgAPLB01050632",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01050634",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01050635",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01050636",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01050637",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01050638",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01050639",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01050640",
        "Length": 548
    },
    {
        "Name": "ctgAPLB01050641",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01050642",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01050643",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01050644",
        "Length": 523
    },
    {
        "Name": "ctgAPLB01050645",
        "Length": 550
    },
    {
        "Name": "ctgAPLB01050646",
        "Length": 547
    },
    {
        "Name": "ctgAPLB01050647",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01050648",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01050649",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01050650",
        "Length": 549
    },
    {
        "Name": "ctgAPLB01050651",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01050652",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01050653",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01050654",
        "Length": 553
    },
    {
        "Name": "ctgAPLB01050656",
        "Length": 541
    },
    {
        "Name": "ctgAPLB01050657",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01050658",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01050659",
        "Length": 556
    },
    {
        "Name": "ctgAPLB01050660",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01050661",
        "Length": 557
    },
    {
        "Name": "ctgAPLB01050662",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01050663",
        "Length": 555
    },
    {
        "Name": "ctgAPLB01050664",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01050665",
        "Length": 554
    },
    {
        "Name": "ctgAPLB01050666",
        "Length": 558
    },
    {
        "Name": "ctgAPLB01050667",
        "Length": 557
    },
    {
        "Name": "ctgAPLB01050668",
        "Length": 562
    },
    {
        "Name": "ctgAPLB01050669",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01050670",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01050671",
        "Length": 507
    },
    {
        "Name": "ctgAPLB01050672",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050673",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01050674",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01050675",
        "Length": 559
    },
    {
        "Name": "ctgAPLB01050676",
        "Length": 562
    },
    {
        "Name": "ctgAPLB01050677",
        "Length": 562
    },
    {
        "Name": "ctgAPLB01050678",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01050679",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050680",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01050681",
        "Length": 561
    },
    {
        "Name": "ctgAPLB01050682",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01050683",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01050684",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050685",
        "Length": 565
    },
    {
        "Name": "ctgAPLB01050686",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01050687",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01050688",
        "Length": 545
    },
    {
        "Name": "ctgAPLB01050689",
        "Length": 508
    },
    {
        "Name": "ctgAPLB01050690",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050691",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050692",
        "Length": 562
    },
    {
        "Name": "ctgAPLB01050693",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050694",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01050695",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01050696",
        "Length": 564
    },
    {
        "Name": "ctgAPLB01050697",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050698",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050699",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01050700",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01050701",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050702",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01050703",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01050704",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01050705",
        "Length": 570
    },
    {
        "Name": "ctgAPLB01050706",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050707",
        "Length": 455
    },
    {
        "Name": "ctgAPLB01050708",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050709",
        "Length": 566
    },
    {
        "Name": "ctgAPLB01050710",
        "Length": 568
    },
    {
        "Name": "ctgAPLB01050711",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01050712",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01050713",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01050714",
        "Length": 572
    },
    {
        "Name": "ctgAPLB01050715",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01050716",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01050717",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01050718",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01050719",
        "Length": 571
    },
    {
        "Name": "ctgAPLB01050720",
        "Length": 569
    },
    {
        "Name": "ctgAPLB01050721",
        "Length": 576
    },
    {
        "Name": "ctgAPLB01050722",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01050723",
        "Length": 578
    },
    {
        "Name": "ctgAPLB01050724",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01050725",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01050726",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01050727",
        "Length": 546
    },
    {
        "Name": "ctgAPLB01050728",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01050729",
        "Length": 576
    },
    {
        "Name": "ctgAPLB01050730",
        "Length": 529
    },
    {
        "Name": "ctgAPLB01050731",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01050732",
        "Length": 575
    },
    {
        "Name": "ctgAPLB01050733",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01050734",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01050735",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01050736",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01050737",
        "Length": 583
    },
    {
        "Name": "ctgAPLB01050738",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01050739",
        "Length": 517
    },
    {
        "Name": "ctgAPLB01050740",
        "Length": 530
    },
    {
        "Name": "ctgAPLB01050741",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01050742",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01050743",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050744",
        "Length": 581
    },
    {
        "Name": "ctgAPLB01050745",
        "Length": 577
    },
    {
        "Name": "ctgAPLB01050746",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01050747",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050748",
        "Length": 563
    },
    {
        "Name": "ctgAPLB01050750",
        "Length": 586
    },
    {
        "Name": "ctgAPLB01050751",
        "Length": 574
    },
    {
        "Name": "ctgAPLB01050752",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050753",
        "Length": 532
    },
    {
        "Name": "ctgAPLB01050754",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01050755",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01050756",
        "Length": 551
    },
    {
        "Name": "ctgAPLB01050757",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01050758",
        "Length": 580
    },
    {
        "Name": "ctgAPLB01050759",
        "Length": 589
    },
    {
        "Name": "ctgAPLB01050760",
        "Length": 590
    },
    {
        "Name": "ctgAPLB01050761",
        "Length": 592
    },
    {
        "Name": "ctgAPLB01050762",
        "Length": 586
    },
    {
        "Name": "ctgAPLB01050763",
        "Length": 593
    },
    {
        "Name": "ctgAPLB01050764",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01050765",
        "Length": 579
    },
    {
        "Name": "ctgAPLB01050766",
        "Length": 594
    },
    {
        "Name": "ctgAPLB01050767",
        "Length": 592
    },
    {
        "Name": "ctgAPLB01050768",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050769",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050770",
        "Length": 589
    },
    {
        "Name": "ctgAPLB01050771",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050772",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050773",
        "Length": 590
    },
    {
        "Name": "ctgAPLB01050774",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050775",
        "Length": 588
    },
    {
        "Name": "ctgAPLB01050776",
        "Length": 592
    },
    {
        "Name": "ctgAPLB01050777",
        "Length": 591
    },
    {
        "Name": "ctgAPLB01050778",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01050779",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01050780",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050781",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050782",
        "Length": 582
    },
    {
        "Name": "ctgAPLB01050783",
        "Length": 600
    },
    {
        "Name": "ctgAPLB01050784",
        "Length": 543
    },
    {
        "Name": "ctgAPLB01050785",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050786",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01050787",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01050788",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01050789",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050790",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01050791",
        "Length": 509
    },
    {
        "Name": "ctgAPLB01050792",
        "Length": 596
    },
    {
        "Name": "ctgAPLB01050793",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050794",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01050795",
        "Length": 594
    },
    {
        "Name": "ctgAPLB01050796",
        "Length": 596
    },
    {
        "Name": "ctgAPLB01050797",
        "Length": 599
    },
    {
        "Name": "ctgAPLB01050798",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01050799",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01050800",
        "Length": 601
    },
    {
        "Name": "ctgAPLB01050801",
        "Length": 598
    },
    {
        "Name": "ctgAPLB01050802",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01050803",
        "Length": 594
    },
    {
        "Name": "ctgAPLB01050804",
        "Length": 602
    },
    {
        "Name": "ctgAPLB01050805",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01050806",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01050807",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01050808",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01050809",
        "Length": 522
    },
    {
        "Name": "ctgAPLB01050810",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01050811",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01050812",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01050813",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01050814",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01050815",
        "Length": 606
    },
    {
        "Name": "ctgAPLB01050816",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01050817",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01050818",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01050820",
        "Length": 606
    },
    {
        "Name": "ctgAPLB01050821",
        "Length": 603
    },
    {
        "Name": "ctgAPLB01050822",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01050823",
        "Length": 606
    },
    {
        "Name": "ctgAPLB01050824",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01050825",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01050826",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01050827",
        "Length": 606
    },
    {
        "Name": "ctgAPLB01050828",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01050829",
        "Length": 607
    },
    {
        "Name": "ctgAPLB01050830",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01050831",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01050832",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01050834",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01050835",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01050836",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01050837",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01050838",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01050839",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01050840",
        "Length": 605
    },
    {
        "Name": "ctgAPLB01050841",
        "Length": 609
    },
    {
        "Name": "ctgAPLB01050842",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01050843",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01050844",
        "Length": 604
    },
    {
        "Name": "ctgAPLB01050845",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01050846",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01050847",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01050848",
        "Length": 608
    },
    {
        "Name": "ctgAPLB01050849",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01050850",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01050851",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01050852",
        "Length": 596
    },
    {
        "Name": "ctgAPLB01050853",
        "Length": 616
    },
    {
        "Name": "ctgAPLB01050854",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01050855",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01050856",
        "Length": 610
    },
    {
        "Name": "ctgAPLB01050857",
        "Length": 612
    },
    {
        "Name": "ctgAPLB01050858",
        "Length": 615
    },
    {
        "Name": "ctgAPLB01050859",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01050860",
        "Length": 585
    },
    {
        "Name": "ctgAPLB01050861",
        "Length": 616
    },
    {
        "Name": "ctgAPLB01050862",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01050863",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01050864",
        "Length": 616
    },
    {
        "Name": "ctgAPLB01050865",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01050866",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01050867",
        "Length": 619
    },
    {
        "Name": "ctgAPLB01050868",
        "Length": 613
    },
    {
        "Name": "ctgAPLB01050869",
        "Length": 618
    },
    {
        "Name": "ctgAPLB01050870",
        "Length": 526
    },
    {
        "Name": "ctgAPLB01050871",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01050872",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01050873",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01050874",
        "Length": 573
    },
    {
        "Name": "ctgAPLB01050875",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01050876",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01050877",
        "Length": 361
    },
    {
        "Name": "ctgAPLB01050878",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01050879",
        "Length": 567
    },
    {
        "Name": "ctgAPLB01050880",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01050881",
        "Length": 623
    },
    {
        "Name": "ctgAPLB01050882",
        "Length": 624
    },
    {
        "Name": "ctgAPLB01050883",
        "Length": 620
    },
    {
        "Name": "ctgAPLB01050884",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01050885",
        "Length": 619
    },
    {
        "Name": "ctgAPLB01050886",
        "Length": 621
    },
    {
        "Name": "ctgAPLB01050887",
        "Length": 624
    },
    {
        "Name": "ctgAPLB01050888",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01050889",
        "Length": 625
    },
    {
        "Name": "ctgAPLB01050890",
        "Length": 582
    },
    {
        "Name": "ctgAPLB01050891",
        "Length": 628
    },
    {
        "Name": "ctgAPLB01050892",
        "Length": 631
    },
    {
        "Name": "ctgAPLB01050893",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01050894",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01050895",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01050896",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01050897",
        "Length": 627
    },
    {
        "Name": "ctgAPLB01050898",
        "Length": 627
    },
    {
        "Name": "ctgAPLB01050899",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01050900",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01050901",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01050902",
        "Length": 630
    },
    {
        "Name": "ctgAPLB01050903",
        "Length": 628
    },
    {
        "Name": "ctgAPLB01050904",
        "Length": 628
    },
    {
        "Name": "ctgAPLB01050905",
        "Length": 618
    },
    {
        "Name": "ctgAPLB01050906",
        "Length": 629
    },
    {
        "Name": "ctgAPLB01050907",
        "Length": 640
    },
    {
        "Name": "ctgAPLB01050908",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01050909",
        "Length": 624
    },
    {
        "Name": "ctgAPLB01050910",
        "Length": 634
    },
    {
        "Name": "ctgAPLB01050911",
        "Length": 641
    },
    {
        "Name": "ctgAPLB01050912",
        "Length": 636
    },
    {
        "Name": "ctgAPLB01050913",
        "Length": 633
    },
    {
        "Name": "ctgAPLB01050914",
        "Length": 644
    },
    {
        "Name": "ctgAPLB01050915",
        "Length": 635
    },
    {
        "Name": "ctgAPLB01050916",
        "Length": 641
    },
    {
        "Name": "ctgAPLB01050917",
        "Length": 640
    },
    {
        "Name": "ctgAPLB01050918",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01050919",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01050920",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01050921",
        "Length": 639
    },
    {
        "Name": "ctgAPLB01050922",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01050923",
        "Length": 642
    },
    {
        "Name": "ctgAPLB01050924",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01050925",
        "Length": 646
    },
    {
        "Name": "ctgAPLB01050926",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01050927",
        "Length": 641
    },
    {
        "Name": "ctgAPLB01050928",
        "Length": 644
    },
    {
        "Name": "ctgAPLB01050929",
        "Length": 643
    },
    {
        "Name": "ctgAPLB01050930",
        "Length": 646
    },
    {
        "Name": "ctgAPLB01050931",
        "Length": 648
    },
    {
        "Name": "ctgAPLB01050932",
        "Length": 649
    },
    {
        "Name": "ctgAPLB01050933",
        "Length": 641
    },
    {
        "Name": "ctgAPLB01050934",
        "Length": 647
    },
    {
        "Name": "ctgAPLB01050935",
        "Length": 595
    },
    {
        "Name": "ctgAPLB01050936",
        "Length": 634
    },
    {
        "Name": "ctgAPLB01050937",
        "Length": 651
    },
    {
        "Name": "ctgAPLB01050938",
        "Length": 648
    },
    {
        "Name": "ctgAPLB01050939",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01050940",
        "Length": 654
    },
    {
        "Name": "ctgAPLB01050941",
        "Length": 651
    },
    {
        "Name": "ctgAPLB01050942",
        "Length": 649
    },
    {
        "Name": "ctgAPLB01050943",
        "Length": 652
    },
    {
        "Name": "ctgAPLB01050944",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01050945",
        "Length": 653
    },
    {
        "Name": "ctgAPLB01050946",
        "Length": 648
    },
    {
        "Name": "ctgAPLB01050947",
        "Length": 657
    },
    {
        "Name": "ctgAPLB01050948",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01050949",
        "Length": 654
    },
    {
        "Name": "ctgAPLB01050950",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01050951",
        "Length": 650
    },
    {
        "Name": "ctgAPLB01050952",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01050953",
        "Length": 661
    },
    {
        "Name": "ctgAPLB01050954",
        "Length": 659
    },
    {
        "Name": "ctgAPLB01050955",
        "Length": 658
    },
    {
        "Name": "ctgAPLB01050956",
        "Length": 655
    },
    {
        "Name": "ctgAPLB01050957",
        "Length": 662
    },
    {
        "Name": "ctgAPLB01050958",
        "Length": 663
    },
    {
        "Name": "ctgAPLB01050959",
        "Length": 557
    },
    {
        "Name": "ctgAPLB01050960",
        "Length": 659
    },
    {
        "Name": "ctgAPLB01050961",
        "Length": 662
    },
    {
        "Name": "ctgAPLB01050962",
        "Length": 665
    },
    {
        "Name": "ctgAPLB01050963",
        "Length": 661
    },
    {
        "Name": "ctgAPLB01050964",
        "Length": 665
    },
    {
        "Name": "ctgAPLB01050965",
        "Length": 584
    },
    {
        "Name": "ctgAPLB01050966",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050967",
        "Length": 661
    },
    {
        "Name": "ctgAPLB01050968",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01050969",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01050970",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050972",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050974",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050975",
        "Length": 648
    },
    {
        "Name": "ctgAPLB01050976",
        "Length": 667
    },
    {
        "Name": "ctgAPLB01050977",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01050978",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01050979",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050980",
        "Length": 674
    },
    {
        "Name": "ctgAPLB01050981",
        "Length": 673
    },
    {
        "Name": "ctgAPLB01050982",
        "Length": 668
    },
    {
        "Name": "ctgAPLB01050983",
        "Length": 388
    },
    {
        "Name": "ctgAPLB01050984",
        "Length": 672
    },
    {
        "Name": "ctgAPLB01050985",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01050986",
        "Length": 615
    },
    {
        "Name": "ctgAPLB01050987",
        "Length": 664
    },
    {
        "Name": "ctgAPLB01050988",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01050989",
        "Length": 671
    },
    {
        "Name": "ctgAPLB01050990",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01050991",
        "Length": 674
    },
    {
        "Name": "ctgAPLB01050992",
        "Length": 675
    },
    {
        "Name": "ctgAPLB01050993",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01050994",
        "Length": 620
    },
    {
        "Name": "ctgAPLB01050995",
        "Length": 676
    },
    {
        "Name": "ctgAPLB01050996",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050997",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01050998",
        "Length": 666
    },
    {
        "Name": "ctgAPLB01050999",
        "Length": 676
    },
    {
        "Name": "ctgAPLB01051000",
        "Length": 678
    },
    {
        "Name": "ctgAPLB01051001",
        "Length": 676
    },
    {
        "Name": "ctgAPLB01051002",
        "Length": 675
    },
    {
        "Name": "ctgAPLB01051003",
        "Length": 677
    },
    {
        "Name": "ctgAPLB01051004",
        "Length": 676
    },
    {
        "Name": "ctgAPLB01051005",
        "Length": 681
    },
    {
        "Name": "ctgAPLB01051006",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01051007",
        "Length": 679
    },
    {
        "Name": "ctgAPLB01051008",
        "Length": 680
    },
    {
        "Name": "ctgAPLB01051009",
        "Length": 682
    },
    {
        "Name": "ctgAPLB01051010",
        "Length": 682
    },
    {
        "Name": "ctgAPLB01051011",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01051012",
        "Length": 683
    },
    {
        "Name": "ctgAPLB01051013",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01051014",
        "Length": 680
    },
    {
        "Name": "ctgAPLB01051015",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01051016",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01051017",
        "Length": 687
    },
    {
        "Name": "ctgAPLB01051018",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01051019",
        "Length": 685
    },
    {
        "Name": "ctgAPLB01051020",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01051021",
        "Length": 688
    },
    {
        "Name": "ctgAPLB01051022",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01051023",
        "Length": 622
    },
    {
        "Name": "ctgAPLB01051024",
        "Length": 688
    },
    {
        "Name": "ctgAPLB01051025",
        "Length": 682
    },
    {
        "Name": "ctgAPLB01051026",
        "Length": 682
    },
    {
        "Name": "ctgAPLB01051027",
        "Length": 681
    },
    {
        "Name": "ctgAPLB01051028",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01051029",
        "Length": 691
    },
    {
        "Name": "ctgAPLB01051030",
        "Length": 691
    },
    {
        "Name": "ctgAPLB01051031",
        "Length": 660
    },
    {
        "Name": "ctgAPLB01051032",
        "Length": 693
    },
    {
        "Name": "ctgAPLB01051033",
        "Length": 670
    },
    {
        "Name": "ctgAPLB01051034",
        "Length": 694
    },
    {
        "Name": "ctgAPLB01051035",
        "Length": 684
    },
    {
        "Name": "ctgAPLB01051036",
        "Length": 695
    },
    {
        "Name": "ctgAPLB01051037",
        "Length": 690
    },
    {
        "Name": "ctgAPLB01051038",
        "Length": 696
    },
    {
        "Name": "ctgAPLB01051039",
        "Length": 700
    },
    {
        "Name": "ctgAPLB01051040",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01051041",
        "Length": 486
    },
    {
        "Name": "ctgAPLB01051042",
        "Length": 696
    },
    {
        "Name": "ctgAPLB01051043",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01051044",
        "Length": 694
    },
    {
        "Name": "ctgAPLB01051045",
        "Length": 679
    },
    {
        "Name": "ctgAPLB01051046",
        "Length": 617
    },
    {
        "Name": "ctgAPLB01051047",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01051048",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01051049",
        "Length": 702
    },
    {
        "Name": "ctgAPLB01051050",
        "Length": 632
    },
    {
        "Name": "ctgAPLB01051051",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01051052",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01051053",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01051054",
        "Length": 651
    },
    {
        "Name": "ctgAPLB01051055",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01051056",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01051057",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01051058",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01051059",
        "Length": 710
    },
    {
        "Name": "ctgAPLB01051060",
        "Length": 704
    },
    {
        "Name": "ctgAPLB01051061",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01051062",
        "Length": 706
    },
    {
        "Name": "ctgAPLB01051064",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01051065",
        "Length": 703
    },
    {
        "Name": "ctgAPLB01051066",
        "Length": 688
    },
    {
        "Name": "ctgAPLB01051067",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01051068",
        "Length": 698
    },
    {
        "Name": "ctgAPLB01051069",
        "Length": 702
    },
    {
        "Name": "ctgAPLB01051070",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01051071",
        "Length": 709
    },
    {
        "Name": "ctgAPLB01051072",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01051073",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01051074",
        "Length": 708
    },
    {
        "Name": "ctgAPLB01051075",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01051076",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01051077",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01051078",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01051079",
        "Length": 653
    },
    {
        "Name": "ctgAPLB01051080",
        "Length": 713
    },
    {
        "Name": "ctgAPLB01051081",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01051082",
        "Length": 712
    },
    {
        "Name": "ctgAPLB01051083",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01051084",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01051085",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01051086",
        "Length": 686
    },
    {
        "Name": "ctgAPLB01051087",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01051088",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01051089",
        "Length": 718
    },
    {
        "Name": "ctgAPLB01051090",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01051091",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01051092",
        "Length": 721
    },
    {
        "Name": "ctgAPLB01051093",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01051094",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01051095",
        "Length": 725
    },
    {
        "Name": "ctgAPLB01051096",
        "Length": 726
    },
    {
        "Name": "ctgAPLB01051097",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01051098",
        "Length": 720
    },
    {
        "Name": "ctgAPLB01051099",
        "Length": 700
    },
    {
        "Name": "ctgAPLB01051101",
        "Length": 705
    },
    {
        "Name": "ctgAPLB01051102",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01051103",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01051104",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01051105",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01051106",
        "Length": 674
    },
    {
        "Name": "ctgAPLB01051107",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01051108",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01051109",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051110",
        "Length": 725
    },
    {
        "Name": "ctgAPLB01051111",
        "Length": 728
    },
    {
        "Name": "ctgAPLB01051112",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051113",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01051114",
        "Length": 723
    },
    {
        "Name": "ctgAPLB01051115",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01051116",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051117",
        "Length": 717
    },
    {
        "Name": "ctgAPLB01051118",
        "Length": 722
    },
    {
        "Name": "ctgAPLB01051119",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051120",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01051121",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01051122",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051123",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01051124",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01051125",
        "Length": 737
    },
    {
        "Name": "ctgAPLB01051126",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01051127",
        "Length": 737
    },
    {
        "Name": "ctgAPLB01051128",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01051129",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01051130",
        "Length": 731
    },
    {
        "Name": "ctgAPLB01051131",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01051132",
        "Length": 667
    },
    {
        "Name": "ctgAPLB01051133",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01051134",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01051136",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01051137",
        "Length": 743
    },
    {
        "Name": "ctgAPLB01051138",
        "Length": 611
    },
    {
        "Name": "ctgAPLB01051139",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01051140",
        "Length": 732
    },
    {
        "Name": "ctgAPLB01051141",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01051142",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01051143",
        "Length": 741
    },
    {
        "Name": "ctgAPLB01051144",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01051145",
        "Length": 734
    },
    {
        "Name": "ctgAPLB01051146",
        "Length": 742
    },
    {
        "Name": "ctgAPLB01051147",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01051148",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01051149",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01051150",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01051151",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01051152",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01051153",
        "Length": 740
    },
    {
        "Name": "ctgAPLB01051154",
        "Length": 751
    },
    {
        "Name": "ctgAPLB01051155",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01051156",
        "Length": 746
    },
    {
        "Name": "ctgAPLB01051157",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01051158",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01051159",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01051160",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01051161",
        "Length": 747
    },
    {
        "Name": "ctgAPLB01051162",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01051163",
        "Length": 758
    },
    {
        "Name": "ctgAPLB01051164",
        "Length": 748
    },
    {
        "Name": "ctgAPLB01051165",
        "Length": 695
    },
    {
        "Name": "ctgAPLB01051166",
        "Length": 754
    },
    {
        "Name": "ctgAPLB01051167",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01051168",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01051169",
        "Length": 756
    },
    {
        "Name": "ctgAPLB01051170",
        "Length": 628
    },
    {
        "Name": "ctgAPLB01051171",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01051172",
        "Length": 760
    },
    {
        "Name": "ctgAPLB01051173",
        "Length": 768
    },
    {
        "Name": "ctgAPLB01051174",
        "Length": 763
    },
    {
        "Name": "ctgAPLB01051175",
        "Length": 766
    },
    {
        "Name": "ctgAPLB01051176",
        "Length": 765
    },
    {
        "Name": "ctgAPLB01051177",
        "Length": 769
    },
    {
        "Name": "ctgAPLB01051178",
        "Length": 711
    },
    {
        "Name": "ctgAPLB01051179",
        "Length": 765
    },
    {
        "Name": "ctgAPLB01051180",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01051181",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01051182",
        "Length": 770
    },
    {
        "Name": "ctgAPLB01051183",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01051184",
        "Length": 767
    },
    {
        "Name": "ctgAPLB01051185",
        "Length": 735
    },
    {
        "Name": "ctgAPLB01051186",
        "Length": 779
    },
    {
        "Name": "ctgAPLB01051187",
        "Length": 770
    },
    {
        "Name": "ctgAPLB01051188",
        "Length": 778
    },
    {
        "Name": "ctgAPLB01051189",
        "Length": 779
    },
    {
        "Name": "ctgAPLB01051190",
        "Length": 776
    },
    {
        "Name": "ctgAPLB01051191",
        "Length": 773
    },
    {
        "Name": "ctgAPLB01051192",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01051193",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01051194",
        "Length": 783
    },
    {
        "Name": "ctgAPLB01051195",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01051196",
        "Length": 716
    },
    {
        "Name": "ctgAPLB01051197",
        "Length": 719
    },
    {
        "Name": "ctgAPLB01051198",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01051199",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01051200",
        "Length": 782
    },
    {
        "Name": "ctgAPLB01051201",
        "Length": 774
    },
    {
        "Name": "ctgAPLB01051202",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01051203",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01051204",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01051205",
        "Length": 789
    },
    {
        "Name": "ctgAPLB01051206",
        "Length": 738
    },
    {
        "Name": "ctgAPLB01051208",
        "Length": 785
    },
    {
        "Name": "ctgAPLB01051209",
        "Length": 782
    },
    {
        "Name": "ctgAPLB01051210",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01051211",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01051212",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01051213",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01051214",
        "Length": 792
    },
    {
        "Name": "ctgAPLB01051215",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01051216",
        "Length": 788
    },
    {
        "Name": "ctgAPLB01051217",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01051218",
        "Length": 787
    },
    {
        "Name": "ctgAPLB01051219",
        "Length": 788
    },
    {
        "Name": "ctgAPLB01051220",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01051221",
        "Length": 795
    },
    {
        "Name": "ctgAPLB01051222",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01051223",
        "Length": 727
    },
    {
        "Name": "ctgAPLB01051224",
        "Length": 794
    },
    {
        "Name": "ctgAPLB01051225",
        "Length": 806
    },
    {
        "Name": "ctgAPLB01051226",
        "Length": 807
    },
    {
        "Name": "ctgAPLB01051227",
        "Length": 797
    },
    {
        "Name": "ctgAPLB01051228",
        "Length": 729
    },
    {
        "Name": "ctgAPLB01051229",
        "Length": 803
    },
    {
        "Name": "ctgAPLB01051230",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01051231",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01051232",
        "Length": 801
    },
    {
        "Name": "ctgAPLB01051233",
        "Length": 752
    },
    {
        "Name": "ctgAPLB01051234",
        "Length": 786
    },
    {
        "Name": "ctgAPLB01051235",
        "Length": 799
    },
    {
        "Name": "ctgAPLB01051236",
        "Length": 811
    },
    {
        "Name": "ctgAPLB01051237",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01051238",
        "Length": 811
    },
    {
        "Name": "ctgAPLB01051239",
        "Length": 626
    },
    {
        "Name": "ctgAPLB01051240",
        "Length": 809
    },
    {
        "Name": "ctgAPLB01051241",
        "Length": 820
    },
    {
        "Name": "ctgAPLB01051242",
        "Length": 819
    },
    {
        "Name": "ctgAPLB01051243",
        "Length": 813
    },
    {
        "Name": "ctgAPLB01051244",
        "Length": 819
    },
    {
        "Name": "ctgAPLB01051245",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01051246",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01051247",
        "Length": 793
    },
    {
        "Name": "ctgAPLB01051248",
        "Length": 815
    },
    {
        "Name": "ctgAPLB01051249",
        "Length": 822
    },
    {
        "Name": "ctgAPLB01051250",
        "Length": 811
    },
    {
        "Name": "ctgAPLB01051251",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01051252",
        "Length": 817
    },
    {
        "Name": "ctgAPLB01051253",
        "Length": 812
    },
    {
        "Name": "ctgAPLB01051254",
        "Length": 829
    },
    {
        "Name": "ctgAPLB01051255",
        "Length": 745
    },
    {
        "Name": "ctgAPLB01051256",
        "Length": 828
    },
    {
        "Name": "ctgAPLB01051257",
        "Length": 829
    },
    {
        "Name": "ctgAPLB01051258",
        "Length": 820
    },
    {
        "Name": "ctgAPLB01051259",
        "Length": 825
    },
    {
        "Name": "ctgAPLB01051260",
        "Length": 834
    },
    {
        "Name": "ctgAPLB01051261",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01051262",
        "Length": 834
    },
    {
        "Name": "ctgAPLB01051263",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01051264",
        "Length": 838
    },
    {
        "Name": "ctgAPLB01051265",
        "Length": 831
    },
    {
        "Name": "ctgAPLB01051266",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01051267",
        "Length": 824
    },
    {
        "Name": "ctgAPLB01051268",
        "Length": 749
    },
    {
        "Name": "ctgAPLB01051269",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01051270",
        "Length": 842
    },
    {
        "Name": "ctgAPLB01051271",
        "Length": 837
    },
    {
        "Name": "ctgAPLB01051272",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01051274",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01051275",
        "Length": 839
    },
    {
        "Name": "ctgAPLB01051276",
        "Length": 823
    },
    {
        "Name": "ctgAPLB01051277",
        "Length": 841
    },
    {
        "Name": "ctgAPLB01051278",
        "Length": 845
    },
    {
        "Name": "ctgAPLB01051279",
        "Length": 842
    },
    {
        "Name": "ctgAPLB01051280",
        "Length": 843
    },
    {
        "Name": "ctgAPLB01051281",
        "Length": 762
    },
    {
        "Name": "ctgAPLB01051282",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01051283",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01051284",
        "Length": 833
    },
    {
        "Name": "ctgAPLB01051285",
        "Length": 835
    },
    {
        "Name": "ctgAPLB01051286",
        "Length": 850
    },
    {
        "Name": "ctgAPLB01051287",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01051288",
        "Length": 853
    },
    {
        "Name": "ctgAPLB01051289",
        "Length": 850
    },
    {
        "Name": "ctgAPLB01051290",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01051291",
        "Length": 855
    },
    {
        "Name": "ctgAPLB01051292",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01051293",
        "Length": 857
    },
    {
        "Name": "ctgAPLB01051294",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01051295",
        "Length": 764
    },
    {
        "Name": "ctgAPLB01051296",
        "Length": 848
    },
    {
        "Name": "ctgAPLB01051297",
        "Length": 730
    },
    {
        "Name": "ctgAPLB01051298",
        "Length": 851
    },
    {
        "Name": "ctgAPLB01051299",
        "Length": 854
    },
    {
        "Name": "ctgAPLB01051300",
        "Length": 848
    },
    {
        "Name": "ctgAPLB01051301",
        "Length": 865
    },
    {
        "Name": "ctgAPLB01051302",
        "Length": 864
    },
    {
        "Name": "ctgAPLB01051303",
        "Length": 870
    },
    {
        "Name": "ctgAPLB01051304",
        "Length": 862
    },
    {
        "Name": "ctgAPLB01051305",
        "Length": 859
    },
    {
        "Name": "ctgAPLB01051306",
        "Length": 860
    },
    {
        "Name": "ctgAPLB01051307",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01051308",
        "Length": 869
    },
    {
        "Name": "ctgAPLB01051309",
        "Length": 873
    },
    {
        "Name": "ctgAPLB01051310",
        "Length": 860
    },
    {
        "Name": "ctgAPLB01051311",
        "Length": 866
    },
    {
        "Name": "ctgAPLB01051312",
        "Length": 880
    },
    {
        "Name": "ctgAPLB01051313",
        "Length": 879
    },
    {
        "Name": "ctgAPLB01051314",
        "Length": 876
    },
    {
        "Name": "ctgAPLB01051315",
        "Length": 777
    },
    {
        "Name": "ctgAPLB01051316",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01051317",
        "Length": 864
    },
    {
        "Name": "ctgAPLB01051318",
        "Length": 876
    },
    {
        "Name": "ctgAPLB01051319",
        "Length": 759
    },
    {
        "Name": "ctgAPLB01051320",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01051321",
        "Length": 879
    },
    {
        "Name": "ctgAPLB01051322",
        "Length": 781
    },
    {
        "Name": "ctgAPLB01051323",
        "Length": 889
    },
    {
        "Name": "ctgAPLB01051324",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01051325",
        "Length": 846
    },
    {
        "Name": "ctgAPLB01051326",
        "Length": 872
    },
    {
        "Name": "ctgAPLB01051327",
        "Length": 878
    },
    {
        "Name": "ctgAPLB01051328",
        "Length": 884
    },
    {
        "Name": "ctgAPLB01051329",
        "Length": 892
    },
    {
        "Name": "ctgAPLB01051330",
        "Length": 872
    },
    {
        "Name": "ctgAPLB01051331",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01051333",
        "Length": 753
    },
    {
        "Name": "ctgAPLB01051334",
        "Length": 810
    },
    {
        "Name": "ctgAPLB01051335",
        "Length": 861
    },
    {
        "Name": "ctgAPLB01051336",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01051337",
        "Length": 904
    },
    {
        "Name": "ctgAPLB01051338",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01051339",
        "Length": 887
    },
    {
        "Name": "ctgAPLB01051340",
        "Length": 896
    },
    {
        "Name": "ctgAPLB01051341",
        "Length": 898
    },
    {
        "Name": "ctgAPLB01051342",
        "Length": 899
    },
    {
        "Name": "ctgAPLB01051343",
        "Length": 899
    },
    {
        "Name": "ctgAPLB01051344",
        "Length": 901
    },
    {
        "Name": "ctgAPLB01051345",
        "Length": 619
    },
    {
        "Name": "ctgAPLB01051346",
        "Length": 898
    },
    {
        "Name": "ctgAPLB01051347",
        "Length": 891
    },
    {
        "Name": "ctgAPLB01051348",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01051349",
        "Length": 903
    },
    {
        "Name": "ctgAPLB01051350",
        "Length": 908
    },
    {
        "Name": "ctgAPLB01051351",
        "Length": 911
    },
    {
        "Name": "ctgAPLB01051352",
        "Length": 907
    },
    {
        "Name": "ctgAPLB01051353",
        "Length": 907
    },
    {
        "Name": "ctgAPLB01051354",
        "Length": 903
    },
    {
        "Name": "ctgAPLB01051355",
        "Length": 909
    },
    {
        "Name": "ctgAPLB01051356",
        "Length": 912
    },
    {
        "Name": "ctgAPLB01051357",
        "Length": 905
    },
    {
        "Name": "ctgAPLB01051358",
        "Length": 906
    },
    {
        "Name": "ctgAPLB01051359",
        "Length": 913
    },
    {
        "Name": "ctgAPLB01051360",
        "Length": 912
    },
    {
        "Name": "ctgAPLB01051361",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01051362",
        "Length": 917
    },
    {
        "Name": "ctgAPLB01051363",
        "Length": 856
    },
    {
        "Name": "ctgAPLB01051364",
        "Length": 915
    },
    {
        "Name": "ctgAPLB01051365",
        "Length": 928
    },
    {
        "Name": "ctgAPLB01051366",
        "Length": 910
    },
    {
        "Name": "ctgAPLB01051367",
        "Length": 917
    },
    {
        "Name": "ctgAPLB01051368",
        "Length": 904
    },
    {
        "Name": "ctgAPLB01051369",
        "Length": 931
    },
    {
        "Name": "ctgAPLB01051370",
        "Length": 920
    },
    {
        "Name": "ctgAPLB01051371",
        "Length": 913
    },
    {
        "Name": "ctgAPLB01051372",
        "Length": 840
    },
    {
        "Name": "ctgAPLB01051373",
        "Length": 900
    },
    {
        "Name": "ctgAPLB01051374",
        "Length": 909
    },
    {
        "Name": "ctgAPLB01051375",
        "Length": 914
    },
    {
        "Name": "ctgAPLB01051376",
        "Length": 915
    },
    {
        "Name": "ctgAPLB01051377",
        "Length": 917
    },
    {
        "Name": "ctgAPLB01051378",
        "Length": 692
    },
    {
        "Name": "ctgAPLB01051379",
        "Length": 915
    },
    {
        "Name": "ctgAPLB01051380",
        "Length": 846
    },
    {
        "Name": "ctgAPLB01051381",
        "Length": 926
    },
    {
        "Name": "ctgAPLB01051382",
        "Length": 933
    },
    {
        "Name": "ctgAPLB01051383",
        "Length": 932
    },
    {
        "Name": "ctgAPLB01051384",
        "Length": 936
    },
    {
        "Name": "ctgAPLB01051385",
        "Length": 935
    },
    {
        "Name": "ctgAPLB01051386",
        "Length": 932
    },
    {
        "Name": "ctgAPLB01051387",
        "Length": 938
    },
    {
        "Name": "ctgAPLB01051388",
        "Length": 939
    },
    {
        "Name": "ctgAPLB01051389",
        "Length": 939
    },
    {
        "Name": "ctgAPLB01051390",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01051391",
        "Length": 947
    },
    {
        "Name": "ctgAPLB01051392",
        "Length": 939
    },
    {
        "Name": "ctgAPLB01051393",
        "Length": 933
    },
    {
        "Name": "ctgAPLB01051394",
        "Length": 945
    },
    {
        "Name": "ctgAPLB01051395",
        "Length": 943
    },
    {
        "Name": "ctgAPLB01051396",
        "Length": 949
    },
    {
        "Name": "ctgAPLB01051397",
        "Length": 938
    },
    {
        "Name": "ctgAPLB01051398",
        "Length": 941
    },
    {
        "Name": "ctgAPLB01051399",
        "Length": 944
    },
    {
        "Name": "ctgAPLB01051400",
        "Length": 951
    },
    {
        "Name": "ctgAPLB01051401",
        "Length": 949
    },
    {
        "Name": "ctgAPLB01051402",
        "Length": 952
    },
    {
        "Name": "ctgAPLB01051403",
        "Length": 952
    },
    {
        "Name": "ctgAPLB01051404",
        "Length": 791
    },
    {
        "Name": "ctgAPLB01051405",
        "Length": 963
    },
    {
        "Name": "ctgAPLB01051406",
        "Length": 965
    },
    {
        "Name": "ctgAPLB01051407",
        "Length": 967
    },
    {
        "Name": "ctgAPLB01051408",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01051409",
        "Length": 970
    },
    {
        "Name": "ctgAPLB01051410",
        "Length": 954
    },
    {
        "Name": "ctgAPLB01051411",
        "Length": 969
    },
    {
        "Name": "ctgAPLB01051412",
        "Length": 950
    },
    {
        "Name": "ctgAPLB01051413",
        "Length": 967
    },
    {
        "Name": "ctgAPLB01051414",
        "Length": 867
    },
    {
        "Name": "ctgAPLB01051415",
        "Length": 971
    },
    {
        "Name": "ctgAPLB01051416",
        "Length": 974
    },
    {
        "Name": "ctgAPLB01051417",
        "Length": 962
    },
    {
        "Name": "ctgAPLB01051418",
        "Length": 971
    },
    {
        "Name": "ctgAPLB01051419",
        "Length": 964
    },
    {
        "Name": "ctgAPLB01051420",
        "Length": 955
    },
    {
        "Name": "ctgAPLB01051421",
        "Length": 977
    },
    {
        "Name": "ctgAPLB01051422",
        "Length": 986
    },
    {
        "Name": "ctgAPLB01051423",
        "Length": 980
    },
    {
        "Name": "ctgAPLB01051424",
        "Length": 978
    },
    {
        "Name": "ctgAPLB01051425",
        "Length": 977
    },
    {
        "Name": "ctgAPLB01051426",
        "Length": 975
    },
    {
        "Name": "ctgAPLB01051427",
        "Length": 984
    },
    {
        "Name": "ctgAPLB01051428",
        "Length": 977
    },
    {
        "Name": "ctgAPLB01051429",
        "Length": 984
    },
    {
        "Name": "ctgAPLB01051430",
        "Length": 953
    },
    {
        "Name": "ctgAPLB01051431",
        "Length": 974
    },
    {
        "Name": "ctgAPLB01051432",
        "Length": 796
    },
    {
        "Name": "ctgAPLB01051433",
        "Length": 975
    },
    {
        "Name": "ctgAPLB01051434",
        "Length": 984
    },
    {
        "Name": "ctgAPLB01051435",
        "Length": 980
    },
    {
        "Name": "ctgAPLB01051436",
        "Length": 987
    },
    {
        "Name": "ctgAPLB01051437",
        "Length": 986
    },
    {
        "Name": "ctgAPLB01051438",
        "Length": 996
    },
    {
        "Name": "ctgAPLB01051439",
        "Length": 989
    },
    {
        "Name": "ctgAPLB01051440",
        "Length": 991
    },
    {
        "Name": "ctgAPLB01051441",
        "Length": 979
    },
    {
        "Name": "ctgAPLB01051442",
        "Length": 999
    },
    {
        "Name": "ctgAPLB01051443",
        "Length": 988
    },
    {
        "Name": "ctgAPLB01051444",
        "Length": 993
    },
    {
        "Name": "ctgAPLB01051445",
        "Length": 997
    },
    {
        "Name": "ctgAPLB01051446",
        "Length": 1001
    },
    {
        "Name": "ctgAPLB01051447",
        "Length": 995
    },
    {
        "Name": "ctgAPLB01051448",
        "Length": 1001
    },
    {
        "Name": "ctgAPLB01051449",
        "Length": 827
    },
    {
        "Name": "ctgAPLB01051450",
        "Length": 1004
    },
    {
        "Name": "ctgAPLB01051451",
        "Length": 943
    },
    {
        "Name": "ctgAPLB01051452",
        "Length": 1001
    },
    {
        "Name": "ctgAPLB01051453",
        "Length": 929
    },
    {
        "Name": "ctgAPLB01051454",
        "Length": 939
    },
    {
        "Name": "ctgAPLB01051455",
        "Length": 1015
    },
    {
        "Name": "ctgAPLB01051456",
        "Length": 1005
    },
    {
        "Name": "ctgAPLB01051457",
        "Length": 1016
    },
    {
        "Name": "ctgAPLB01051458",
        "Length": 1002
    },
    {
        "Name": "ctgAPLB01051459",
        "Length": 1020
    },
    {
        "Name": "ctgAPLB01051460",
        "Length": 1021
    },
    {
        "Name": "ctgAPLB01051461",
        "Length": 910
    },
    {
        "Name": "ctgAPLB01051463",
        "Length": 1002
    },
    {
        "Name": "ctgAPLB01051464",
        "Length": 921
    },
    {
        "Name": "ctgAPLB01051465",
        "Length": 886
    },
    {
        "Name": "ctgAPLB01051466",
        "Length": 1026
    },
    {
        "Name": "ctgAPLB01051467",
        "Length": 1005
    },
    {
        "Name": "ctgAPLB01051468",
        "Length": 1026
    },
    {
        "Name": "ctgAPLB01051469",
        "Length": 922
    },
    {
        "Name": "ctgAPLB01051470",
        "Length": 993
    },
    {
        "Name": "ctgAPLB01051471",
        "Length": 1007
    },
    {
        "Name": "ctgAPLB01051472",
        "Length": 931
    },
    {
        "Name": "ctgAPLB01051473",
        "Length": 996
    },
    {
        "Name": "ctgAPLB01051474",
        "Length": 505
    },
    {
        "Name": "ctgAPLB01051475",
        "Length": 881
    },
    {
        "Name": "ctgAPLB01051476",
        "Length": 1019
    },
    {
        "Name": "ctgAPLB01051477",
        "Length": 952
    },
    {
        "Name": "ctgAPLB01051478",
        "Length": 967
    },
    {
        "Name": "ctgAPLB01051479",
        "Length": 993
    },
    {
        "Name": "ctgAPLB01051480",
        "Length": 950
    },
    {
        "Name": "ctgAPLB01051481",
        "Length": 1034
    },
    {
        "Name": "ctgAPLB01051482",
        "Length": 1031
    },
    {
        "Name": "ctgAPLB01051483",
        "Length": 231
    },
    {
        "Name": "ctgAPLB01051484",
        "Length": 964
    },
    {
        "Name": "ctgAPLB01051485",
        "Length": 863
    },
    {
        "Name": "ctgAPLB01051486",
        "Length": 989
    },
    {
        "Name": "ctgAPLB01051487",
        "Length": 938
    },
    {
        "Name": "ctgAPLB01051488",
        "Length": 1011
    },
    {
        "Name": "ctgAPLB01051489",
        "Length": 846
    },
    {
        "Name": "ctgAPLB01051490",
        "Length": 988
    },
    {
        "Name": "ctgAPLB01051491",
        "Length": 1029
    },
    {
        "Name": "ctgAPLB01051492",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01051493",
        "Length": 1041
    },
    {
        "Name": "ctgAPLB01051494",
        "Length": 1049
    },
    {
        "Name": "ctgAPLB01051495",
        "Length": 1042
    },
    {
        "Name": "ctgAPLB01051496",
        "Length": 1035
    },
    {
        "Name": "ctgAPLB01051497",
        "Length": 1038
    },
    {
        "Name": "ctgAPLB01051498",
        "Length": 1031
    },
    {
        "Name": "ctgAPLB01051499",
        "Length": 1032
    },
    {
        "Name": "ctgAPLB01051500",
        "Length": 1032
    },
    {
        "Name": "ctgAPLB01051501",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01051502",
        "Length": 1041
    },
    {
        "Name": "ctgAPLB01051503",
        "Length": 1039
    },
    {
        "Name": "ctgAPLB01051504",
        "Length": 1041
    },
    {
        "Name": "ctgAPLB01051505",
        "Length": 784
    },
    {
        "Name": "ctgAPLB01051506",
        "Length": 1055
    },
    {
        "Name": "ctgAPLB01051507",
        "Length": 1048
    },
    {
        "Name": "ctgAPLB01051508",
        "Length": 1061
    },
    {
        "Name": "ctgAPLB01051509",
        "Length": 1047
    },
    {
        "Name": "ctgAPLB01051510",
        "Length": 1032
    },
    {
        "Name": "ctgAPLB01051511",
        "Length": 1040
    },
    {
        "Name": "ctgAPLB01051512",
        "Length": 1034
    },
    {
        "Name": "ctgAPLB01051513",
        "Length": 657
    },
    {
        "Name": "ctgAPLB01051514",
        "Length": 1060
    },
    {
        "Name": "ctgAPLB01051515",
        "Length": 1052
    },
    {
        "Name": "ctgAPLB01051516",
        "Length": 1046
    },
    {
        "Name": "ctgAPLB01051517",
        "Length": 1057
    },
    {
        "Name": "ctgAPLB01051518",
        "Length": 1053
    },
    {
        "Name": "ctgAPLB01051519",
        "Length": 1073
    },
    {
        "Name": "ctgAPLB01051520",
        "Length": 1068
    },
    {
        "Name": "ctgAPLB01051521",
        "Length": 1058
    },
    {
        "Name": "ctgAPLB01051522",
        "Length": 1069
    },
    {
        "Name": "ctgAPLB01051523",
        "Length": 1043
    },
    {
        "Name": "ctgAPLB01051524",
        "Length": 1075
    },
    {
        "Name": "ctgAPLB01051525",
        "Length": 1068
    },
    {
        "Name": "ctgAPLB01051526",
        "Length": 1063
    },
    {
        "Name": "ctgAPLB01051527",
        "Length": 1082
    },
    {
        "Name": "ctgAPLB01051528",
        "Length": 1092
    },
    {
        "Name": "ctgAPLB01051529",
        "Length": 1066
    },
    {
        "Name": "ctgAPLB01051531",
        "Length": 1071
    },
    {
        "Name": "ctgAPLB01051532",
        "Length": 1068
    },
    {
        "Name": "ctgAPLB01051533",
        "Length": 1093
    },
    {
        "Name": "ctgAPLB01051534",
        "Length": 1090
    },
    {
        "Name": "ctgAPLB01051535",
        "Length": 1106
    },
    {
        "Name": "ctgAPLB01051536",
        "Length": 1066
    },
    {
        "Name": "ctgAPLB01051537",
        "Length": 1054
    },
    {
        "Name": "ctgAPLB01051538",
        "Length": 1104
    },
    {
        "Name": "ctgAPLB01051539",
        "Length": 1081
    },
    {
        "Name": "ctgAPLB01051540",
        "Length": 1098
    },
    {
        "Name": "ctgAPLB01051541",
        "Length": 1091
    },
    {
        "Name": "ctgAPLB01051543",
        "Length": 1047
    },
    {
        "Name": "ctgAPLB01051544",
        "Length": 1107
    },
    {
        "Name": "ctgAPLB01051545",
        "Length": 1110
    },
    {
        "Name": "ctgAPLB01051546",
        "Length": 1106
    },
    {
        "Name": "ctgAPLB01051547",
        "Length": 1123
    },
    {
        "Name": "ctgAPLB01051548",
        "Length": 1102
    },
    {
        "Name": "ctgAPLB01051549",
        "Length": 1062
    },
    {
        "Name": "ctgAPLB01051550",
        "Length": 1082
    },
    {
        "Name": "ctgAPLB01051551",
        "Length": 1139
    },
    {
        "Name": "ctgAPLB01051552",
        "Length": 1125
    },
    {
        "Name": "ctgAPLB01051553",
        "Length": 1116
    },
    {
        "Name": "ctgAPLB01051554",
        "Length": 1037
    },
    {
        "Name": "ctgAPLB01051555",
        "Length": 1077
    },
    {
        "Name": "ctgAPLB01051556",
        "Length": 1112
    },
    {
        "Name": "ctgAPLB01051557",
        "Length": 1142
    },
    {
        "Name": "ctgAPLB01051558",
        "Length": 1122
    },
    {
        "Name": "ctgAPLB01051559",
        "Length": 1075
    },
    {
        "Name": "ctgAPLB01051560",
        "Length": 1137
    },
    {
        "Name": "ctgAPLB01051561",
        "Length": 1138
    },
    {
        "Name": "ctgAPLB01051562",
        "Length": 1151
    },
    {
        "Name": "ctgAPLB01051563",
        "Length": 1135
    },
    {
        "Name": "ctgAPLB01051564",
        "Length": 1153
    },
    {
        "Name": "ctgAPLB01051565",
        "Length": 1092
    },
    {
        "Name": "ctgAPLB01051566",
        "Length": 1154
    },
    {
        "Name": "ctgAPLB01051567",
        "Length": 1137
    },
    {
        "Name": "ctgAPLB01051568",
        "Length": 1160
    },
    {
        "Name": "ctgAPLB01051569",
        "Length": 1147
    },
    {
        "Name": "ctgAPLB01051570",
        "Length": 1160
    },
    {
        "Name": "ctgAPLB01051571",
        "Length": 1118
    },
    {
        "Name": "ctgAPLB01051572",
        "Length": 1149
    },
    {
        "Name": "ctgAPLB01051573",
        "Length": 1155
    },
    {
        "Name": "ctgAPLB01051575",
        "Length": 1127
    },
    {
        "Name": "ctgAPLB01051576",
        "Length": 1174
    },
    {
        "Name": "ctgAPLB01051577",
        "Length": 1149
    },
    {
        "Name": "ctgAPLB01051578",
        "Length": 1134
    },
    {
        "Name": "ctgAPLB01051579",
        "Length": 1189
    },
    {
        "Name": "ctgAPLB01051580",
        "Length": 1161
    },
    {
        "Name": "ctgAPLB01051581",
        "Length": 1179
    },
    {
        "Name": "ctgAPLB01051582",
        "Length": 1170
    },
    {
        "Name": "ctgAPLB01051583",
        "Length": 1185
    },
    {
        "Name": "ctgAPLB01051584",
        "Length": 1155
    },
    {
        "Name": "ctgAPLB01051585",
        "Length": 1167
    },
    {
        "Name": "ctgAPLB01051586",
        "Length": 1160
    },
    {
        "Name": "ctgAPLB01051587",
        "Length": 1199
    },
    {
        "Name": "ctgAPLB01051588",
        "Length": 1156
    },
    {
        "Name": "ctgAPLB01051589",
        "Length": 1146
    },
    {
        "Name": "ctgAPLB01051590",
        "Length": 1183
    },
    {
        "Name": "ctgAPLB01051591",
        "Length": 1197
    },
    {
        "Name": "ctgAPLB01051592",
        "Length": 1206
    },
    {
        "Name": "ctgAPLB01051593",
        "Length": 1096
    },
    {
        "Name": "ctgAPLB01051594",
        "Length": 1220
    },
    {
        "Name": "ctgAPLB01051595",
        "Length": 1200
    },
    {
        "Name": "ctgAPLB01051596",
        "Length": 1181
    },
    {
        "Name": "ctgAPLB01051597",
        "Length": 1204
    },
    {
        "Name": "ctgAPLB01051598",
        "Length": 1189
    },
    {
        "Name": "ctgAPLB01051599",
        "Length": 1232
    },
    {
        "Name": "ctgAPLB01051600",
        "Length": 681
    },
    {
        "Name": "ctgAPLB01051602",
        "Length": 1199
    },
    {
        "Name": "ctgAPLB01051604",
        "Length": 1182
    },
    {
        "Name": "ctgAPLB01051605",
        "Length": 1052
    },
    {
        "Name": "ctgAPLB01051606",
        "Length": 1213
    },
    {
        "Name": "ctgAPLB01051607",
        "Length": 1122
    },
    {
        "Name": "ctgAPLB01051608",
        "Length": 1230
    },
    {
        "Name": "ctgAPLB01051609",
        "Length": 1221
    },
    {
        "Name": "ctgAPLB01051610",
        "Length": 1246
    },
    {
        "Name": "ctgAPLB01051611",
        "Length": 1242
    },
    {
        "Name": "ctgAPLB01051612",
        "Length": 1233
    },
    {
        "Name": "ctgAPLB01051613",
        "Length": 1232
    },
    {
        "Name": "ctgAPLB01051614",
        "Length": 1236
    },
    {
        "Name": "ctgAPLB01051615",
        "Length": 1222
    },
    {
        "Name": "ctgAPLB01051616",
        "Length": 1208
    },
    {
        "Name": "ctgAPLB01051617",
        "Length": 1242
    },
    {
        "Name": "ctgAPLB01051618",
        "Length": 1239
    },
    {
        "Name": "ctgAPLB01051619",
        "Length": 1232
    },
    {
        "Name": "ctgAPLB01051620",
        "Length": 1253
    },
    {
        "Name": "ctgAPLB01051621",
        "Length": 1262
    },
    {
        "Name": "ctgAPLB01051622",
        "Length": 1256
    },
    {
        "Name": "ctgAPLB01051623",
        "Length": 1211
    },
    {
        "Name": "ctgAPLB01051624",
        "Length": 1273
    },
    {
        "Name": "ctgAPLB01051625",
        "Length": 1259
    },
    {
        "Name": "ctgAPLB01051626",
        "Length": 1245
    },
    {
        "Name": "ctgAPLB01051627",
        "Length": 1235
    },
    {
        "Name": "ctgAPLB01051628",
        "Length": 1121
    },
    {
        "Name": "ctgAPLB01051630",
        "Length": 1296
    },
    {
        "Name": "ctgAPLB01051631",
        "Length": 1273
    },
    {
        "Name": "ctgAPLB01051632",
        "Length": 1248
    },
    {
        "Name": "ctgAPLB01051633",
        "Length": 1286
    },
    {
        "Name": "ctgAPLB01051634",
        "Length": 1225
    },
    {
        "Name": "ctgAPLB01051635",
        "Length": 1266
    },
    {
        "Name": "ctgAPLB01051636",
        "Length": 1269
    },
    {
        "Name": "ctgAPLB01051637",
        "Length": 1173
    },
    {
        "Name": "ctgAPLB01051638",
        "Length": 1276
    },
    {
        "Name": "ctgAPLB01051639",
        "Length": 1279
    },
    {
        "Name": "ctgAPLB01051640",
        "Length": 1275
    },
    {
        "Name": "ctgAPLB01051641",
        "Length": 1285
    },
    {
        "Name": "ctgAPLB01051642",
        "Length": 1316
    },
    {
        "Name": "ctgAPLB01051643",
        "Length": 1293
    },
    {
        "Name": "ctgAPLB01051644",
        "Length": 1296
    },
    {
        "Name": "ctgAPLB01051645",
        "Length": 1290
    },
    {
        "Name": "ctgAPLB01051646",
        "Length": 1285
    },
    {
        "Name": "ctgAPLB01051648",
        "Length": 1342
    },
    {
        "Name": "ctgAPLB01051649",
        "Length": 1179
    },
    {
        "Name": "ctgAPLB01051650",
        "Length": 1298
    },
    {
        "Name": "ctgAPLB01051651",
        "Length": 1286
    },
    {
        "Name": "ctgAPLB01051652",
        "Length": 1275
    },
    {
        "Name": "ctgAPLB01051653",
        "Length": 1305
    },
    {
        "Name": "ctgAPLB01051654",
        "Length": 1318
    },
    {
        "Name": "ctgAPLB01051655",
        "Length": 1168
    },
    {
        "Name": "ctgAPLB01051656",
        "Length": 1330
    },
    {
        "Name": "ctgAPLB01051657",
        "Length": 1298
    },
    {
        "Name": "ctgAPLB01051658",
        "Length": 1333
    },
    {
        "Name": "ctgAPLB01051659",
        "Length": 1321
    },
    {
        "Name": "ctgAPLB01051661",
        "Length": 1322
    },
    {
        "Name": "ctgAPLB01051662",
        "Length": 1334
    },
    {
        "Name": "ctgAPLB01051663",
        "Length": 1339
    },
    {
        "Name": "ctgAPLB01051664",
        "Length": 1332
    },
    {
        "Name": "ctgAPLB01051666",
        "Length": 1359
    },
    {
        "Name": "ctgAPLB01051667",
        "Length": 1354
    },
    {
        "Name": "ctgAPLB01051668",
        "Length": 1265
    },
    {
        "Name": "ctgAPLB01051669",
        "Length": 1361
    },
    {
        "Name": "ctgAPLB01051670",
        "Length": 935
    },
    {
        "Name": "ctgAPLB01051671",
        "Length": 1361
    },
    {
        "Name": "ctgAPLB01051672",
        "Length": 1384
    },
    {
        "Name": "ctgAPLB01051674",
        "Length": 1351
    },
    {
        "Name": "ctgAPLB01051675",
        "Length": 1340
    },
    {
        "Name": "ctgAPLB01051676",
        "Length": 1371
    },
    {
        "Name": "ctgAPLB01051677",
        "Length": 1244
    },
    {
        "Name": "ctgAPLB01051678",
        "Length": 1387
    },
    {
        "Name": "ctgAPLB01051679",
        "Length": 1370
    },
    {
        "Name": "ctgAPLB01051680",
        "Length": 1360
    },
    {
        "Name": "ctgAPLB01051681",
        "Length": 1384
    },
    {
        "Name": "ctgAPLB01051682",
        "Length": 1392
    },
    {
        "Name": "ctgAPLB01051683",
        "Length": 1366
    },
    {
        "Name": "ctgAPLB01051684",
        "Length": 1369
    },
    {
        "Name": "ctgAPLB01051685",
        "Length": 1363
    },
    {
        "Name": "ctgAPLB01051686",
        "Length": 1391
    },
    {
        "Name": "ctgAPLB01051687",
        "Length": 1190
    },
    {
        "Name": "ctgAPLB01051688",
        "Length": 1205
    },
    {
        "Name": "ctgAPLB01051689",
        "Length": 1359
    },
    {
        "Name": "ctgAPLB01051690",
        "Length": 1406
    },
    {
        "Name": "ctgAPLB01051691",
        "Length": 1404
    },
    {
        "Name": "ctgAPLB01051692",
        "Length": 1386
    },
    {
        "Name": "ctgAPLB01051693",
        "Length": 1383
    },
    {
        "Name": "ctgAPLB01051694",
        "Length": 1407
    },
    {
        "Name": "ctgAPLB01051695",
        "Length": 1428
    },
    {
        "Name": "ctgAPLB01051696",
        "Length": 1404
    },
    {
        "Name": "ctgAPLB01051697",
        "Length": 1398
    },
    {
        "Name": "ctgAPLB01051698",
        "Length": 1395
    },
    {
        "Name": "ctgAPLB01051699",
        "Length": 1403
    },
    {
        "Name": "ctgAPLB01051700",
        "Length": 1367
    },
    {
        "Name": "ctgAPLB01051701",
        "Length": 1406
    },
    {
        "Name": "ctgAPLB01051702",
        "Length": 1436
    },
    {
        "Name": "ctgAPLB01051703",
        "Length": 1413
    },
    {
        "Name": "ctgAPLB01051704",
        "Length": 1409
    },
    {
        "Name": "ctgAPLB01051705",
        "Length": 1440
    },
    {
        "Name": "ctgAPLB01051706",
        "Length": 1448
    },
    {
        "Name": "ctgAPLB01051707",
        "Length": 1465
    },
    {
        "Name": "ctgAPLB01051708",
        "Length": 1418
    },
    {
        "Name": "ctgAPLB01051709",
        "Length": 1417
    },
    {
        "Name": "ctgAPLB01051710",
        "Length": 1387
    },
    {
        "Name": "ctgAPLB01051712",
        "Length": 1435
    },
    {
        "Name": "ctgAPLB01051713",
        "Length": 1437
    },
    {
        "Name": "ctgAPLB01051714",
        "Length": 1485
    },
    {
        "Name": "ctgAPLB01051715",
        "Length": 1382
    },
    {
        "Name": "ctgAPLB01051716",
        "Length": 1417
    },
    {
        "Name": "ctgAPLB01051717",
        "Length": 1357
    },
    {
        "Name": "ctgAPLB01051718",
        "Length": 1485
    },
    {
        "Name": "ctgAPLB01051719",
        "Length": 1445
    },
    {
        "Name": "ctgAPLB01051720",
        "Length": 1450
    },
    {
        "Name": "ctgAPLB01051721",
        "Length": 1480
    },
    {
        "Name": "ctgAPLB01051722",
        "Length": 1462
    },
    {
        "Name": "ctgAPLB01051723",
        "Length": 1403
    },
    {
        "Name": "ctgAPLB01051724",
        "Length": 1476
    },
    {
        "Name": "ctgAPLB01051725",
        "Length": 1504
    },
    {
        "Name": "ctgAPLB01051726",
        "Length": 1495
    },
    {
        "Name": "ctgAPLB01051727",
        "Length": 1494
    },
    {
        "Name": "ctgAPLB01051728",
        "Length": 1453
    },
    {
        "Name": "ctgAPLB01051729",
        "Length": 1508
    },
    {
        "Name": "ctgAPLB01051730",
        "Length": 1302
    },
    {
        "Name": "ctgAPLB01051731",
        "Length": 1509
    },
    {
        "Name": "ctgAPLB01051732",
        "Length": 1501
    },
    {
        "Name": "ctgAPLB01051733",
        "Length": 1457
    },
    {
        "Name": "ctgAPLB01051734",
        "Length": 1506
    },
    {
        "Name": "ctgAPLB01051735",
        "Length": 1508
    },
    {
        "Name": "ctgAPLB01051736",
        "Length": 1514
    },
    {
        "Name": "ctgAPLB01051737",
        "Length": 1479
    },
    {
        "Name": "ctgAPLB01051738",
        "Length": 1526
    },
    {
        "Name": "ctgAPLB01051739",
        "Length": 1514
    },
    {
        "Name": "ctgAPLB01051740",
        "Length": 1552
    },
    {
        "Name": "ctgAPLB01051741",
        "Length": 1509
    },
    {
        "Name": "ctgAPLB01051742",
        "Length": 1373
    },
    {
        "Name": "ctgAPLB01051743",
        "Length": 1436
    },
    {
        "Name": "ctgAPLB01051744",
        "Length": 1516
    },
    {
        "Name": "ctgAPLB01051745",
        "Length": 1536
    },
    {
        "Name": "ctgAPLB01051746",
        "Length": 1515
    },
    {
        "Name": "ctgAPLB01051747",
        "Length": 1508
    },
    {
        "Name": "ctgAPLB01051748",
        "Length": 1511
    },
    {
        "Name": "ctgAPLB01051749",
        "Length": 1542
    },
    {
        "Name": "ctgAPLB01051750",
        "Length": 1545
    },
    {
        "Name": "ctgAPLB01051751",
        "Length": 1553
    },
    {
        "Name": "ctgAPLB01051752",
        "Length": 1553
    },
    {
        "Name": "ctgAPLB01051753",
        "Length": 1510
    },
    {
        "Name": "ctgAPLB01051754",
        "Length": 1560
    },
    {
        "Name": "ctgAPLB01051756",
        "Length": 1509
    },
    {
        "Name": "ctgAPLB01051757",
        "Length": 1516
    },
    {
        "Name": "ctgAPLB01051758",
        "Length": 1196
    },
    {
        "Name": "ctgAPLB01051759",
        "Length": 1571
    },
    {
        "Name": "ctgAPLB01051760",
        "Length": 1567
    },
    {
        "Name": "ctgAPLB01051761",
        "Length": 1581
    },
    {
        "Name": "ctgAPLB01051762",
        "Length": 1393
    },
    {
        "Name": "ctgAPLB01051763",
        "Length": 1558
    },
    {
        "Name": "ctgAPLB01051764",
        "Length": 1576
    },
    {
        "Name": "ctgAPLB01051765",
        "Length": 1471
    },
    {
        "Name": "ctgAPLB01051766",
        "Length": 1578
    },
    {
        "Name": "ctgAPLB01051767",
        "Length": 1580
    },
    {
        "Name": "ctgAPLB01051768",
        "Length": 1595
    },
    {
        "Name": "ctgAPLB01051769",
        "Length": 1541
    },
    {
        "Name": "ctgAPLB01051770",
        "Length": 1560
    },
    {
        "Name": "ctgAPLB01051771",
        "Length": 1572
    },
    {
        "Name": "ctgAPLB01051772",
        "Length": 1597
    },
    {
        "Name": "ctgAPLB01051773",
        "Length": 1593
    },
    {
        "Name": "ctgAPLB01051774",
        "Length": 1631
    },
    {
        "Name": "ctgAPLB01051775",
        "Length": 1635
    },
    {
        "Name": "ctgAPLB01051776",
        "Length": 1598
    },
    {
        "Name": "ctgAPLB01051777",
        "Length": 1594
    },
    {
        "Name": "ctgAPLB01051778",
        "Length": 1458
    },
    {
        "Name": "ctgAPLB01051779",
        "Length": 1601
    },
    {
        "Name": "ctgAPLB01051780",
        "Length": 1261
    },
    {
        "Name": "ctgAPLB01051781",
        "Length": 1593
    },
    {
        "Name": "ctgAPLB01051782",
        "Length": 1646
    },
    {
        "Name": "ctgAPLB01051783",
        "Length": 1646
    },
    {
        "Name": "ctgAPLB01051784",
        "Length": 1658
    },
    {
        "Name": "ctgAPLB01051785",
        "Length": 1599
    },
    {
        "Name": "ctgAPLB01051786",
        "Length": 1645
    },
    {
        "Name": "ctgAPLB01051787",
        "Length": 1668
    },
    {
        "Name": "ctgAPLB01051788",
        "Length": 1668
    },
    {
        "Name": "ctgAPLB01051789",
        "Length": 1683
    },
    {
        "Name": "ctgAPLB01051790",
        "Length": 1655
    },
    {
        "Name": "ctgAPLB01051791",
        "Length": 1665
    },
    {
        "Name": "ctgAPLB01051792",
        "Length": 1641
    },
    {
        "Name": "ctgAPLB01051793",
        "Length": 1647
    },
    {
        "Name": "ctgAPLB01051794",
        "Length": 1564
    },
    {
        "Name": "ctgAPLB01051795",
        "Length": 1526
    },
    {
        "Name": "ctgAPLB01051796",
        "Length": 1656
    },
    {
        "Name": "ctgAPLB01051797",
        "Length": 1665
    },
    {
        "Name": "ctgAPLB01051798",
        "Length": 1657
    },
    {
        "Name": "ctgAPLB01051799",
        "Length": 1684
    },
    {
        "Name": "ctgAPLB01051800",
        "Length": 1536
    },
    {
        "Name": "ctgAPLB01051801",
        "Length": 1685
    },
    {
        "Name": "ctgAPLB01051802",
        "Length": 1604
    },
    {
        "Name": "ctgAPLB01051803",
        "Length": 1708
    },
    {
        "Name": "ctgAPLB01051804",
        "Length": 1724
    },
    {
        "Name": "ctgAPLB01051805",
        "Length": 1498
    },
    {
        "Name": "ctgAPLB01051807",
        "Length": 1742
    },
    {
        "Name": "ctgAPLB01051808",
        "Length": 1696
    },
    {
        "Name": "ctgAPLB01051809",
        "Length": 1634
    },
    {
        "Name": "ctgAPLB01051810",
        "Length": 1678
    },
    {
        "Name": "ctgAPLB01051812",
        "Length": 1737
    },
    {
        "Name": "ctgAPLB01051813",
        "Length": 1755
    },
    {
        "Name": "ctgAPLB01051814",
        "Length": 1726
    },
    {
        "Name": "ctgAPLB01051815",
        "Length": 1709
    },
    {
        "Name": "ctgAPLB01051816",
        "Length": 1758
    },
    {
        "Name": "ctgAPLB01051817",
        "Length": 1700
    },
    {
        "Name": "ctgAPLB01051818",
        "Length": 1677
    },
    {
        "Name": "ctgAPLB01051819",
        "Length": 1786
    },
    {
        "Name": "ctgAPLB01051820",
        "Length": 1784
    },
    {
        "Name": "ctgAPLB01051821",
        "Length": 1744
    },
    {
        "Name": "ctgAPLB01051822",
        "Length": 1188
    },
    {
        "Name": "ctgAPLB01051823",
        "Length": 1794
    },
    {
        "Name": "ctgAPLB01051824",
        "Length": 1712
    },
    {
        "Name": "ctgAPLB01051825",
        "Length": 1779
    },
    {
        "Name": "ctgAPLB01051826",
        "Length": 1799
    },
    {
        "Name": "ctgAPLB01051827",
        "Length": 1539
    },
    {
        "Name": "ctgAPLB01051828",
        "Length": 1795
    },
    {
        "Name": "ctgAPLB01051829",
        "Length": 1768
    },
    {
        "Name": "ctgAPLB01051830",
        "Length": 1628
    },
    {
        "Name": "ctgAPLB01051831",
        "Length": 1752
    },
    {
        "Name": "ctgAPLB01051832",
        "Length": 1791
    },
    {
        "Name": "ctgAPLB01051833",
        "Length": 1819
    },
    {
        "Name": "ctgAPLB01051834",
        "Length": 1782
    },
    {
        "Name": "ctgAPLB01051835",
        "Length": 1773
    },
    {
        "Name": "ctgAPLB01051836",
        "Length": 1808
    },
    {
        "Name": "ctgAPLB01051837",
        "Length": 1854
    },
    {
        "Name": "ctgAPLB01051838",
        "Length": 1891
    },
    {
        "Name": "ctgAPLB01051839",
        "Length": 1800
    },
    {
        "Name": "ctgAPLB01051840",
        "Length": 1500
    },
    {
        "Name": "ctgAPLB01051841",
        "Length": 1839
    },
    {
        "Name": "ctgAPLB01051842",
        "Length": 1768
    },
    {
        "Name": "ctgAPLB01051843",
        "Length": 1848
    },
    {
        "Name": "ctgAPLB01051844",
        "Length": 1952
    },
    {
        "Name": "ctgAPLB01051845",
        "Length": 1895
    },
    {
        "Name": "ctgAPLB01051847",
        "Length": 1933
    },
    {
        "Name": "ctgAPLB01051848",
        "Length": 1896
    },
    {
        "Name": "ctgAPLB01051849",
        "Length": 1906
    },
    {
        "Name": "ctgAPLB01051850",
        "Length": 1913
    },
    {
        "Name": "ctgAPLB01051851",
        "Length": 1990
    },
    {
        "Name": "ctgAPLB01051852",
        "Length": 1916
    },
    {
        "Name": "ctgAPLB01051853",
        "Length": 1907
    },
    {
        "Name": "ctgAPLB01051854",
        "Length": 1924
    },
    {
        "Name": "ctgAPLB01051855",
        "Length": 1903
    },
    {
        "Name": "ctgAPLB01051857",
        "Length": 1992
    },
    {
        "Name": "ctgAPLB01051858",
        "Length": 1902
    },
    {
        "Name": "ctgAPLB01051859",
        "Length": 2039
    },
    {
        "Name": "ctgAPLB01051860",
        "Length": 1585
    },
    {
        "Name": "ctgAPLB01051861",
        "Length": 1966
    },
    {
        "Name": "ctgAPLB01051862",
        "Length": 2042
    },
    {
        "Name": "ctgAPLB01051863",
        "Length": 1994
    },
    {
        "Name": "ctgAPLB01051864",
        "Length": 1811
    },
    {
        "Name": "ctgAPLB01051865",
        "Length": 2034
    },
    {
        "Name": "ctgAPLB01051866",
        "Length": 2039
    },
    {
        "Name": "ctgAPLB01051867",
        "Length": 2072
    },
    {
        "Name": "ctgAPLB01051868",
        "Length": 2000
    },
    {
        "Name": "ctgAPLB01051869",
        "Length": 2082
    },
    {
        "Name": "ctgAPLB01051870",
        "Length": 2054
    },
    {
        "Name": "ctgAPLB01051871",
        "Length": 2048
    },
    {
        "Name": "ctgAPLB01051873",
        "Length": 1976
    },
    {
        "Name": "ctgAPLB01051874",
        "Length": 2079
    },
    {
        "Name": "ctgAPLB01051875",
        "Length": 2092
    },
    {
        "Name": "ctgAPLB01051876",
        "Length": 2014
    },
    {
        "Name": "ctgAPLB01051877",
        "Length": 2057
    },
    {
        "Name": "ctgAPLB01051878",
        "Length": 2095
    },
    {
        "Name": "ctgAPLB01051879",
        "Length": 2144
    },
    {
        "Name": "ctgAPLB01051880",
        "Length": 1796
    },
    {
        "Name": "ctgAPLB01051881",
        "Length": 1509
    },
    {
        "Name": "ctgAPLB01051882",
        "Length": 1618
    },
    {
        "Name": "ctgAPLB01051883",
        "Length": 2133
    },
    {
        "Name": "ctgAPLB01051884",
        "Length": 2081
    },
    {
        "Name": "ctgAPLB01051885",
        "Length": 2182
    },
    {
        "Name": "ctgAPLB01051886",
        "Length": 2148
    },
    {
        "Name": "ctgAPLB01051887",
        "Length": 2041
    },
    {
        "Name": "ctgAPLB01051888",
        "Length": 2099
    },
    {
        "Name": "ctgAPLB01051889",
        "Length": 2150
    },
    {
        "Name": "ctgAPLB01051890",
        "Length": 2116
    },
    {
        "Name": "ctgAPLB01051891",
        "Length": 2193
    },
    {
        "Name": "ctgAPLB01051892",
        "Length": 2136
    },
    {
        "Name": "ctgAPLB01051893",
        "Length": 1847
    },
    {
        "Name": "ctgAPLB01051894",
        "Length": 2141
    },
    {
        "Name": "ctgAPLB01051895",
        "Length": 2146
    },
    {
        "Name": "ctgAPLB01051896",
        "Length": 2195
    },
    {
        "Name": "ctgAPLB01051898",
        "Length": 2280
    },
    {
        "Name": "ctgAPLB01051899",
        "Length": 2287
    },
    {
        "Name": "ctgAPLB01051900",
        "Length": 1603
    },
    {
        "Name": "ctgAPLB01051901",
        "Length": 2292
    },
    {
        "Name": "ctgAPLB01051902",
        "Length": 2289
    },
    {
        "Name": "ctgAPLB01051903",
        "Length": 1904
    },
    {
        "Name": "ctgAPLB01051904",
        "Length": 2221
    },
    {
        "Name": "ctgAPLB01051905",
        "Length": 1963
    },
    {
        "Name": "ctgAPLB01051906",
        "Length": 2299
    },
    {
        "Name": "ctgAPLB01051907",
        "Length": 2030
    },
    {
        "Name": "ctgAPLB01051908",
        "Length": 2286
    },
    {
        "Name": "ctgAPLB01051909",
        "Length": 2263
    },
    {
        "Name": "ctgAPLB01051910",
        "Length": 2211
    },
    {
        "Name": "ctgAPLB01051911",
        "Length": 2321
    },
    {
        "Name": "ctgAPLB01051912",
        "Length": 2288
    },
    {
        "Name": "ctgAPLB01051913",
        "Length": 2208
    },
    {
        "Name": "ctgAPLB01051914",
        "Length": 2318
    },
    {
        "Name": "ctgAPLB01051915",
        "Length": 2315
    },
    {
        "Name": "ctgAPLB01051916",
        "Length": 1400
    },
    {
        "Name": "ctgAPLB01051917",
        "Length": 2193
    },
    {
        "Name": "ctgAPLB01051918",
        "Length": 2241
    },
    {
        "Name": "ctgAPLB01051919",
        "Length": 2381
    },
    {
        "Name": "ctgAPLB01051920",
        "Length": 2401
    },
    {
        "Name": "ctgAPLB01051921",
        "Length": 2382
    },
    {
        "Name": "ctgAPLB01051922",
        "Length": 2348
    },
    {
        "Name": "ctgAPLB01051923",
        "Length": 2348
    },
    {
        "Name": "ctgAPLB01051924",
        "Length": 2417
    },
    {
        "Name": "ctgAPLB01051925",
        "Length": 1965
    },
    {
        "Name": "ctgAPLB01051926",
        "Length": 2440
    },
    {
        "Name": "ctgAPLB01051927",
        "Length": 1785
    },
    {
        "Name": "ctgAPLB01051928",
        "Length": 2518
    },
    {
        "Name": "ctgAPLB01051929",
        "Length": 2496
    },
    {
        "Name": "ctgAPLB01051930",
        "Length": 2465
    },
    {
        "Name": "ctgAPLB01051931",
        "Length": 2403
    },
    {
        "Name": "ctgAPLB01051932",
        "Length": 2575
    },
    {
        "Name": "ctgAPLB01051933",
        "Length": 2562
    },
    {
        "Name": "ctgAPLB01051934",
        "Length": 2648
    },
    {
        "Name": "ctgAPLB01051935",
        "Length": 2414
    },
    {
        "Name": "ctgAPLB01051936",
        "Length": 2479
    },
    {
        "Name": "ctgAPLB01051937",
        "Length": 2080
    },
    {
        "Name": "ctgAPLB01051938",
        "Length": 2601
    },
    {
        "Name": "ctgAPLB01051939",
        "Length": 1504
    },
    {
        "Name": "ctgAPLB01051940",
        "Length": 2515
    },
    {
        "Name": "ctgAPLB01051941",
        "Length": 2459
    },
    {
        "Name": "ctgAPLB01051942",
        "Length": 1397
    },
    {
        "Name": "ctgAPLB01051943",
        "Length": 2667
    },
    {
        "Name": "ctgAPLB01051944",
        "Length": 2360
    },
    {
        "Name": "ctgAPLB01051945",
        "Length": 2776
    },
    {
        "Name": "ctgAPLB01051946",
        "Length": 2608
    },
    {
        "Name": "ctgAPLB01051947",
        "Length": 2201
    },
    {
        "Name": "ctgAPLB01051948",
        "Length": 2609
    },
    {
        "Name": "ctgAPLB01051949",
        "Length": 2712
    },
    {
        "Name": "ctgAPLB01051950",
        "Length": 2775
    },
    {
        "Name": "ctgAPLB01051951",
        "Length": 2816
    },
    {
        "Name": "ctgAPLB01051952",
        "Length": 2801
    },
    {
        "Name": "ctgAPLB01051953",
        "Length": 2386
    },
    {
        "Name": "ctgAPLB01051954",
        "Length": 2790
    },
    {
        "Name": "ctgAPLB01051955",
        "Length": 2231
    },
    {
        "Name": "ctgAPLB01051956",
        "Length": 2991
    },
    {
        "Name": "ctgAPLB01051957",
        "Length": 2993
    },
    {
        "Name": "ctgAPLB01051958",
        "Length": 3029
    },
    {
        "Name": "ctgAPLB01051959",
        "Length": 2747
    },
    {
        "Name": "ctgAPLB01051960",
        "Length": 2734
    },
    {
        "Name": "ctgAPLB01051961",
        "Length": 2833
    },
    {
        "Name": "ctgAPLB01051963",
        "Length": 2880
    },
    {
        "Name": "ctgAPLB01051964",
        "Length": 1033
    },
    {
        "Name": "ctgAPLB01051965",
        "Length": 3001
    },
    {
        "Name": "ctgAPLB01051967",
        "Length": 3037
    },
    {
        "Name": "ctgAPLB01051968",
        "Length": 3092
    },
    {
        "Name": "ctgAPLB01051969",
        "Length": 2948
    },
    {
        "Name": "ctgAPLB01051970",
        "Length": 2669
    },
    {
        "Name": "ctgAPLB01051971",
        "Length": 2955
    },
    {
        "Name": "ctgAPLB01051972",
        "Length": 1804
    },
    {
        "Name": "ctgAPLB01051973",
        "Length": 3061
    },
    {
        "Name": "ctgAPLB01051974",
        "Length": 3141
    },
    {
        "Name": "ctgAPLB01051975",
        "Length": 3225
    },
    {
        "Name": "ctgAPLB01051976",
        "Length": 2908
    },
    {
        "Name": "ctgAPLB01051977",
        "Length": 3270
    },
    {
        "Name": "ctgAPLB01051978",
        "Length": 3204
    },
    {
        "Name": "ctgAPLB01051979",
        "Length": 2048
    },
    {
        "Name": "ctgAPLB01051980",
        "Length": 2429
    },
    {
        "Name": "ctgAPLB01051981",
        "Length": 3166
    },
    {
        "Name": "ctgAPLB01051982",
        "Length": 3185
    },
    {
        "Name": "ctgAPLB01051983",
        "Length": 3274
    },
    {
        "Name": "ctgAPLB01051984",
        "Length": 3262
    },
    {
        "Name": "ctgAPLB01051985",
        "Length": 3263
    },
    {
        "Name": "ctgAPLB01051986",
        "Length": 3319
    },
    {
        "Name": "ctgAPLB01051987",
        "Length": 3441
    },
    {
        "Name": "ctgAPLB01051988",
        "Length": 3343
    },
    {
        "Name": "ctgAPLB01051989",
        "Length": 3479
    },
    {
        "Name": "ctgAPLB01051990",
        "Length": 3585
    },
    {
        "Name": "ctgAPLB01051991",
        "Length": 2984
    },
    {
        "Name": "ctgAPLB01051992",
        "Length": 3532
    },
    {
        "Name": "ctgAPLB01051993",
        "Length": 3470
    },
    {
        "Name": "ctgAPLB01051994",
        "Length": 3270
    },
    {
        "Name": "ctgAPLB01051995",
        "Length": 2700
    },
    {
        "Name": "ctgAPLB01051996",
        "Length": 2678
    },
    {
        "Name": "ctgAPLB01051999",
        "Length": 3811
    },
    {
        "Name": "ctgAPLB01052000",
        "Length": 2619
    },
    {
        "Name": "ctgAPLB01052001",
        "Length": 3981
    },
    {
        "Name": "ctgAPLB01052002",
        "Length": 3708
    },
    {
        "Name": "ctgAPLB01052003",
        "Length": 3784
    },
    {
        "Name": "ctgAPLB01052004",
        "Length": 3646
    },
    {
        "Name": "ctgAPLB01052005",
        "Length": 3359
    },
    {
        "Name": "ctgAPLB01052006",
        "Length": 3291
    },
    {
        "Name": "ctgAPLB01052007",
        "Length": 4300
    },
    {
        "Name": "ctgAPLB01052008",
        "Length": 4241
    },
    {
        "Name": "ctgAPLB01052009",
        "Length": 4080
    },
    {
        "Name": "ctgAPLB01052010",
        "Length": 3960
    },
    {
        "Name": "ctgAPLB01052011",
        "Length": 3639
    },
    {
        "Name": "ctgAPLB01052012",
        "Length": 3258
    },
    {
        "Name": "ctgAPLB01052014",
        "Length": 4338
    },
    {
        "Name": "ctgAPLB01052015",
        "Length": 3441
    },
    {
        "Name": "ctgAPLB01052016",
        "Length": 4059
    },
    {
        "Name": "ctgAPLB01052017",
        "Length": 4388
    },
    {
        "Name": "ctgAPLB01052018",
        "Length": 2162
    },
    {
        "Name": "ctgAPLB01052019",
        "Length": 4018
    },
    {
        "Name": "ctgAPLB01052020",
        "Length": 4915
    },
    {
        "Name": "ctgAPLB01052021",
        "Length": 4105
    },
    {
        "Name": "ctgAPLB01052022",
        "Length": 1297
    },
    {
        "Name": "ctgAPLB01052023",
        "Length": 4851
    },
    {
        "Name": "ctgAPLB01052024",
        "Length": 4559
    },
    {
        "Name": "ctgAPLB01052025",
        "Length": 4958
    },
    {
        "Name": "ctgAPLB01052026",
        "Length": 4197
    },
    {
        "Name": "ctgAPLB01052027",
        "Length": 4144
    },
    {
        "Name": "ctgAPLB01052028",
        "Length": 2897
    },
    {
        "Name": "ctgAPLB01052029",
        "Length": 2974
    },
    {
        "Name": "ctgAPLB01052030",
        "Length": 3603
    },
    {
        "Name": "ctgAPLB01052031",
        "Length": 3004
    },
    {
        "Name": "ctgAPLB01052032",
        "Length": 4996
    },
    {
        "Name": "ctgAPLB01052033",
        "Length": 1381
    },
    {
        "Name": "ctgAPLB01052034",
        "Length": 1345
    },
    {
        "Name": "ctgAPLB01052036",
        "Length": 6425
    },
    {
        "Name": "ctgAPLB01052038",
        "Length": 6040
    },
    {
        "Name": "ctgAPLB01052039",
        "Length": 6079
    },
    {
        "Name": "ctgAPLB01052040",
        "Length": 5183
    },
    {
        "Name": "ctgAPLB01052041",
        "Length": 6427
    },
    {
        "Name": "ctgAPLB01052043",
        "Length": 3278
    },
    {
        "Name": "ctgAPLB01052044",
        "Length": 2891
    },
    {
        "Name": "ctgAPLB01052045",
        "Length": 5575
    },
    {
        "Name": "ctgAPLB01052046",
        "Length": 5366
    },
    {
        "Name": "ctgAPLB01052047",
        "Length": 5399
    },
    {
        "Name": "ctgAPLB01052048",
        "Length": 6947
    },
    {
        "Name": "ctgAPLB01052049",
        "Length": 2092
    },
    {
        "Name": "ctgAPLB01052050",
        "Length": 7798
    },
    {
        "Name": "ctgAPLB01052051",
        "Length": 3909
    },
    {
        "Name": "ctgAPLB01052052",
        "Length": 6567
    },
    {
        "Name": "ctgAPLB01052053",
        "Length": 4516
    },
    {
        "Name": "ctgAPLB01052055",
        "Length": 7166
    },
    {
        "Name": "ctgAPLB01052056",
        "Length": 6563
    },
    {
        "Name": "ctgAPLB01052057",
        "Length": 9348
    },
    {
        "Name": "ctgAPLB01052059",
        "Length": 2955
    },
    {
        "Name": "ctgAPLB01052061",
        "Length": 5346
    },
    {
        "Name": "ctgAPLB01052062",
        "Length": 5163
    },
    {
        "Name": "ctgAPLB01052063",
        "Length": 11209
    },
    {
        "Name": "ctgAPLB01052065",
        "Length": 5743
    },
    {
        "Name": "ctgAPLB01052066",
        "Length": 5230
    },
    {
        "Name": "ctgAPLB01052067",
        "Length": 8065
    },
    {
        "Name": "ctgAPLB01052068",
        "Length": 4470
    },
    {
        "Name": "ctgAPLB01052069",
        "Length": 2238
    },
    {
        "Name": "ctgAPLB01052070",
        "Length": 4154
    },
    {
        "Name": "ctgAPLB01052071",
        "Length": 5168
    },
    {
        "Name": "ctgAPLB01052072",
        "Length": 8097
    },
    {
        "Name": "ctgAPLB01052073",
        "Length": 5372
    },
    {
        "Name": "ctgAPLB01052074",
        "Length": 5779
    },
    {
        "Name": "ctgAPLB01052075",
        "Length": 2955
    },
    {
        "Name": "ctgAPLB01052076",
        "Length": 258
    },
    {
        "Name": "ctgAPLB01052077",
        "Length": 808
    },
    {
        "Name": "ctgAPLB01052078",
        "Length": 680
    },
    {
        "Name": "ctgAPLB01052080",
        "Length": 909
    },
    {
        "Name": "ctgAPLB01052081",
        "Length": 2104
    },
    {
        "Name": "ctgAPLB01052082",
        "Length": 772
    },
    {
        "Name": "ctgAPLB01052095",
        "Length": 701
    },
    {
        "Name": "ctgAPLB01052104",
        "Length": 645
    },
    {
        "Name": "ctgAPLB01052199",
        "Length": 22821
    }
]
export default TaiZi_3